(function () {
  const section = document.querySelector('.product-customizer-wrapper')?.closest('[id^="shopify-section-"]');
  if (!section) return;

  window.__pcpCustomizerReturnUrl = window.location.pathname + window.location.search;

  const hiddenClassName = 'pcp-hidden';
  let transitionAlertTimeout = null;

  const pcpMessages = (function () {
    const el = section.querySelector('#pcp-messages');
    if (!el) return {};
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return {};
    }
  })();

  function getPcpMessage(key, vars) {
    let msg = pcpMessages[key];
    if (msg == null || String(msg).trim() === '') return '';
    msg = String(msg);
    if (vars) {
      Object.keys(vars).forEach(function (varKey) {
        msg = msg.split('[' + varKey + ']').join(vars[varKey] != null ? String(vars[varKey]) : '');
      });
    }
    return msg;
  }

const REVIEW_BTN_LOADING_HTML =
  '<span class="pcp-btn-loading"><span class="pcp-btn-loading__spinner" aria-hidden="true"></span>Preparing review…</span>';

function showTransitionAlert(message) {
  const el = section.querySelector('#transition-alert');
  const msgEl = el ? el.querySelector('.transition-alert__message') : null;
  const closeBtn = el ? el.querySelector('.transition-alert__close') : null;
  if (!el || !msgEl) return;
  if (transitionAlertTimeout) {
    clearTimeout(transitionAlertTimeout);
    transitionAlertTimeout = null;
  }
  msgEl.textContent = message || '';
  el.setAttribute('aria-hidden', 'false');
  el.classList.add('visible');
  function hide() {
    el.classList.remove('visible');
    el.setAttribute('aria-hidden', 'true');
    if (transitionAlertTimeout) {
      clearTimeout(transitionAlertTimeout);
      transitionAlertTimeout = null;
    }
  }
  transitionAlertTimeout = setTimeout(hide, 10000);
  if (closeBtn) closeBtn.addEventListener('click', hide, { once: true });
}

const steps = Array.from(section.querySelectorAll('.customization-step'));
const stepHeaders = section.querySelectorAll('.step-header');
const optionButtons = section.querySelectorAll('.option-button:not(input)');
const inputFields = section.querySelectorAll('.option-button[type="text"], .option-button[type="number"]');
const stepNextButtons = section.querySelectorAll('.step-next-button');
const reviewButton = section.querySelector('.review-button');
const backButton = section.querySelector('.back-button');
const stepCounter = section.querySelector('.step-counter');
const scrollableSelectors = [
  '.customization-steps',
  '.step-options',
  '.selector-content',
  '.chain-selector .product-grid',
  '.charm-pendant-selector .product-grid',
  '.filter-tabs',
  '.mobile-step-indicators',
  '.review-details-section',
  '.review-content',
].join(', ');

section.addEventListener('touchmove', function (e) {
  const scrollableTarget = e.target.closest(scrollableSelectors);
  if (!scrollableTarget) return;
  if (
    scrollableTarget.scrollHeight > scrollableTarget.clientHeight ||
    scrollableTarget.scrollWidth > scrollableTarget.clientWidth
  ) {
    e.stopPropagation();
  }
}, { passive: true, capture: true });

function setHidden(element, isHidden) {
  if (!element) return;
  element.classList.toggle(hiddenClassName, Boolean(isHidden));
}

function escapeHtmlAttr(value) {
  if (value == null) return '';
  return String(value)
    .replace(/&/g, '&amp;')
    .replace(/"/g, '&quot;')
    .replace(/</g, '&lt;')
    .replace(/\r?\n/g, ' ');
}

function decodeHtmlEntities(value) {
  if (value == null) return '';
  return String(value)
    .replace(/&quot;/g, '"')
    .replace(/&#34;/g, '"')
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>');
}

/** Slugify image alt for a safe class on `.canvas-product-item` (e.g. `canvas-item-alt--gold-heart`). */
function canvasItemClassFromImageAlt(alt) {
  if (alt == null || typeof alt !== 'string') return null;
  const t = alt.trim();
  if (!t) return null;
  let slug = t
    .toLowerCase()
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .replace(/-+/g, '-');
  if (!slug) {
    let h = 0;
    for (let i = 0; i < t.length; i++) {
      h = (Math.imul(31, h) + t.charCodeAt(i)) | 0;
    }
    slug = 'u' + Math.abs(h).toString(36);
  } else if (/^[0-9-]/.test(slug)) {
    slug = 'alt-' + slug;
  }
  return ('canvas-item-alt--' + slug).substring(0, 120);
}

function applyCanvasItemAltClass(canvasItem, alt) {
  const cls = canvasItemClassFromImageAlt(alt);
  if (cls) canvasItem.classList.add(cls);
}

function stripCanvasItemAltClassesFromElement(el) {
  if (!el || !el.classList) return;
  const toRemove = [];
  el.classList.forEach(function (c) {
    if (c.indexOf('canvas-item-alt--') === 0) toRemove.push(c);
  });
  toRemove.forEach(function (c) {
    el.classList.remove(c);
  });
}

/** Same slug as canvas `.canvas-product-item` — applied to `.product-image.personalizer_image` on product cards. */
function syncProductImageCanvasAltClass(productImageWrap, imageAlt) {
  if (!productImageWrap || !productImageWrap.classList) return;
  stripCanvasItemAltClassesFromElement(productImageWrap);
  if (!productImageWrap.classList.contains('personalizer_image')) return;
  const cls = canvasItemClassFromImageAlt(imageAlt);
  if (cls) productImageWrap.classList.add(cls);
}

/** Alt-derived “frame” classes: toolbar is fixed below the frame (see CSS + updateCanvasItemControls). */
function canvasItemUsesBelowFrameControls(el) {
  if (!el || !el.classList) return false;
  return (
    el.classList.contains('canvas-item-alt--max-10') ||
    el.classList.contains('canvas-item-alt--max-20') ||
    el.classList.contains('canvas-item-alt--w-10')
  );
}

function hideElementsForCapture(elements) {
  const state = [];
  elements.forEach((element) => {
    if (!element) return;
    state.push({ element, hadClass: element.classList.contains(hiddenClassName) });
    element.classList.add(hiddenClassName);
  });
  return function restore() {
    state.forEach((item) => {
      if (!item.hadClass) {
        item.element.classList.remove(hiddenClassName);
      }
    });
  };
}

function getEngravingFontModifierClass(fontName) {
  const key = String(fontName || '')
    .trim()
    .toLowerCase()
    .replace(/\s+/g, ' ');
  if (key === 'cursive') return 'pcp-engrave-font--cursive';
  if (key === 'sans serif' || key === 'sansserif') return 'pcp-engrave-font--sans-serif';
  if (key === 'serif') return 'pcp-engrave-font--serif';
  if (key === 'script') return 'pcp-engrave-font--script';
  if (key === 'block') return 'pcp-engrave-font--block';
  return '';
}

const DEFAULT_ENGRAVING_MAX_CHARS = 10;
const zeptoEngravingLimitCache = Object.create(null);
const zeptoEngravingLimitPending = Object.create(null);

function getZeptoShopDomain() {
  return typeof Shopify !== 'undefined' && Shopify.shop ? Shopify.shop : 'leahalexandra.myshopify.com';
}

function parseZeptoEngravingMaxChars(scriptText) {
  if (!scriptText) return null;
  const metaRegex = /cstmfy_meta_\d+":"([^"]+)"/g;
  let match;
  let fallback = null;
  while ((match = metaRegex.exec(scriptText)) !== null) {
    const parts = match[1].split(',');
    const engraveIdx = parts.indexOf('ENGRAVE');
    if (engraveIdx !== -1) {
      const maxIdx = engraveIdx + 9;
      if (maxIdx < parts.length) {
        const n = parseInt(parts[maxIdx], 10);
        if (Number.isFinite(n) && n > 0) return n;
      }
    }
    if (parts.length > 17) {
      const n = parseInt(parts[17], 10);
      if (Number.isFinite(n) && n > 0 && n <= 200) {
        fallback = fallback == null ? n : fallback;
      }
    }
  }
  return fallback;
}

function fetchZeptoConfigScript(productId) {
  const url =
    'https://cdn-zeptoapps.com/product-personalizer/canvas-script.php?shop=' +
    encodeURIComponent(getZeptoShopDomain()) +
    '&prid=' +
    encodeURIComponent(String(productId)) +
    '&kkr=tomato';
  return fetch(url).then(function (res) {
    if (!res.ok) throw new Error('Zepto config fetch failed');
    return res.text();
  });
}

function getZeptoLimitFromScript(scriptText) {
  return parseZeptoEngravingMaxChars(scriptText);
}

function getCardProductTitle(card) {
  if (!card) return '';
  const titleEl = card.querySelector(
    '.product-card-engraving-overlay-title, .product-card-overlay-title, .product-title'
  );
  return titleEl ? String(titleEl.textContent || '').trim() : '';
}

function getRelatedEngravingSearchQueries(productTitle) {
  const title = String(productTitle || '').trim();
  if (!title) return [];
  const queries = [];
  const seen = Object.create(null);
  const add = function (value) {
    const q = String(value || '').trim();
    if (!q || seen[q.toLowerCase()]) return;
    seen[q.toLowerCase()] = true;
    queries.push(q);
  };

  add(title);

  const stripped = title
    .replace(
      /\s+(goldfill|gold vermeil|sterling silver|10k gold|14k gold|silver|gold)$/i,
      ''
    )
    .trim();
  if (stripped !== title) add(stripped);

  const words = title.split(/\s+/);
  if (words.length > 2) add(words.slice(0, -1).join(' '));

  const base = stripped || title;
  if (base.toLowerCase().indexOf('bracelet') === -1) add(base + ' Bracelet');

  return queries;
}

function rankRelatedZeptoProducts(products, productTitle, excludeId) {
  const baseTitle = String(productTitle || '')
    .trim()
    .toLowerCase();
  return products
    .filter(function (product) {
      return product && product.id != null && String(product.id) !== String(excludeId);
    })
    .sort(function (a, b) {
      const aTitle = String(a.title || '').toLowerCase();
      const bTitle = String(b.title || '').toLowerCase();
      const score = function (title) {
        let value = 100;
        if (baseTitle && title === baseTitle) value += 40;
        if (title.indexOf('bracelet') !== -1) value -= 50;
        if (baseTitle && title.indexOf(baseTitle) !== -1) value -= 20;
        if (baseTitle && title.indexOf(baseTitle) === 0) value -= 10;
        return value;
      };
      return score(aTitle) - score(bTitle);
    });
}

function fetchRelatedZeptoEngravingLimit(productTitle, excludeId) {
  const queries = getRelatedEngravingSearchQueries(productTitle);
  if (!queries.length) return Promise.resolve(null);

  let chain = Promise.resolve(null);
  queries.forEach(function (query) {
    chain = chain.then(function (found) {
      if (found != null) return found;
      return fetch(
        '/search/suggest.json?q=' +
          encodeURIComponent(query) +
          '&resources[type]=product&resources[limit]=10'
      )
        .then(function (res) {
          if (!res.ok) throw new Error('Product search failed');
          return res.json();
        })
        .then(function (data) {
          const products =
            data && data.resources && data.resources.results && data.resources.results.products;
          if (!products || !products.length) return null;
          const ranked = rankRelatedZeptoProducts(products, productTitle, excludeId);
          let productChain = Promise.resolve(null);
          ranked.forEach(function (product) {
            productChain = productChain.then(function (limit) {
              if (limit != null) return limit;
              return fetchZeptoConfigScript(product.id)
                .then(getZeptoLimitFromScript)
                .catch(function () {
                  return null;
                });
            });
          });
          return productChain;
        })
        .catch(function () {
          return null;
        });
    });
  });

  return chain;
}

function fetchZeptoEngravingLimit(productId, productTitle) {
  const key = String(productId || '').trim();
  if (!key) return Promise.resolve(null);
  if (zeptoEngravingLimitCache[key] != null) return Promise.resolve(zeptoEngravingLimitCache[key]);
  if (zeptoEngravingLimitPending[key]) return zeptoEngravingLimitPending[key];

  zeptoEngravingLimitPending[key] = fetchZeptoConfigScript(key)
    .then(getZeptoLimitFromScript)
    .then(function (limit) {
      if (limit != null) return limit;
      return fetchRelatedZeptoEngravingLimit(productTitle, key);
    })
    .then(function (limit) {
      delete zeptoEngravingLimitPending[key];
      if (limit != null) {
        zeptoEngravingLimitCache[key] = limit;
        return limit;
      }
      return null;
    })
    .catch(function () {
      delete zeptoEngravingLimitPending[key];
      return fetchRelatedZeptoEngravingLimit(productTitle, key).then(function (limit) {
        if (limit != null) {
          zeptoEngravingLimitCache[key] = limit;
        }
        return limit;
      });
    });

  return zeptoEngravingLimitPending[key];
}

function getEngravingMaxChars(productId, productData) {
  if (productData && productData.engravingMaxChars != null) {
    const fromData = parseInt(productData.engravingMaxChars, 10);
    if (Number.isFinite(fromData) && fromData > 0) return fromData;
  }
  const key = String(productId || '').trim();
  if (key && zeptoEngravingLimitCache[key] != null) return zeptoEngravingLimitCache[key];
  return null;
}

function resolveEngravingMaxChars(productId, productData) {
  const cached = getEngravingMaxChars(productId, productData);
  return cached != null ? cached : DEFAULT_ENGRAVING_MAX_CHARS;
}

function normalizeEngravingText(value, maxChars) {
  const limit =
    maxChars != null && Number.isFinite(parseInt(maxChars, 10)) && parseInt(maxChars, 10) > 0
      ? parseInt(maxChars, 10)
      : DEFAULT_ENGRAVING_MAX_CHARS;
  return String(value == null ? '' : value)
    .trim()
    .slice(0, limit);
}

function formatEngravingMaxLabel(maxChars) {
  const n = parseInt(maxChars, 10);
  if (!Number.isFinite(n) || n <= 0) {
    return '(max ' + DEFAULT_ENGRAVING_MAX_CHARS + ' Letters)';
  }
  return '(max ' + n + ' Letter' + (n === 1 ? '' : 's') + ')';
}

function applyEngravingLimitToUi(scope, maxChars) {
  if (!scope || maxChars == null) return;
  const limit = parseInt(maxChars, 10);
  if (!Number.isFinite(limit) || limit <= 0) return;
  const input = scope.querySelector('.product-card-engraving-text-input, .canvas-engraving-editor__input');
  const label = scope.querySelector('.max_chr_hh');
  if (input) input.maxLength = limit;
  if (label) label.textContent = formatEngravingMaxLabel(limit);
}

function prefetchZeptoEngravingLimits(selector) {
  if (!selector) return;
  selector.querySelectorAll('.product-card[data-product-id]').forEach(function (card) {
    const tags = (card.getAttribute('data-product-tags') || '').toLowerCase();
    if (!tags.includes('engravable')) return;
    const id = card.getAttribute('data-product-id');
    if (!id) return;
    fetchZeptoEngravingLimit(id, getCardProductTitle(card)).then(function (limit) {
      if (limit == null) return;
      const overlay = card.querySelector('.product-card-engraving-overlay');
      if (overlay) applyEngravingLimitToUi(overlay, limit);
    });
  });
}

function generateCharmInstanceId() {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  return 'charm-' + Date.now() + '-' + Math.random().toString(36).slice(2, 11);
}

function setButtonLoading(button, isLoading, loadingHtml) {
  if (!button) return;
  if (isLoading) {
    if (!button.dataset.originalHtml) {
      button.dataset.originalHtml = button.innerHTML;
    }
    button.classList.add('pcp-loading');
    button.disabled = true;
    if (loadingHtml) {
      button.innerHTML = loadingHtml;
    }
  } else {
    button.classList.remove('pcp-loading');
    button.disabled = false;
    if (button.dataset.originalHtml) {
      button.innerHTML = button.dataset.originalHtml;
    }
  }
}

function getCharmSelectors() {
  return section.querySelectorAll('.charm-pendant-selector');
}

function refreshCharmSelectors() {
  const allCharmSelectors = getCharmSelectors();
  allCharmSelectors.forEach((selector) => {
    const updateDisplayFunc = selector._updateCanvasDisplay;
    if (updateDisplayFunc) {
      updateDisplayFunc();
    }
  });
}

function getCardVariantId(card) {
  if (!card) return null;
  const variantSelect = card.querySelector('.product-card-variant-select');
  let variantId = variantSelect ? variantSelect.value : null;
  if (!variantId || variantId === '' || variantId === 'null') {
    const dataVariantId = card.getAttribute('data-variant-id');
    if (dataVariantId && dataVariantId !== '' && /^\d+$/.test(String(dataVariantId).trim())) {
      variantId = String(dataVariantId).trim();
    }
  }
  return variantId;
}

function getCardPrice(card, variantSelect, variantId) {
  if (!card) return '';
  let priceText = '';
  if (variantSelect && variantId) {
    const selectedOption = variantSelect.options[variantSelect.selectedIndex];
    if (selectedOption) {
      priceText = selectedOption.getAttribute('data-price') || '';
    }
  }
  if (!priceText) {
    const priceElement = card.querySelector('.product-price');
    if (priceElement) {
      priceText = priceElement.textContent.trim();
    }
  }
  return priceText;
}

function getCardVariantTitle(variantSelect, variantId) {
  if (!variantSelect) return '';
  const option = getVariantSelectOption(variantSelect, variantId);
  return option ? option.textContent.trim() : '';
}

function getVariantSelectOption(variantSelect, variantId) {
  if (!variantSelect || !variantSelect.options || !variantSelect.options.length) return null;
  if (variantId != null && String(variantId).trim() !== '') {
    const id = String(variantId).trim();
    for (let i = 0; i < variantSelect.options.length; i++) {
      const option = variantSelect.options[i];
      if (String(option.value) === id) return option;
    }
  }
  const selectedIndex = variantSelect.selectedIndex;
  if (selectedIndex >= 0 && variantSelect.options[selectedIndex]) {
    return variantSelect.options[selectedIndex];
  }
  return null;
}

function findVariantIdByTitle(productId, variantTitle) {
  const title = variantTitle != null ? String(variantTitle).trim() : '';
  if (!productId || !title) return '';
  const normalizedTitle = title.toLowerCase();

  const productData = getProductData(productId);
  if (productData && Array.isArray(productData.variants)) {
    const match = productData.variants.find((variant) => {
      return variant && variant.title && String(variant.title).trim().toLowerCase() === normalizedTitle;
    });
    if (match && match.id != null) return String(match.id);
  }

  const productIdStr = String(productId);
  const cards = section.querySelectorAll(`[data-product-id="${productIdStr}"]`);
  for (let i = 0; i < cards.length; i++) {
    const select = cards[i].querySelector('.product-card-variant-select');
    if (!select || !select.options) continue;
    for (let j = 0; j < select.options.length; j++) {
      const option = select.options[j];
      if (option.textContent.trim().toLowerCase() === normalizedTitle && option.value) {
        return String(option.value);
      }
    }
  }
  return '';
}

function resolveProductVariantId(productData) {
  let variantId = productData && productData.variantId != null ? String(productData.variantId).trim() : '';
  const variantTitle =
    productData && productData.variantTitle != null ? String(productData.variantTitle).trim() : '';

  if (!variantTitle || !productData || !productData.productId) {
    return variantId;
  }

  const titleVariantId = findVariantIdByTitle(productData.productId, variantTitle);
  if (!titleVariantId) {
    return variantId;
  }

  if (!variantId) {
    return titleVariantId;
  }

  const currentTitle = getVariantData(productData.productId, variantId)?.title;
  const normalizedCurrent = currentTitle ? String(currentTitle).trim().toLowerCase() : '';
  const normalizedStored = variantTitle.toLowerCase();

  if (normalizedStored && normalizedCurrent !== normalizedStored) {
    return titleVariantId;
  }

  return variantId;
}

function buildChainProduct(card, variantId) {
  if (!card) return null;
  const productId = card.getAttribute('data-product-id');
  const productImage = card.querySelector('.product-image img');
  const productTitle = card.querySelector('.product-title')?.textContent || '';
  if (!productImage) return null;
  let imageSrc = productImage.getAttribute('src') || productImage.src;
  imageSrc = getOriginalImageUrl(imageSrc);
  const variantSelect = card.querySelector('.product-card-variant-select');
  const priceText = getCardPrice(card, variantSelect, variantId);
  let variantTitle = getCardVariantTitle(variantSelect, variantId);
  const variantDataFromJson = productId && variantId ? getVariantData(productId, variantId) : null;
  if (!variantTitle && variantDataFromJson && variantDataFromJson.title) {
    variantTitle = variantDataFromJson.title;
  }
  if (variantDataFromJson && variantDataFromJson.image && String(variantDataFromJson.image).trim() !== '') {
    imageSrc = getOriginalImageUrl(variantDataFromJson.image);
  }
  if (variantSelect && variantId) {
    const selectedOptionForVariant = getVariantSelectOption(variantSelect, variantId);
    if (selectedOptionForVariant) {
      const optionCanvasImage = selectedOptionForVariant.getAttribute('data-canvas-image');
      if (optionCanvasImage && String(optionCanvasImage).trim() !== '') {
        imageSrc = getOriginalImageUrl(optionCanvasImage);
      }
    }
  }
  let hasPersonalizerImage = false;
  let imageAlt = '';
  if (variantSelect) {
    const selectedOption = variantSelect.options[variantSelect.selectedIndex];
    if (selectedOption) {
      hasPersonalizerImage = selectedOption.getAttribute('data-personalizer-image') === 'true';
      imageAlt = selectedOption.getAttribute('data-canvas-image-alt') || selectedOption.getAttribute('data-image-alt') || '';
    }
  } else if (variantDataFromJson) {
    hasPersonalizerImage = !!variantDataFromJson.hasPersonalizerImage;
    if (variantDataFromJson.imageAlt != null && String(variantDataFromJson.imageAlt).trim() !== '') {
      imageAlt = String(variantDataFromJson.imageAlt).trim();
    }
  }
  if (
    !variantSelect &&
    !hasPersonalizerImage &&
    card.getAttribute('data-product-personalizer-image') === 'true'
  ) {
    hasPersonalizerImage = true;
  }
  if (!imageAlt.trim() && productImage) {
    imageAlt = productImage.getAttribute('alt') || '';
  }
  if (!imageAlt.trim() && variantDataFromJson && variantDataFromJson.imageAlt) {
    imageAlt = String(variantDataFromJson.imageAlt);
  }
  const focalPoint = resolveChainFocalPoint(productId, variantId);
  return {
    productId: productId,
    variantId: variantId,
    variantTitle: variantTitle,
    imageSrc: imageSrc,
    hasPersonalizerImage: hasPersonalizerImage,
    imageAlt: imageAlt.trim() || productTitle,
    title: productTitle,
    price: priceText,
    type: 'chain',
    focalPoint: focalPoint,
  };
}

function setChainProduct(chainProduct) {
  window._canvasProducts = window._canvasProducts.filter((p) => p.type !== 'chain');
  if (chainProduct) {
    window._canvasProducts.push(chainProduct);
  }
  refreshCharmSelectors();
}

function clearChainProduct(productId, variantId) {
  window._canvasProducts = window._canvasProducts.filter(
    (p) => !(p.productId === productId && p.variantId === variantId && p.type === 'chain')
  );
  refreshCharmSelectors();
}

function getChainStepIndex() {
  return (
    steps.findIndex((step) => {
      const selector = step.querySelector('.chain-selector');
      return selector !== null;
    }) + 1
  );
}

function getSelectedChainProductId() {
  const chainStepIndex = getChainStepIndex();
  if (chainStepIndex <= 0) return null;
  const selection = selections[chainStepIndex];
  if (!selection || selection === '') return null;
  const parts = String(selection).split('|');
  return parts[0] ? String(parts[0]).trim() : null;
}

function getChainCompatibilityData(chainProductId) {
  const chainStepIndex = getChainStepIndex();
  if (chainStepIndex <= 0) return null;
  const jsonScript = section.querySelector('script[data-chain-products="' + chainStepIndex + '"]');
  if (!jsonScript) return null;
  try {
    const products = JSON.parse(jsonScript.textContent);
    const chain = Array.isArray(products) ? products.find((p) => String(p.id) === String(chainProductId)) : null;
    return chain || null;
  } catch (e) {
    return null;
  }
}

function isCharmCompatibleWithChain(charmCard, chainProductId) {
  if (!charmCard || !chainProductId) return true;
  const charmId = charmCard.getAttribute('data-product-id');
  if (!charmId) return true;
  const chainIdStr = String(chainProductId);
  const charmIdStr = String(charmId);

  let chainBlocksCharm = false;
  const chainData = getChainCompatibilityData(chainProductId);
  if (chainData && chainData.compatibleProductIds && Array.isArray(chainData.compatibleProductIds) && chainData.compatibleProductIds.length > 0) {
    const compatType = (chainData.compatibilityType || '').trim().toLowerCase();
    const isInList = chainData.compatibleProductIds.some((id) => String(id) === charmIdStr);
    if (compatType === 'compatible with') {
      chainBlocksCharm = !isInList;
    } else if (compatType === 'not compatible with') {
      chainBlocksCharm = isInList;
    }
  }

  let charmBlocksChain = false;
  const charmCompatType = (charmCard.getAttribute('data-compatibility-type') || '').trim().toLowerCase();
  const charmCompatIdsRaw = charmCard.getAttribute('data-compatible-products') || '';
  const charmCompatIds = charmCompatIdsRaw ? charmCompatIdsRaw.split(',').map((id) => String(id).trim()).filter(Boolean) : [];
  if (charmCompatType && charmCompatIds.length > 0) {
    const isInList = charmCompatIds.some((id) => id === chainIdStr);
    if (charmCompatType === 'compatible with') {
      charmBlocksChain = !isInList;
    } else if (charmCompatType === 'not compatible with') {
      charmBlocksChain = isInList;
    }
  }

  return !chainBlocksCharm && !charmBlocksChain;
}

function removeIncompatibleCharmsFromChain() {
  const chainProductId = getSelectedChainProductId();
  if (!chainProductId) return;

  const removedTitles = [];
  const charmSelectors = getCharmSelectors();
  charmSelectors.forEach((selector) => {
    const selectedProducts = selector._selectedProducts || [];
    const removeProductFn = selector._removeProduct;
    if (!removeProductFn || !Array.isArray(selectedProducts)) return;

    const indicesToRemove = [];
    selectedProducts.forEach((product, index) => {
      const card = selector.querySelector('[data-product-id="' + product.productId + '"]');
      if (card && !isCharmCompatibleWithChain(card, chainProductId)) {
        indicesToRemove.push({ index, title: product.title || 'Item' });
      }
    });

    indicesToRemove.sort((a, b) => b.index - a.index).forEach(({ index, title }) => {
      removeProductFn(index);
      removedTitles.push(title);
    });
  });

  if (removedTitles.length > 0) {
    const message =
      removedTitles.length === 1
        ? getPcpMessage('chainRemovedSingle', { product: removedTitles[0] })
        : getPcpMessage('chainRemovedMultiple', {
            products: removedTitles.map(function (t) {
              return '"' + t + '"';
            }).join(', '),
          });
    showTransitionAlert(message);
  }
}

function isHideIncompatibleEnabled(selector) {
  return selector && selector.getAttribute('data-hide-incompatible') === 'true';
}

function updateCharmCompatibility() {
  removeIncompatibleCharmsFromChain();

  const chainProductId = getSelectedChainProductId();
  const charmSelectors = getCharmSelectors();
  charmSelectors.forEach((selector) => {
    const hideIncompatible = isHideIncompatibleEnabled(selector);
    const cards = selector.querySelectorAll('.product-card:not(.product-card--sold-out)');
    cards.forEach((card) => {
      if (!chainProductId) {
        card.classList.remove('product-card--incompatible');
        card.classList.remove('product-card--hidden-incompatible');
        card.style.pointerEvents = '';
      } else {
        const compatible = isCharmCompatibleWithChain(card, chainProductId);
        if (compatible) {
          card.classList.remove('product-card--incompatible');
          card.classList.remove('product-card--hidden-incompatible');
          card.style.pointerEvents = '';
        } else if (hideIncompatible) {
          card.classList.remove('product-card--incompatible');
          card.classList.add('product-card--hidden-incompatible');
          card.style.pointerEvents = 'none';
        } else {
          card.classList.remove('product-card--hidden-incompatible');
          card.classList.add('product-card--incompatible');
          card.style.pointerEvents = 'none';
        }
      }
    });
    if (typeof selector._filterProducts === 'function') {
      selector._filterProducts();
    }
  });
}

function updateChainProductVariant(productId, variantId) {
  if (!productId || !variantId) return;
  if (!window._canvasProducts) return;
  const chainItem = window._canvasProducts.find((p) => p.type === 'chain');
  if (!chainItem) return;
  if (String(chainItem.productId) !== String(productId)) return;

  chainItem.variantId = String(variantId);

  const variantData = getVariantData(productId, variantId);
  if (variantData && variantData.price) {
    chainItem.price = variantData.price;
  }
  if (variantData && variantData.title) {
    chainItem.variantTitle = variantData.title;
  }
  if (variantData && variantData.image && String(variantData.image).trim() !== '') {
    chainItem.imageSrc = getOriginalImageUrl(variantData.image);
  }
  if (variantData && variantData.imageAlt != null && String(variantData.imageAlt).trim() !== '') {
    chainItem.imageAlt = String(variantData.imageAlt).trim();
  }
  if (variantData && variantData.hasPersonalizerImage !== undefined) {
    chainItem.hasPersonalizerImage = !!variantData.hasPersonalizerImage;
  }
  chainItem.focalPoint = resolveChainFocalPoint(productId, variantId);

  refreshCharmSelectors();
}

section.addEventListener('click', function (e) {
  const btn = e.target.closest('.product-card-engraveables-btn');
  if (!btn) return;
  e.stopPropagation();
  e.preventDefault();
  const card = btn.closest('.product-card');
  if (card) {
    card.classList.toggle('engraving-overlay-open');
    if (card.classList.contains('engraving-overlay-open')) {
      const productId = card.getAttribute('data-product-id');
      const overlay = card.querySelector('.product-card-engraving-overlay');
      fetchZeptoEngravingLimit(productId, getCardProductTitle(card)).then(function (limit) {
        if (limit != null) applyEngravingLimitToUi(overlay, limit);
      });
    } else {
      card.querySelectorAll('[data-engraving-font-dropdown].is-open').forEach(closeEngravingFontDropdown);
    }
  }
}, true);

section.addEventListener('click', function (e) {
  const closeBtn = e.target.closest('.product-card-engraving-overlay-close');
  if (!closeBtn) return;
  e.stopPropagation();
  e.preventDefault();
  const card = closeBtn.closest('.product-card');
  if (card) {
    card.classList.remove('engraving-overlay-open');
    card.querySelectorAll('[data-engraving-font-dropdown].is-open').forEach(closeEngravingFontDropdown);
  }
}, true);

section.addEventListener('click', function (e) {
  const reviewBtn = e.target.closest('.review-button');
  if (!reviewBtn || reviewBtn.disabled) return;
  e.preventDefault();
  beginReview(reviewBtn);
});

let currentStep = 1;
const totalSteps = steps.length;
const selections = {};

function parseSelectionToken(token) {
  if (!token || typeof token !== 'string') return null;
  const trimmed = token.trim();
  if (!trimmed) return null;
  const hashIndex = trimmed.indexOf('#');
  const base = hashIndex >= 0 ? trimmed.slice(0, hashIndex) : trimmed;
  const parts = base.split('|');
  return {
    productId: parts[0] || null,
    variantId: parts.length > 1 ? parts[1] : null,
  };
}

function cardMatchesSelectionToken(card, token) {
  const parsed = parseSelectionToken(token);
  if (!parsed || !parsed.productId) return false;
  const cardProductId = card.getAttribute('data-product-id');
  if (String(cardProductId) !== String(parsed.productId)) return false;
  if (!parsed.variantId) return true;
  const cardVariantId = getCardVariantId(card);
  return cardVariantId != null && String(cardVariantId) === String(parsed.variantId);
}

function restoreStepSelectionHighlights(stepIndex) {
  const step = steps[stepIndex - 1];
  if (!step) return;

  const selection = selections[stepIndex];
  const stepOptions = step.querySelector('.step-options');

  if (stepOptions) {
    const optionBtns = stepOptions.querySelectorAll('.option-button:not(input)');
    optionBtns.forEach((btn) => {
      const value =
        btn.getAttribute('data-option-value') || btn.getAttribute('data-product-id') || btn.textContent.trim();
      const isSelected = selection != null && selection !== '' && String(selection) === String(value);
      btn.classList.toggle('selected', isSelected);
    });
  }

  const chainSelector = step.querySelector('.chain-selector');
  if (chainSelector) {
    const cards = chainSelector.querySelectorAll('.product-card');
    cards.forEach((card) => card.classList.remove('selected'));
    if (selection) {
      const token = String(selection).split(',')[0];
      cards.forEach((card) => {
        const parsed = parseSelectionToken(token);
        if (!parsed || String(card.getAttribute('data-product-id')) !== String(parsed.productId)) return;
        if (parsed.variantId) {
          const variantSelect = card.querySelector('.product-card-variant-select');
          if (variantSelect) {
            variantSelect.value = parsed.variantId;
          }
        }
        if (cardMatchesSelectionToken(card, token)) {
          card.classList.add('selected');
        }
      });
    }
  }

  const charmSelector = step.querySelector('.charm-pendant-selector');
  if (charmSelector) {
    const tokens = selection ? String(selection).split(',').filter(Boolean) : [];
    const cards = charmSelector.querySelectorAll('.product-card');
    cards.forEach((card) => {
      const isSelected = tokens.some((token) => cardMatchesSelectionToken(card, token));
      card.classList.toggle('selected', isSelected);
    });
  }
}

function syncAllSelectionHighlights() {
  for (let i = 1; i <= totalSteps; i++) {
    restoreStepSelectionHighlights(i);
  }
}

function updateStepCounter() {
  if (stepCounter) {
    stepCounter.textContent = `${currentStep}/${totalSteps}`;
  }
}

function isSizeStep(step) {
  if (!step) return false;
  const stepTitle = step.querySelector('.step-title');
  if (!stepTitle) return false;
  const titleText = stepTitle.textContent.toLowerCase();
  return (
    titleText.includes('chain length') ||
    titleText.includes('size') ||
    (titleText.includes('length') && !titleText.includes('chain'))
  );
}

function isCharmStepElement(step) {
  return !!(step && step.querySelector('.charm-pendant-selector'));
}

function getCharmStep() {
  return steps.find(isCharmStepElement) || null;
}

function isCharmStepExpanded() {
  const charmStep = getCharmStep();
  return !!(charmStep && charmStep.classList.contains('expanded'));
}

function stepHasSelection(stepIndex) {
  const sel = selections[stepIndex];
  return sel !== undefined && sel !== null && String(sel).trim() !== '';
}

function isRequiredCustomizerStep(step) {
  return !isCharmStepElement(step);
}

function areAllRequiredSelectionsComplete() {
  if (totalSteps <= 0) return true;
  for (let i = 1; i <= totalSteps; i++) {
    const step = steps[i - 1];
    if (!step || !isRequiredCustomizerStep(step)) continue;
    if (!stepHasSelection(i)) return false;
  }
  return true;
}

function updateReviewButtonState() {
  if (!reviewButton) return;
  reviewButton.disabled = totalSteps === 0 ? false : !areAllRequiredSelectionsComplete();
}

function clearSizeStepSelections() {
  steps.forEach((step, idx) => {
    if (!isSizeStep(step)) return;
    const stepOptions = step.querySelector('.step-options');
    if (stepOptions) {
      stepOptions.querySelectorAll('.option-button').forEach((btn) => btn.classList.remove('selected'));
      delete stepOptions[`_lastUpdate_${idx + 1}`];
    }
    selections[idx + 1] = '';
    updateStepNextButton(idx + 1);
  });
}

function updateStepHeadersState() {
  stepHeaders.forEach((header, index) => {
    const stepIndex = index + 1;
    const previousStepIndex = stepIndex - 1;

    if (stepIndex === 1) {
      header.classList.remove('disabled');
    } else {
      const previousSelection = selections[previousStepIndex];
      const hasPreviousSelection =
        previousSelection !== undefined && previousSelection !== null && previousSelection !== '';
      const currentSelection = selections[stepIndex];
      const hasCurrentSelection =
        currentSelection !== undefined && currentSelection !== null && currentSelection !== '';

      if (hasPreviousSelection || hasCurrentSelection) {
        header.classList.remove('disabled');
      } else {
        header.classList.add('disabled');
        const step = steps[index];
        if (step && step.classList.contains('expanded')) {
          step.classList.remove('expanded');
        }
      }
    }
  });
  updateReviewButtonState();
}

function expandStep(stepIndex) {
  const step = steps[stepIndex - 1];
  if (step) {
    const header = stepHeaders[stepIndex - 1];
    if (header && header.classList.contains('disabled')) {
      return;
    }
  }

  steps.forEach((step, index) => {
    if (index + 1 === stepIndex) {
      step.classList.add('expanded');
    } else {
      step.classList.remove('expanded');
    }
  });

  const mobilePills = section.querySelectorAll('.mobile-step-pill');
  mobilePills.forEach((pill) => {
    const pillStep = parseInt(pill.getAttribute('data-step'), 10);
    pill.classList.toggle('active', pillStep === stepIndex);
  });
  const mobileIndicators = section.querySelector('.mobile-step-indicators');
  if (mobileIndicators && window.matchMedia('(max-width: 1024px)').matches) {
    const activePill = mobileIndicators.querySelector('.mobile-step-pill.active');
    if (activePill && typeof activePill.scrollIntoView === 'function') {
      activePill.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    }
  }

  const customizerPanel = section.querySelector('.customizer-panel');
  if (customizerPanel && window.matchMedia('(max-width: 768px)').matches) {
    const isLastStep = stepIndex === totalSteps;
    customizerPanel.classList.toggle('mobile-last-step', isLastStep);
  }

  updateReviewButtonState();

  updateCharmCompatibility();
  restoreStepSelectionHighlights(stepIndex);
  requestAnimationFrame(function () {
    layoutPcpCharms();
  });
}

function getMetalDisplayLabel(metalTag, materialLabel) {
  if (materialLabel && String(materialLabel).trim()) {
    return String(materialLabel).trim();
  }
  if (!metalTag) return '';
  return String(metalTag)
    .replace(/_2d$/i, '')
    .split('_')
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
}

function getMetalPattern(metalName) {
  if (!metalName) return '';

  const metal = metalName.trim().toLowerCase();
  const normalizedMetal = metal.replace(/\s+/g, '_').replace(/[^a-zA-Z0-9_]/g, '');
  const pattern = normalizedMetal + '_2D';

  return pattern;
}

function matchesMetalTag(tag, metalPattern) {
  if (!tag || !metalPattern) return false;

  const tagLower = tag.toLowerCase();
  const patternLower = metalPattern.toLowerCase();

  return tagLower.includes(patternLower);
}

const PCP_GOLD_METAL_FAMILIES = ['solid_gold', 'gold_vermeil', 'gold_fill'];

function metalLabelToFamily(label) {
  if (!label) return null;
  const text = String(label).trim().toLowerCase();
  if (text.includes('solid') && text.includes('gold')) return 'solid_gold';
  if (text.includes('vermeil')) return 'gold_vermeil';
  if (text.includes('fill')) return 'gold_fill';
  if (text.includes('silver')) return 'sterling_silver';
  if (text.includes('rose') && text.includes('gold')) return 'rose_gold';
  return null;
}

function detectMetalFamily(...sources) {
  const text = sources
    .filter(Boolean)
    .map((source) => String(source))
    .join(' ')
    .toLowerCase()
    .replace(/-/g, ' ');

  if (/gold\s*vermeil|gold_vermeil|\bvermeil\b/.test(text)) return 'gold_vermeil';
  if (/gold\s*fill|goldfill|gold_fill|solid_fill/.test(text)) return 'gold_fill';
  if (/sterling\s*silver|sterling_silver|solid_silver/.test(text)) return 'sterling_silver';
  if (
    /solid\s*gold|solid_gold|\b\d{1,2}\s*kt?\s*(?:yellow\s+|white\s+|rose\s+)?gold\b/.test(text)
  ) {
    return 'solid_gold';
  }
  if (/rose\s*gold|rose_gold/.test(text)) return 'rose_gold';
  return null;
}

function getProductMetalFamily(productId, title) {
  const productIdStr = String(productId);
  const cards = section.querySelectorAll('[data-product-id="' + productIdStr + '"]');
  for (let i = 0; i < cards.length; i++) {
    const card = cards[i];
    const metalTag = card.getAttribute('data-metal-tag') || '';
    const chainTag = card.getAttribute('data-chain-tag') || '';
    const materialMeta = card.getAttribute('data-material-metafield') || '';
    const tags = card.getAttribute('data-product-tags') || '';
    const cardTitle = card.querySelector('.product-title')?.textContent || title || '';

    const family =
      detectMetalFamily(metalTag) ||
      detectMetalFamily(chainTag) ||
      detectMetalFamily(materialMeta) ||
      detectMetalFamily(tags, cardTitle);
    if (family) return family;
  }
  return detectMetalFamily(title);
}

function getConfiguredMetalFamilies() {
  const families = new Set();
  const selectedMetal = getSelectedMetalLabel();
  const fromMetalLabel = metalLabelToFamily(selectedMetal);
  if (fromMetalLabel) {
    families.add(fromMetalLabel);
  }

  if (window._canvasProducts && window._canvasProducts.length > 0) {
    window._canvasProducts.forEach((product) => {
      const family = getProductMetalFamily(product.productId, product.title);
      if (family) families.add(family);
    });
  }

  getCharmSelectors().forEach((selector) => {
    (selector._selectedProducts || []).forEach((product) => {
      const family = getProductMetalFamily(product.productId, product.title);
      if (family) families.add(family);
    });
  });

  return families;
}

function hasMixedGoldMetals(families) {
  const present = PCP_GOLD_METAL_FAMILIES.filter((family) => families.has(family));
  if (present.length < 2) return false;
  if (
    present.includes('solid_gold') &&
    (present.includes('gold_vermeil') || present.includes('gold_fill'))
  ) {
    return true;
  }
  return present.includes('gold_vermeil') && present.includes('gold_fill');
}

function getMixedMetalsWarningMessage() {
  return getPcpMessage('mixedMetalsWarning');
}

function getDelicateWarningMessage() {
  return getPcpMessage('delicateWarning');
}

function getProductTags(productId) {
  const productIdStr = String(productId);
  const cards = section.querySelectorAll('[data-product-id="' + productIdStr + '"]');
  for (let i = 0; i < cards.length; i++) {
    const tags = cards[i].getAttribute('data-product-tags');
    if (tags != null && String(tags).trim() !== '') {
      return String(tags);
    }
  }
  const productData = getProductData(productId);
  if (productData && productData.tags) {
    return Array.isArray(productData.tags) ? productData.tags.join(',') : String(productData.tags);
  }
  return '';
}

function productHasDelicateTag(productId) {
  const tags = getProductTags(productId);
  if (!tags) return false;
  return tags.split(',').some((tag) => tag.trim().toLowerCase() === 'delicate');
}

function sparkContainsDelicateProduct() {
  const allProducts = getAllSelectedProducts();
  for (let i = 0; i < allProducts.length; i++) {
    if (productHasDelicateTag(allProducts[i].productId)) return true;
  }
  return false;
}

function getDelicateWarningMessage() {
  return getPcpMessage('delicateWarning');
}

function checkAndWarnMixedMetals() {
  if (!hasMixedGoldMetals(getConfiguredMetalFamilies())) return;
  showTransitionAlert(getMixedMetalsWarningMessage());
}

function checkAndWarnDelicate(productId) {
  if (!productId || !productHasDelicateTag(productId)) return;
  showTransitionAlert(getDelicateWarningMessage());
}

function checkSelectionWarnings(productId) {
  if (productId && productHasDelicateTag(productId)) {
    checkAndWarnDelicate(productId);
    return;
  }
  checkAndWarnMixedMetals();
}

function getSelectedMetalLabel() {
  const metalStep = steps.find((step) => {
    const stepTitle = step.querySelector('.step-title');
    if (stepTitle) {
      const titleText = stepTitle.textContent.toLowerCase();
      return titleText.includes('metal') || titleText.includes('choose metal');
    }
    return false;
  });
  if (!metalStep) return '';
  const selectedMetalButton = metalStep.querySelector('.option-button.selected');
  return selectedMetalButton ? selectedMetalButton.textContent.trim() : '';
}

function appendReviewFinalSaleNotice(container) {
  if (!container) return;
  container.querySelectorAll('.review-final-sale-banner').forEach(function (el) {
    el.remove();
  });
  const banner = document.createElement('div');
  banner.className = 'review-final-sale-banner';
  banner.innerHTML =
    '<span class="review-final-sale-banner__badge">' + getPcpMessage('reviewFinalSaleBadge') + '</span>' +
    '<span>' + getPcpMessage('reviewFinalSaleText') + '</span>';
  const title = container.querySelector('.review-section-title');
  if (title) {
    title.after(banner);
  } else {
    container.insertBefore(banner, container.firstChild);
  }
}

function appendReviewMixedMetalsWarning(container) {
  if (!container || !hasMixedGoldMetals(getConfiguredMetalFamilies())) return;
  const warning = document.createElement('div');
  warning.className = 'review-mixed-metals-warning';
  warning.innerHTML =
    '<span class="review-mixed-metals-warning__badge">' + getPcpMessage('reviewMixedMetalsBadge') + '</span>' +
    '<span class="review-mixed-metals-warning__message">' + getMixedMetalsWarningMessage() + '</span>';
  container.appendChild(warning);
}

function appendReviewDelicateWarning(container) {
  if (!container || !sparkContainsDelicateProduct()) return;
  const warning = document.createElement('div');
  warning.className = 'review-delicate-warning';
  warning.innerHTML =
    '<span class="review-delicate-warning__badge">' + getPcpMessage('reviewDelicateBadge') + '</span>' +
    '<span class="review-delicate-warning__message">' + getDelicateWarningMessage() + '</span>';
  container.appendChild(warning);
}

function appendReviewProductWarnings(productsList) {
  if (!productsList) return;
  productsList.querySelectorAll('.review-mixed-metals-warning, .review-delicate-warning').forEach(function (el) {
    el.remove();
  });
  appendReviewMixedMetalsWarning(productsList);
  appendReviewDelicateWarning(productsList);
}

const FINAL_SALE_AGREEMENT_PROPERTY = 'Final Sale Agreement';
const FINAL_SALE_AGREEMENT_VALUE = 'Accepted';

function getFinalSaleAgreementConfig() {
  const modal = section.querySelector('#final-sale-modal');
  return {
    propertyKey: modal?.dataset.finalSaleProperty || FINAL_SALE_AGREEMENT_PROPERTY,
    acceptedValue: modal?.dataset.finalSaleAcceptedValue || FINAL_SALE_AGREEMENT_VALUE,
  };
}

let finalSaleModalConfirmHandler = null;

function hideFinalSaleModal() {
  const modal = section.querySelector('#final-sale-modal');
  if (!modal) return;
  const checkbox = modal.querySelector('.pcp-final-sale-modal__checkbox');
  const confirmBtn = modal.querySelector('.pcp-final-sale-modal__confirm');

  if (modal._pcpCheckboxChangeHandler && checkbox) {
    checkbox.removeEventListener('change', modal._pcpCheckboxChangeHandler);
    modal._pcpCheckboxChangeHandler = null;
  }
  if (modal._pcpDismissHandler) {
    modal.querySelectorAll('[data-final-sale-dismiss]').forEach(function (el) {
      el.removeEventListener('click', modal._pcpDismissHandler);
    });
    modal._pcpDismissHandler = null;
  }

  modal.classList.add('pcp-hidden');
  modal.setAttribute('aria-hidden', 'true');
  document.body.classList.remove('pcp-final-sale-modal-open');
  if (checkbox) checkbox.checked = false;
  if (confirmBtn) confirmBtn.disabled = true;
  if (finalSaleModalConfirmHandler) {
    const confirmButton = modal.querySelector('.pcp-final-sale-modal__confirm');
    if (confirmButton) {
      confirmButton.removeEventListener('click', finalSaleModalConfirmHandler);
    }
    finalSaleModalConfirmHandler = null;
  }
}

function showFinalSaleModal(onConfirm) {
  const modal = section.querySelector('#final-sale-modal');
  if (!modal) {
    onConfirm();
    return;
  }

  hideFinalSaleModal();

  const checkbox = modal.querySelector('.pcp-final-sale-modal__checkbox');
  const confirmBtn = modal.querySelector('.pcp-final-sale-modal__confirm');
  const dismissEls = modal.querySelectorAll('[data-final-sale-dismiss]');

  modal.classList.remove('pcp-hidden');
  modal.setAttribute('aria-hidden', 'false');
  document.body.classList.add('pcp-final-sale-modal-open');

  function onCheckboxChange() {
    if (confirmBtn) confirmBtn.disabled = !checkbox.checked;
  }

  function dismissModal() {
    hideFinalSaleModal();
  }

  if (checkbox) {
    checkbox.checked = false;
    modal._pcpCheckboxChangeHandler = onCheckboxChange;
    checkbox.addEventListener('change', onCheckboxChange);
    onCheckboxChange();
  }

  modal._pcpDismissHandler = dismissModal;
  dismissEls.forEach(function (el) {
    el.addEventListener('click', dismissModal);
  });

  finalSaleModalConfirmHandler = function () {
    if (!checkbox || !checkbox.checked) return;
    hideFinalSaleModal();
    onConfirm();
  };

  if (confirmBtn) {
    confirmBtn.addEventListener('click', finalSaleModalConfirmHandler);
  }

  if (!modal.dataset.finalSaleLinksWired) {
    modal.dataset.finalSaleLinksWired = 'true';
    modal.querySelectorAll('.pcp-final-sale-modal__checkbox-text a').forEach(function (link) {
      link.addEventListener('click', function (e) {
        e.stopPropagation();
      });
    });
  }
}

function filterChainProducts(stepIndex) {
  const step = steps[stepIndex - 1];
  if (!step) return;

  const productGrid = step.querySelector('.product-grid[data-chain-step="' + stepIndex + '"]');
  if (!productGrid) return;

  const jsonScript = section.querySelector('script[data-chain-products="' + stepIndex + '"]');
  if (!jsonScript) return;

  let products = [];
  try {
    products = JSON.parse(jsonScript.textContent);
  } catch (e) {
    return;
  }

  let selectedMetal = '';
  for (let i = stepIndex - 1; i > 0; i--) {
    const prevStep = steps[i - 1];
    if (prevStep) {
      const stepTitle = prevStep.querySelector('.step-title');
      if (stepTitle && (stepTitle.textContent.includes('Metal') || stepTitle.textContent.includes('metal'))) {
        selectedMetal = selections[i];
        break;
      }
    }
  }

  const metalPattern = getMetalPattern(selectedMetal);
  const searchInput = step.querySelector('.search-input');
  const searchTerm = searchInput ? searchInput.value.toLowerCase() : '';

  const chainSelector = step.querySelector('.chain-selector');
  const activeChainFilter = chainSelector
    ? chainSelector.querySelector('.category-filter.active[data-chain-filter]')
    : null;
  const selectedChainFilter = activeChainFilter ? activeChainFilter.getAttribute('data-chain-filter') : 'all';

  productGrid.innerHTML = '';
  let hasAnyVisible = false;

  products.forEach((product) => {
    let shouldShow = true;

    const productTags = product.tags ? product.tags.join(',').toLowerCase() : '';
    const isConnector = productTags.includes('connector');
    const isPendant = productTags.includes('pendant');
    const isCharm = productTags.includes('charm');
    const isEngravable = productTags.includes('engravable');

    if (isConnector || isPendant || isCharm || isEngravable) {
      shouldShow = false;
    }

    if (shouldShow && searchTerm && !product.title.toLowerCase().includes(searchTerm)) {
      shouldShow = false;
    }

    if (shouldShow && selectedChainFilter !== 'all') {
      const productTitle = product.title.toLowerCase();
      const productTagsArray = product.tags ? product.tags.map((tag) => tag.toLowerCase()) : [];
      const filterValue = selectedChainFilter.toLowerCase();
      const normalizedFilter = filterValue.replace(/[-_\s]/g, '');

      let matchesFilter = false;

      if (productTitle.includes(filterValue)) {
        matchesFilter = true;
      } else {
        for (let i = 0; i < productTagsArray.length; i++) {
          const tag = productTagsArray[i];
          const normalizedTag = tag.replace(/[-_\s]/g, '');

          if (
            tag === filterValue ||
            tag.includes(filterValue) ||
            normalizedTag === normalizedFilter ||
            normalizedTag.includes(normalizedFilter)
          ) {
            matchesFilter = true;
            break;
          }
        }
      }

      if (!matchesFilter) {
        shouldShow = false;
      }
    }

    if (shouldShow && selectedMetal && metalPattern) {
      if (!matchesMetalTag(product.chainTag, metalPattern)) {
        shouldShow = false;
      }
    } else if (shouldShow && !selectedMetal) {
      shouldShow = false;
    }

    if (shouldShow) {
      hasAnyVisible = true;
      const hasVariants = product.variants && product.variants.length > 0;
      const firstVariant = hasVariants ? product.variants[0] : null;
      const cardImageSrc =
        firstVariant &&
        firstVariant.cardImage != null &&
        String(firstVariant.cardImage).trim() !== ''
          ? String(firstVariant.cardImage).trim()
          : firstVariant && firstVariant.image
            ? firstVariant.image
            : product.cardImage != null && String(product.cardImage).trim() !== ''
              ? String(product.cardImage).trim()
              : product.image || '';
      const cardImageAlt =
        firstVariant &&
        firstVariant.cardImageAlt != null &&
        String(firstVariant.cardImageAlt).trim() !== ''
          ? String(firstVariant.cardImageAlt).trim()
          : firstVariant && firstVariant.imageAlt != null && String(firstVariant.imageAlt).trim() !== ''
            ? String(firstVariant.imageAlt).trim()
            : product.cardImageAlt != null && String(product.cardImageAlt).trim() !== ''
              ? String(product.cardImageAlt).trim()
              : product.title;
      const cardHasPersonalizerImage =
        !!product.productHasPersonalizerImage || !!(firstVariant && firstVariant.hasPersonalizerImage);
      const card = document.createElement('div');
      card.className = 'product-card chain-product' + (hasVariants ? '' : ' product-card--sold-out');
      card.setAttribute('data-product-id', product.id);
      card.setAttribute('data-available', hasVariants ? 'true' : 'false');
      if (hasVariants) {
        card.setAttribute('draggable', 'true');
        card.setAttribute('data-variant-id', String(product.variants[0].id));
      }
      card.setAttribute('data-product-tags', product.tags.join(','));
      card.setAttribute('data-step', stepIndex);
      card.setAttribute('data-chain-tag', product.chainTag);
      card.setAttribute('data-product-personalizer-image', cardHasPersonalizerImage ? 'true' : 'false');

      const metalLabel = getMetalDisplayLabel(product.chainTag, product.materialLabel);
      let cardHTML = '';
      if (cardImageSrc) {
        cardHTML += '<div class="product-image">';
        if (metalLabel) {
          cardHTML += `<span class="product-card-metal-badge">${metalLabel}</span>`;
        }
        cardHTML += `<img src="${cardImageSrc}" alt="${escapeHtmlAttr(cardImageAlt)}"></div>`;
      } else if (metalLabel) {
        cardHTML += `<span class="product-card-metal-badge product-card-metal-badge--inline">${metalLabel}</span>`;
      }
      cardHTML += `<div class="product-info"><h4 class="product-title">${product.title}</h4><p class="product-price">${product.price}</p></div>`;
      if (hasVariants) {
        cardHTML += `<div class="product-card-overlay"><h3 class="product-card-overlay-title">${product.title}</h3><div class="product-card-overlay-config">`;
        if (product.variants.length > 1 && product.optionName) {
          cardHTML += `<label>${product.optionName}:</label><select class="product-card-variant-select" data-product-id="${product.id}">`;
          product.variants.forEach((variant) => {
            const variantShopImage =
              variant.cardImage != null && String(variant.cardImage).trim() !== ''
                ? String(variant.cardImage).trim()
                : product.cardImage != null && String(product.cardImage).trim() !== ''
                  ? String(product.cardImage).trim()
                  : variant.image || product.image || '';
            const variantShopAlt =
              variant.cardImageAlt != null && String(variant.cardImageAlt).trim() !== ''
                ? String(variant.cardImageAlt).trim()
                : product.cardImageAlt != null && String(product.cardImageAlt).trim() !== ''
                  ? String(product.cardImageAlt).trim()
                  : variant.imageAlt != null && String(variant.imageAlt).trim() !== ''
                    ? String(variant.imageAlt).trim()
                    : product.title;
            const variantCanvasImage = variant.image || product.image || '';
            const variantCanvasAlt =
              variant.imageAlt != null && String(variant.imageAlt).trim() !== ''
                ? String(variant.imageAlt).trim()
                : product.title;
            cardHTML += `<option value="${variant.id}" data-price="${variant.price}" data-image="${variantShopImage}" data-image-alt="${escapeHtmlAttr(
              variantShopAlt
            )}" data-canvas-image="${variantCanvasImage}" data-canvas-image-alt="${escapeHtmlAttr(
              variantCanvasAlt
            )}" data-personalizer-image="${variant.hasPersonalizerImage ? 'true' : 'false'}" data-focal-point-x="${
              variant.focalPointX != null ? variant.focalPointX : product.focalPointX != null ? product.focalPointX : 50
            }" data-focal-point-y="${
              variant.focalPointY != null ? variant.focalPointY : product.focalPointY != null ? product.focalPointY : 50
            }">${variant.title}</option>`;
          });
          cardHTML += `</select>`;
        }
        cardHTML += `<button class="product-card-overlay-select-btn" data-step="${stepIndex}" data-product-id="${product.id}">Select</button></div></div>`;
      }
      card.innerHTML = cardHTML;
      productGrid.appendChild(card);
    }
  });

  if (!hasAnyVisible) {
    const emptyEl = document.createElement('p');
    emptyEl.className = 'product-grid-empty';
    emptyEl.textContent = 'Oops, no products found.';
    productGrid.appendChild(emptyEl);
    productGrid.classList.add('is-empty');
  } else {
    productGrid.classList.remove('is-empty');
  }

  attachChainProductEvents(stepIndex);
  restoreStepSelectionHighlights(stepIndex);
}

let updateChainLengthQuestionTimeout = null;

function updateChainLengthQuestion(selectedProductId, selectedVariantId) {
  if (!selectedProductId) return;

  if (updateChainLengthQuestionTimeout) {
    clearTimeout(updateChainLengthQuestionTimeout);
  }

  updateChainLengthQuestionTimeout = setTimeout(() => {
    const allChainScripts = section.querySelectorAll('script[data-chain-products]');
    let allProducts = [];

    allChainScripts.forEach((script) => {
      try {
        const products = JSON.parse(script.textContent);
        allProducts = allProducts.concat(products);
      } catch (e) {}
    });

    const selectedProduct = allProducts.find((p) => p.id == selectedProductId);
    if (!selectedProduct) return;

    steps.forEach((step, idx) => {
      const stepTitle = step.querySelector('.step-title');
      if (!stepTitle) return;

      const titleText = stepTitle.textContent.toLowerCase();
      if (!titleText.includes('chain length') && !titleText.includes('length') && !titleText.includes('size')) {
        return;
      }

      const stepOptions = step.querySelector('.step-options');
      if (!stepOptions) return;

      const updateKey = `_lastUpdate_${idx + 1}`;
      const lastUpdate = stepOptions[updateKey];
      if (lastUpdate && lastUpdate.productId == selectedProductId) {
        return;
      }

      const existingButtons = stepOptions.querySelectorAll('.option-button');
      existingButtons.forEach((btn) => btn.remove());

      stepOptions[updateKey] = { productId: selectedProductId, variantId: selectedVariantId };

      function createOptionButton(value, label, isSelected, isDisabled) {
        const button = document.createElement('button');
        button.className = 'option-button';
        if (isSelected) {
          button.classList.add('selected');
        }
        if (isDisabled) {
          button.classList.add('is-disabled');
          button.disabled = true;
        }
        button.setAttribute('data-option-value', value);
        button.setAttribute('data-step', idx + 1);
        button.textContent = label;

        button.addEventListener('click', function () {
          if (this.disabled) return;
          const stepOptions = this.closest('.step-options');
          const stepButtons = stepOptions.querySelectorAll('.option-button');
          stepButtons.forEach((btn) => btn.classList.remove('selected'));
          this.classList.add('selected');
          selections[idx + 1] = this.getAttribute('data-option-value');
          updateChainProductVariant(selectedProductId, this.getAttribute('data-option-value'));
          const chainStepIndex = getChainStepIndex();
          if (chainStepIndex > 0) {
            selections[chainStepIndex] = `${selectedProductId}|${this.getAttribute('data-option-value')}`;
          }
          updateStepNextButton(idx + 1);
          updateStepHeadersState();
        });

        return button;
      }

      const hasVariants =
        selectedProduct.variants && Array.isArray(selectedProduct.variants) && selectedProduct.variants.length > 0;

      if (!hasVariants) {
        const button = createOptionButton(selectedProductId, 'Default', true);
        stepOptions.appendChild(button);
        selections[idx + 1] = selectedProductId;
      } else {
        let defaultVariantId = selectedVariantId;
        const variantExists = selectedProduct.variants.some((v) => v && v.id == selectedVariantId);
        if (!variantExists || !defaultVariantId) {
          const firstAvailable = selectedProduct.variants.find((v) => v && v.available !== false);
          defaultVariantId = firstAvailable ? firstAvailable.id : null;
        }

        selections[idx + 1] = '';

        selectedProduct.variants.forEach((variant) => {
          if (!variant || !variant.id || !variant.title) return;

          const isDisabled = variant.available === false;
          const isSelected = !isDisabled && variant.id == defaultVariantId;
          const button = createOptionButton(variant.id, variant.title, isSelected, isDisabled);
          stepOptions.appendChild(button);

          if (isSelected && !isDisabled) {
            selections[idx + 1] = variant.id;
          }
        });
      }

      if (selections[idx + 1]) {
        updateChainProductVariant(selectedProductId, selections[idx + 1]);
        const chainStepIndex = getChainStepIndex();
        if (chainStepIndex > 0) {
          selections[chainStepIndex] = `${selectedProductId}|${selections[idx + 1]}`;
        }
      }

      updateStepNextButton(idx + 1);
      updateStepHeadersState();
    });
  }, 50);
}

function clearChainSelections() {
  steps.forEach((step, idx) => {
    const selector = step.querySelector('.chain-selector');
    if (selector) {
      const selectedCards = selector.querySelectorAll('.product-card.selected');
      selectedCards.forEach((card) => {
        card.classList.remove('selected');
      });
      selections[idx + 1] = '';
      updateStepNextButton(idx + 1);
    }
  });

  steps.forEach((step, idx) => {
    const stepTitle = step.querySelector('.step-title');
    if (
      stepTitle &&
      (stepTitle.textContent.toLowerCase().includes('chain length') ||
        (stepTitle.textContent.toLowerCase().includes('length') &&
          !stepTitle.textContent.toLowerCase().includes('chain')))
    ) {
      const stepOptions = step.querySelector('.step-options');
      if (stepOptions) {
        stepOptions.innerHTML = '';
      }
      selections[idx + 1] = '';
      updateStepNextButton(idx + 1);
    }
  });

  window._canvasProducts = window._canvasProducts.filter((p) => p.type !== 'chain');

  const allCharmSelectors = getCharmSelectors();
  allCharmSelectors.forEach((selector) => {
    const updateDisplayFunc = selector._updateCanvasDisplay;
    if (updateDisplayFunc) {
      updateDisplayFunc();
    }
  });

  updateStepHeadersState();
  updateCharmCompatibility();
}

function getOriginalImageUrl(imageUrl) {
  if (!imageUrl) return '';
  try {
    const url = new URL(imageUrl);
    url.searchParams.delete('width');
    url.searchParams.delete('height');
    url.searchParams.delete('w');
    url.searchParams.delete('h');
    return url.toString();
  } catch (e) {
    return imageUrl.replace(/[?&](width|height|w|h)=\d+/g, '').replace(/[?&]$/, '');
  }
}

function attachChainProductEvents(stepIndex) {
  const step = steps[stepIndex - 1];
  if (!step) return;

  const selector = step.querySelector('.chain-selector');
  if (!selector) return;

  const canvasContent = section.querySelector('.canvas-content');

      const productCards = selector.querySelectorAll('.product-card');
  let selectedChain = null;

  productCards.forEach((card) => {
    const existingClickHandler = card._clickHandler;
    if (existingClickHandler) {
      card.removeEventListener('click', existingClickHandler);
    }

    const existingDragStart = card._dragStartHandler;
    if (existingDragStart) {
      card.removeEventListener('dragstart', existingDragStart);
    }

    const existingDragEnd = card._dragEndHandler;
    if (existingDragEnd) {
      card.removeEventListener('dragend', existingDragEnd);
    }

    const dragStartHandler = function (e) {
      if (this.classList.contains('product-card--sold-out') || this.getAttribute('data-available') === 'false') {
        e.preventDefault();
        return;
      }
      this.classList.add('dragging');
      e.dataTransfer.setData('text/plain', this.getAttribute('data-product-id'));
      e.dataTransfer.setData('step-index', stepIndex);
      e.dataTransfer.effectAllowed = 'move';
    };

    const dragEndHandler = function () {
      this.classList.remove('dragging');
    };

    const clickHandler = function (e) {
      if (this.classList.contains('product-card--sold-out') || this.getAttribute('data-available') === 'false') {
        showTransitionAlert(getPcpMessage('soldOutMessage'));
        return;
      }
      if (
        e.target.classList.contains('product-card-overlay-select-btn') ||
        e.target.closest('.product-card-overlay-select-btn')
      ) {
        return;
      }
      if (
        e.target.classList.contains('product-card-variant-select') ||
        e.target.closest('.product-card-variant-select')
      ) {
        return;
      }

      const productId = this.getAttribute('data-product-id');
      const variantId = getCardVariantId(this);

      if (this.classList.contains('selected')) {
        selectedChain = null;
        this.classList.remove('selected');
        selections[stepIndex] = '';

        clearChainProduct(productId, variantId);
      } else {
        productCards.forEach((c) => c.classList.remove('selected'));
        this.classList.add('selected');
        selectedChain = {
          productId: productId,
          variantId: variantId,
        };
        selections[stepIndex] = variantId ? `${productId}|${variantId}` : productId;

        const chainProduct = buildChainProduct(this, variantId);
        setChainProduct(chainProduct);

        clearSizeStepSelections();
        updateChainLengthQuestion(productId, variantId);
        checkSelectionWarnings(productId);
      }

      updateStepNextButton(stepIndex);
      updateStepHeadersState();
      updateCharmCompatibility();
    };

    card._clickHandler = clickHandler;
    card._dragStartHandler = dragStartHandler;
    card._dragEndHandler = dragEndHandler;
    card.addEventListener('click', clickHandler);
    card.addEventListener('dragstart', dragStartHandler);
    card.addEventListener('dragend', dragEndHandler);
  });

  if (canvasContent) {
    const existingDropHandler = canvasContent._chainDropHandler;
    if (existingDropHandler) {
      canvasContent.removeEventListener('drop', existingDropHandler);
    }

    const chainDropHandler = function (e) {
      const productId = e.dataTransfer.getData('text/plain');
      const droppedStepIndex = parseInt(e.dataTransfer.getData('step-index'));

      if (droppedStepIndex === stepIndex) {
        e.preventDefault();
        e.stopPropagation();
        this.classList.remove('drag-over');

        const droppedCard = selector.querySelector(`[data-product-id="${productId}"]`);

        if (droppedCard && droppedCard.classList.contains('chain-product') && droppedCard.getAttribute('data-available') !== 'false') {
          const variantSelect = droppedCard.querySelector('.product-card-variant-select');
          let variantId = variantSelect ? variantSelect.value : droppedCard.getAttribute('data-variant-id');
          if (!variantId || variantId === '' || variantId === 'null') {
            variantId = droppedCard.getAttribute('data-variant-id') || null;
          }

          productCards.forEach((c) => c.classList.remove('selected'));
          droppedCard.classList.add('selected');

          selectedChain = {
            productId: productId,
            variantId: variantId,
          };
          selections[stepIndex] = variantId ? `${productId}|${variantId}` : productId;

            const chainProduct = buildChainProduct(droppedCard, variantId);
            setChainProduct(chainProduct);

          clearSizeStepSelections();
          updateChainLengthQuestion(productId, variantId);
          checkSelectionWarnings(productId);
          updateStepNextButton(stepIndex);
          updateStepHeadersState();
          updateCharmCompatibility();
        }
      }
    };

    if (!canvasContent._chainDropHandlers) {
      canvasContent._chainDropHandlers = [];
    }

    const existingHandlerIndex = canvasContent._chainDropHandlers.findIndex((h) => h.stepIndex === stepIndex);
    if (existingHandlerIndex !== -1) {
      canvasContent.removeEventListener('drop', canvasContent._chainDropHandlers[existingHandlerIndex].handler);
      canvasContent._chainDropHandlers.splice(existingHandlerIndex, 1);
    }

    canvasContent._chainDropHandlers.push({ stepIndex: stepIndex, handler: chainDropHandler });
    canvasContent.addEventListener('drop', chainDropHandler);
  }

  const cardSelectButtons = selector.querySelectorAll('.product-card-overlay-select-btn');
  cardSelectButtons.forEach((btn) => {
    const existingHandler = btn._selectHandler;
    if (existingHandler) {
      btn.removeEventListener('click', existingHandler);
    }

    const selectHandler = function (e) {
      e.stopPropagation();
      const card = this.closest('.product-card');
      if (card) {
        const productId = card.getAttribute('data-product-id');
        const variantSelect = card.querySelector('.product-card-variant-select');
        const variantId = variantSelect ? variantSelect.value : null;

        productCards.forEach((c) => c.classList.remove('selected'));
        card.classList.add('selected');
        selectedChain = {
          productId: productId,
          variantId: variantId,
        };
        selections[stepIndex] = variantId ? `${productId}|${variantId}` : productId;

          const chainProduct = buildChainProduct(card, variantId);
          setChainProduct(chainProduct);

        clearSizeStepSelections();
        updateChainLengthQuestion(productId, variantId);
        checkSelectionWarnings(productId);
        updateStepNextButton(stepIndex);
        updateStepHeadersState();
        updateCharmCompatibility();
      }
    };

    btn._selectHandler = selectHandler;
    btn.addEventListener('click', selectHandler);
  });

  const variantSelects = selector.querySelectorAll('.product-card-variant-select');
  variantSelects.forEach((select) => {
    const existingHandler = select._changeHandler;
    if (existingHandler) {
      select.removeEventListener('change', existingHandler);
    }

    const changeHandler = function (e) {
      e.stopPropagation();
      const card = this.closest('.product-card');
      if (!card) return;
      const productId = card.getAttribute('data-product-id');
      const newVariantId = this.value;
      const selOpt = this.options[this.selectedIndex];
      const variantImageData = selOpt && selOpt.getAttribute('data-image');
      const variantImageAltData = selOpt && selOpt.getAttribute('data-image-alt');
      const productImageWrap = card.querySelector('.product-image');
      const productImage = card.querySelector('.product-image img');
      if (productImageWrap && productImage) {
        if (variantImageData && variantImageData !== '') {
          productImage.setAttribute('src', variantImageData);
          productImage.setAttribute('srcset', '');
        }
        if (variantImageAltData != null && String(variantImageAltData).trim() !== '') {
          productImage.setAttribute('alt', String(variantImageAltData).trim());
        }
      }
      if (card.classList.contains('selected')) {
        selectedChain = {
          productId: productId,
          variantId: newVariantId,
        };
        selections[stepIndex] = newVariantId ? `${productId}|${newVariantId}` : productId;
        updateChainLengthQuestion(productId, newVariantId);
        updateChainProductVariant(productId, newVariantId);
        updateStepNextButton(stepIndex);
        updateStepHeadersState();
        updateCharmCompatibility();
      }
    };

    select._changeHandler = changeHandler;
    select.addEventListener('change', changeHandler);

  });

  updateCharmCompatibility();
}

function updateStepNextButton(stepIndex) {
  const step = steps[stepIndex - 1];
  if (!step) return;

  const nextButton = step.querySelector('.step-next-button');
  if (!nextButton) return;

  const isCharmSelector = step.querySelector('.charm-pendant-selector');
  if (isCharmSelector) {
    const currentSelection = selections[stepIndex];
    const selectionCount = currentSelection
      ? typeof currentSelection === 'string'
        ? currentSelection.split(',').length
        : currentSelection.length
      : 0;
    nextButton.disabled = selectionCount < 1;
  } else {
    const hasSelection = selections[stepIndex] !== undefined && selections[stepIndex] !== '';
    nextButton.disabled = !hasSelection;
  }

  filterChainProducts(stepIndex + 1);
  updateReviewButtonState();
}

stepHeaders.forEach((header, index) => {
  header.addEventListener('click', function () {
    if (this.classList.contains('disabled')) {
      return;
    }

    const stepIndex = index + 1;
    const step = steps[index];
    const isExpanded = step.classList.contains('expanded');

    if (isExpanded) {
      step.classList.remove('expanded');
      layoutPcpCharms();
    } else {
      currentStep = stepIndex;
      expandStep(stepIndex);
      updateStepCounter();
      filterChainProducts(stepIndex);
    }
  });
});

const mobileStepPills = section.querySelectorAll('.mobile-step-pill');
mobileStepPills.forEach((pill) => {
  pill.addEventListener('click', function () {
    const stepIndex = parseInt(this.getAttribute('data-step'), 10);
    const header = stepHeaders[stepIndex - 1];
    if (header && header.classList.contains('disabled')) {
      return;
    }
    currentStep = stepIndex;
    expandStep(stepIndex);
    updateStepCounter();
    filterChainProducts(stepIndex);
    const step = steps[stepIndex - 1];
    if (step) {
      step.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
  });
});

(function setInitialMobileReviewVisibility() {
  const customizerPanel = section.querySelector('.customizer-panel');
  if (customizerPanel && window.matchMedia('(max-width: 768px)').matches) {
    customizerPanel.classList.toggle('mobile-last-step', currentStep === totalSteps);
  }
  updateReviewButtonState();
})();

optionButtons.forEach((button) => {
  button.addEventListener('click', function () {
    const stepIndex = parseInt(this.getAttribute('data-step'));
    const optionValue =
      this.getAttribute('data-option-value') || this.getAttribute('data-product-id') || this.textContent.trim();

    const step = this.closest('.customization-step');
    const stepOptions = step.querySelectorAll('.option-button:not(input)');

    stepOptions.forEach((opt) => opt.classList.remove('selected'));
    this.classList.add('selected');

    selections[stepIndex] = optionValue;
    updateStepNextButton(stepIndex);
    updateStepHeadersState();

    const stepTitle = step.querySelector('.step-title');
    if (stepTitle && (stepTitle.textContent.includes('Metal') || stepTitle.textContent.includes('metal'))) {
      clearChainSelections();
      steps.forEach((s, idx) => {
        filterChainProducts(idx + 1);
      });
      checkAndWarnMixedMetals();
    }
  });
});

inputFields.forEach((input) => {
  input.addEventListener('input', function () {
    const stepIndex = parseInt(this.getAttribute('data-step'));
    selections[stepIndex] = this.value;
    updateStepNextButton(stepIndex);
    updateStepHeadersState();
  });
});

stepNextButtons.forEach((button) => {
  button.addEventListener('click', function () {
    if (this.disabled) return;

    const stepIndex = parseInt(this.getAttribute('data-step-next'));
    const nextStepIndex = stepIndex + 1;

    if (stepIndex === totalSteps && this.hasAttribute('data-step-review')) {
      beginReview(this);
      return;
    }

    if (nextStepIndex <= totalSteps) {
      currentStep = nextStepIndex;
      expandStep(currentStep);
      updateStepCounter();
      filterChainProducts(currentStep);
    }
  });
});

if (backButton) {
  backButton.addEventListener('click', function () {
    if (currentStep > 1) {
      currentStep--;
      expandStep(currentStep);
      updateStepCounter();
    }
  });
}

const reviewView = section.querySelector('.review-view');
const reviewBackButton = section.querySelector('.review-back-button');
const productCustomizerWrapper = section.querySelector('.product-customizer-wrapper');

/** Clockwise angle from chain top (12 o'clock / clasp), 0 → 2π. Used to match review/cart order to canvas layout. */
function pcpGetCharmClockwiseSortKey(product) {
  const pos = product && product.position;
  if (!pos || typeof pos.x !== 'number' || typeof pos.y !== 'number') {
    return Number.POSITIVE_INFINITY;
  }
  const dx = pos.x - 50;
  const dy = pos.y - 50;
  if (Math.abs(dx) < 0.001 && Math.abs(dy) < 0.001) {
    return Number.POSITIVE_INFINITY;
  }
  let angle = Math.atan2(dx, -dy);
  if (angle < 0) angle += 2 * Math.PI;
  return angle;
}

function sortCharmsByCanvasPosition(charms) {
  return charms.slice().sort(function (a, b) {
    const angleDiff = pcpGetCharmClockwiseSortKey(a) - pcpGetCharmClockwiseSortKey(b);
    if (angleDiff !== 0) return angleDiff;
    const aId = a.id != null ? String(a.id) : '';
    const bId = b.id != null ? String(b.id) : '';
    if (aId !== bId) return aId.localeCompare(bId);
    return 0;
  });
}

function getAllSelectedProducts() {
  const chainProducts = [];
  const charmProducts = [];

  if (window._canvasProducts && window._canvasProducts.length > 0) {
    window._canvasProducts.forEach((product) => {
      chainProducts.push({
        productId: product.productId,
        variantId: product.variantId,
        variantTitle: product.variantTitle,
        title: product.title,
        imageSrc: product.imageSrc,
        type: product.type || 'chain',
        price: product.price || 0,
        position: product.position || { x: 50, y: 50 },
        rotation: product.rotation || 0,
      });
    });
  }

  const charmSelectors = getCharmSelectors();
  charmSelectors.forEach((selector) => {
    const selectorSelectedProducts = selector._selectedProducts || [];
    selectorSelectedProducts.forEach((product) => {
      const item = {
        productId: product.productId,
        variantId: product.variantId,
        variantTitle: product.variantTitle,
        title: product.title,
        imageSrc: product.imageSrc,
        type: 'charm',
        price: product.price || 0,
        position: product.position || { x: 50, y: 50 },
        rotation: product.rotation || 0,
      };
      if (product.id != null && product.id !== '') {
        item.id = product.id;
      }
      if (product.engravingText !== undefined) {
        item.engravingText = normalizeEngravingText(
          product.engravingText,
          resolveEngravingMaxChars(product.productId, product)
        );
      }
      if (product.engravingFont !== undefined) item.engravingFont = product.engravingFont;
      charmProducts.push(item);
    });
  });

  return chainProducts.concat(sortCharmsByCanvasPosition(charmProducts));
}

function getCanvasCharmProductCount() {
  let count = 0;
  getCharmSelectors().forEach(function (selector) {
    const arr = selector._selectedProducts;
    if (Array.isArray(arr)) count += arr.length;
  });
  return count;
}

function getProductData(productId) {
  const productIdStr = String(productId);
  const productIdNum = parseInt(productId);
  const allScripts = section.querySelectorAll('script[data-chain-products], script[data-charm-products], script[data-pendant-products]');
  for (let script of allScripts) {
    try {
      const products = JSON.parse(script.textContent);
      if (!Array.isArray(products)) continue;
      const product = products.find((p) => {
        const pId = String(p.id || '');
        return pId === productIdStr || 
               pId === String(productIdNum) || 
               p.id == productIdNum ||
               p.id == productIdStr;
      });
      if (product) return product;
    } catch (e) {
      console.warn('Error parsing product script in getProductData:', e);
    }
  }

  const productCards = section.querySelectorAll(`[data-product-id="${productId}"]`);
  if (productCards.length > 0) {
    const card = productCards[0];
    const title = card.querySelector('.product-title')?.textContent || '';
    const priceText = card.querySelector('.product-price')?.textContent || '';
    const price = parseFloat(priceText.replace(/[^0-9.]/g, '')) || 0;
    const image = card.querySelector('.product-image img')?.getAttribute('src') || '';

    return {
      id: productId,
      title: title,
      price: priceText,
      image: image,
    };
  }

  return null;
}

function parsePrice(priceString) {
  if (priceString == null || priceString === '') return 0;
  if (typeof priceString === 'number') {
    if (isShopifyCentsPrice(priceString)) {
      return priceString / 100;
    }
    return priceString;
  }
  if (typeof priceString !== 'string') return 0;

  let cleaned = priceString.trim();
  cleaned = cleaned.replace(/^Rs\.?\s*/i, '');
  cleaned = cleaned.replace(/^PKR\s*/i, '');
  cleaned = cleaned.replace(/[^\d,.\s]/g, '');

  cleaned = cleaned.replace(/\s/g, '');

  if (!cleaned) return 0;

  const lastCommaIndex = cleaned.lastIndexOf(',');
  const lastPeriodIndex = cleaned.lastIndexOf('.');

  if (lastCommaIndex > lastPeriodIndex) {
    const digitsAfterComma = cleaned.length - lastCommaIndex - 1;
    if (digitsAfterComma <= 2 && lastCommaIndex > 0) {
      cleaned = cleaned.replace(/\./g, '');
      cleaned = cleaned.replace(',', '.');
    } else {
      cleaned = cleaned.replace(/,/g, '');
    }
  } else if (lastPeriodIndex > lastCommaIndex) {
    const digitsAfterPeriod = cleaned.length - lastPeriodIndex - 1;
    if (digitsAfterPeriod <= 2 && lastPeriodIndex > 0) {
      cleaned = cleaned.replace(/,/g, '');
    } else {
      if (lastCommaIndex !== -1) {
        const digitsAfterComma = cleaned.length - lastCommaIndex - 1;
        if (digitsAfterComma <= 2 && lastCommaIndex > 0) {
          cleaned = cleaned.replace(/\./g, '');
          cleaned = cleaned.replace(',', '.');
        } else {
          cleaned = cleaned.replace(/,/g, '');
        }
      } else {
        cleaned = cleaned.replace(/,/g, '');
      }
    }
  } else {
    cleaned = cleaned.replace(/,/g, '');
  }

  const parsed = parseFloat(cleaned);
  return isNaN(parsed) ? 0 : parsed;
}

function isShopifyCentsPrice(value) {
  if (value == null || value === '') return false;
  const str = String(value).trim();
  if (!/^\d+$/.test(str)) return false;
  const num = Number(str);
  return !Number.isNaN(num) && num >= 100;
}

function formatShopifyCents(cents) {
  const amount = Number(cents);
  if (Number.isNaN(amount)) return '';
  if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
    return Shopify.formatMoney(amount);
  }
  return formatPrice(amount / 100, 'Rs.');
}

function normalizeCustomizerProductPrice(price, productId, variantId) {
  if (typeof price === 'string' && price.trim() && !isShopifyCentsPrice(price)) {
    return price.trim();
  }

  if (isShopifyCentsPrice(price)) {
    return formatShopifyCents(price);
  }

  if (productId) {
    const cards = section.querySelectorAll('[data-product-id="' + String(productId) + '"]');
    for (let i = 0; i < cards.length; i++) {
      const card = cards[i];
      const variantSelect = card.querySelector('.product-card-variant-select');
      const resolvedVariantId = variantId || getCardVariantId(card);
      if (variantSelect && resolvedVariantId) {
        variantSelect.value = String(resolvedVariantId);
      }
      const cardPrice = getCardPrice(card, variantSelect, resolvedVariantId);
      if (cardPrice) return cardPrice;
    }

    const variantData = variantId ? getVariantData(productId, variantId) : null;
    if (variantData && variantData.price && String(variantData.price).trim()) {
      return String(variantData.price).trim();
    }
  }

  if (price != null && price !== '') {
    return isShopifyCentsPrice(price) ? formatShopifyCents(price) : String(price).trim();
  }

  return '';
}

function formatPrice(amount, samplePrice) {
  const currencyMap = {
    DA: 'DZD',
    'د.ج': 'DZD',
    $: 'USD',
    '€': 'EUR',
    '£': 'GBP',
    '¥': 'JPY',
    '₹': 'INR',
    'Rs.': 'PKR',
    'Rs': 'PKR',
    دج: 'DZD',
  };

  if (typeof Shopify !== 'undefined') {
    if (Shopify.currency && Shopify.currency.active) {
      const currencyCode = Shopify.currency.active;
      const formattedAmount = amount.toFixed(2);
      return currencyCode + ' ' + formattedAmount;
    }
    if (Shopify.formatMoney) {
      const formatted = Shopify.formatMoney(amount * 100);
      const currencySymbol = formatted.replace(/[\d,.\s]/g, '').trim();
      if (currencySymbol && currencyMap[currencySymbol]) {
        const numberPart = formatted.replace(/[^\d,.]/g, '');
        return currencyMap[currencySymbol] + ' ' + numberPart;
      }
      return formatted;
    }
  }

  if (!samplePrice || typeof samplePrice !== 'string') {
    return 'USD ' + amount.toFixed(2);
  }

  const cleanedPrice = samplePrice.trim();
  const numberPattern = /[\d,.\s]+/;
  const numberMatch = cleanedPrice.match(numberPattern);

  if (!numberMatch) {
    return 'USD ' + amount.toFixed(2);
  }

  const numberPart = numberMatch[0];
  const numberStartIndex = cleanedPrice.indexOf(numberPart);
  const numberEndIndex = numberStartIndex + numberPart.length;

  const beforeNumber = cleanedPrice.substring(0, numberStartIndex).trim();
  const afterNumber = cleanedPrice.substring(numberEndIndex).trim();

  let currencySymbol = '';
  if (beforeNumber) {
    currencySymbol = beforeNumber;
  } else if (afterNumber) {
    currencySymbol = afterNumber;
  } else {
    const commonSymbols = cleanedPrice.match(/[€$£¥₹دجDA]/);
    currencySymbol = commonSymbols ? commonSymbols[0] : '$';
  }

  if (!currencySymbol) {
    currencySymbol = '$';
  }

  const currencyCode = currencyMap[currencySymbol] || currencySymbol;

  const hasComma = numberPart.includes(',');
  const commaIndex = numberPart.lastIndexOf(',');
  const periodIndex = numberPart.lastIndexOf('.');

  let formattedAmount = '';
  if (hasComma && commaIndex > periodIndex) {
    const digitsAfterComma = numberPart.length - commaIndex - 1;
    if (digitsAfterComma <= 2) {
      formattedAmount = amount.toFixed(2).replace('.', ',');
    } else {
      formattedAmount = amount.toFixed(2);
    }
  } else if (hasComma && periodIndex > commaIndex) {
    const intPart = Math.floor(amount).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    formattedAmount = intPart + amount.toFixed(2).slice(-3);
  } else {
    formattedAmount = amount.toFixed(2);
  }

  return currencyCode + ' ' + formattedAmount;
}

async function getDefaultVariantId(productId) {
  const productIdStr = String(productId);
  const productIdNum = parseInt(productId);
  
  const allScripts = section.querySelectorAll('script[data-chain-products], script[data-charm-products], script[data-pendant-products]');
  for (let script of allScripts) {
    try {
      const products = JSON.parse(script.textContent);
      if (!Array.isArray(products)) continue;
      
      const product = products.find((p) => {
        const pId = String(p.id || '');
        return pId === productIdStr || 
               pId === String(productIdNum) || 
               p.id == productIdNum ||
               p.id == productIdStr;
      });
      
      if (product && product.variants && Array.isArray(product.variants) && product.variants.length > 0) {
        const variantId = product.variants[0].id;
        if (variantId) return String(variantId);
      }
    } catch (e) {
      console.warn('Error parsing product script:', e);
    }
  }

  const productCards = section.querySelectorAll(`[data-product-id="${productIdStr}"], [data-product-id="${productIdNum}"]`);
  if (productCards.length > 0) {
    const card = productCards[0];
    const variantSelect = card.querySelector('.product-card-variant-select');
    if (variantSelect && variantSelect.options && variantSelect.options.length > 0) {
      for (let i = 0; i < variantSelect.options.length; i++) {
        const option = variantSelect.options[i];
        const variantId = option.value;
        if (variantId && variantId !== '' && variantId !== 'null' && /^\d+$/.test(String(variantId))) {
          return String(variantId);
        }
      }
    }
    
    const dataVariantId = card.getAttribute('data-variant-id');
    if (dataVariantId && dataVariantId !== '' && dataVariantId !== 'null' && /^\d+$/.test(String(dataVariantId))) {
      return String(dataVariantId);
    }
    const cardHandle = card.getAttribute('data-product-handle');
    if (cardHandle && cardHandle.trim() !== '') {
      try {
        const handleResponse = await fetch(`/products/${cardHandle}.js`);
        if (handleResponse.ok) {
          const product = await handleResponse.json();
          if (product && product.variants && Array.isArray(product.variants) && product.variants.length > 0) {
            const vid = product.variants[0].id;
            if (vid) return String(vid);
          }
        }
      } catch (err) {
        console.warn('Error fetching product by handle:', err);
      }
    }
  }

  const anyProductEl = section.querySelector(`[data-product-id="${productIdStr}"][data-product-handle], [data-product-id="${productIdNum}"][data-product-handle]`);
  if (anyProductEl) {
    const handle = anyProductEl.getAttribute('data-product-handle');
    if (handle && handle.trim() !== '') {
      try {
        const handleResponse = await fetch(`/products/${handle}.js`);
        if (handleResponse.ok) {
          const product = await handleResponse.json();
          if (product && product.variants && Array.isArray(product.variants) && product.variants.length > 0) {
            const vid = product.variants[0].id;
            if (vid) return String(vid);
          }
        }
      } catch (err) {
        console.warn('Error fetching product by handle:', err);
      }
    }
  }
  
  try {
    const productData = getProductData(productIdNum);
    if (productData && productData.variants && Array.isArray(productData.variants) && productData.variants.length > 0) {
      const variantId = productData.variants[0].id;
      if (variantId) return String(variantId);
    }
  } catch (e) {
    console.warn('Error getting product data:', e);
  }
  
  try {
    let productHandle = productIdStr;
    if (productIdStr.includes('/')) {
      productHandle = productIdStr.split('/').pop();
    }
    if (productHandle && /^[a-z0-9\-]+$/i.test(productHandle)) {
      const productUrl = `/products/${productHandle}.js`;
      const response = await fetch(productUrl);
      if (response.ok) {
        const product = await response.json();
        if (product && product.variants && Array.isArray(product.variants) && product.variants.length > 0) {
          const variantId = product.variants[0].id;
          if (variantId) return String(variantId);
        }
      }
    }
  } catch (e) {
    console.warn('Error fetching product from Shopify API:', e);
  }
  
  return null;
}

function getVariantData(productId, variantId) {
  const allScripts = section.querySelectorAll('script[data-chain-products], script[data-charm-products], script[data-pendant-products]');
  for (let script of allScripts) {
    try {
      const products = JSON.parse(script.textContent);
      const product = products.find((p) => p.id == productId || String(p.id) === String(productId));
      if (product && product.variants) {
        const variant = product.variants.find((v) => v.id == variantId || String(v.id) === String(variantId));
        if (variant) {
          return {
            id: variantId,
            title: variant.title,
            price: variant.price || '',
            image: variant.image != null ? String(variant.image) : '',
            imageAlt: variant.imageAlt != null ? String(variant.imageAlt) : '',
            hasPersonalizerImage: !!variant.hasPersonalizerImage,
            cardImage: variant.cardImage != null ? String(variant.cardImage) : '',
            cardImageAlt: variant.cardImageAlt != null ? String(variant.cardImageAlt) : '',
            focalPointX: variant.focalPointX,
            focalPointY: variant.focalPointY,
          };
        }
      }
    } catch (e) {}
  }

  const productCards = section.querySelectorAll(`[data-product-id="${productId}"]`);
  if (productCards.length > 0) {
    const card = productCards[0];
    const variantSelect = card.querySelector('.product-card-variant-select');
    if (variantSelect && variantId) {
      const variantIdStr = String(variantId);
      const option = variantSelect.querySelector(`option[value="${variantIdStr}"], option[value="${variantId}"]`);
      if (option) {
        const canvasImg = option.getAttribute('data-canvas-image') || '';
        const canvasAlt = option.getAttribute('data-canvas-image-alt') || '';
        return {
          id: variantId,
          title: option.textContent.trim(),
          price: option.getAttribute('data-price') || '',
          image: canvasImg,
          imageAlt: canvasAlt || option.getAttribute('data-image-alt') || '',
          hasPersonalizerImage: option.getAttribute('data-personalizer-image') === 'true',
          cardImage: option.getAttribute('data-image') || '',
          cardImageAlt: option.getAttribute('data-image-alt') || '',
          focalPointX: option.getAttribute('data-focal-point-x'),
          focalPointY: option.getAttribute('data-focal-point-y'),
        };
      }
    }
  }
  return null;
}

const PCP_CAPTURE_MIN_WIDTH = 600;
const PCP_CAPTURE_MIN_HEIGHT = 600;
const PCP_CAPTURE_MAX_SCALE = 3;

function getCanvasCaptureScale(captureWidth, captureHeight) {
  const dpr = Math.max(1, window.devicePixelRatio || 1);
  const widthScale = captureWidth > 0 ? PCP_CAPTURE_MIN_WIDTH / captureWidth : 2;
  const heightScale = captureHeight > 0 ? PCP_CAPTURE_MIN_HEIGHT / captureHeight : 2;
  return Math.min(PCP_CAPTURE_MAX_SCALE, Math.max(dpr, widthScale, heightScale, 2));
}

function upgradeShopifyImageUrlForCapture(src, targetWidth) {
  if (!src || typeof src !== 'string') return src;

  const width = Math.max(300, Math.min(2400, Math.round(targetWidth)));
  try {
    const url = new URL(src.startsWith('//') ? 'https:' + src : src);
    if (url.searchParams.has('width')) {
      url.searchParams.set('width', String(width));
      return url.toString().replace(/^https:/, '');
    }
  } catch (e) {}

  return src.replace(/([?&]width=)\d+/i, '$1' + width);
}

function upgradeCaptureImagesForExport(root, targetWidth) {
  if (!root) return false;
  let upgraded = false;
  root.querySelectorAll('img').forEach((img) => {
    if (!img.src) return;
    if (img.complete && img.naturalWidth >= targetWidth * 0.85) return;
    const nextSrc = upgradeShopifyImageUrlForCapture(img.src, targetWidth);
    if (nextSrc !== img.src) {
      img.src = nextSrc;
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      upgraded = true;
    }
  });
  return upgraded;
}

function loadHtml2Canvas() {
  return new Promise((resolve, reject) => {
    if (window.html2canvas) {
      resolve(window.html2canvas);
      return;
    }

    const script = document.createElement('script');
    script.src = 'https://cdnjs.cloudflare.com/ajax/libs/html2canvas/1.4.1/html2canvas.min.js';
    script.onload = () => resolve(window.html2canvas);
    script.onerror = () => reject(new Error('Failed to load html2canvas'));
    document.head.appendChild(script);
  });
}

function waitForImages(element) {
  return new Promise((resolve) => {
    const images = element.querySelectorAll('img');
    if (images.length === 0) {
      resolve();
      return;
    }

    let loaded = 0;
    let errored = 0;
    const total = images.length;

    const checkComplete = () => {
      if (loaded + errored === total) {
        resolve();
      }
    };

    images.forEach((img) => {
      if (img.complete) {
        if (img.naturalWidth > 0) {
          loaded++;
        } else {
          errored++;
        }
        checkComplete();
      } else {
        img.onload = () => {
          loaded++;
          checkComplete();
        };
        img.onerror = () => {
          errored++;
          checkComplete();
        };
      }
    });

    if (loaded + errored === total) {
      resolve();
    }
  });
}

function captureCanvasAsImage(sizeHint) {
  return loadHtml2Canvas()
    .then((html2canvas) => {
      const canvasContent = section.querySelector('.canvas-content');
      if (!canvasContent) {
        throw new Error('Canvas content not found');
      }
      const captureTarget = canvasContent;

      const elementsToHide = [];
      const selectionCounter = canvasContent.querySelector('.selection-counter');
      if (selectionCounter) {
        elementsToHide.push(selectionCounter);
      }
      const removeButtons = canvasContent.querySelectorAll('.remove-btn');
      removeButtons.forEach((btn) => elementsToHide.push(btn));
      const rotateButtons = canvasContent.querySelectorAll('.rotate-btn');
      rotateButtons.forEach((btn) => elementsToHide.push(btn));
      const rotateHandles = canvasContent.querySelectorAll('.canvas-rotate-handle');
      rotateHandles.forEach((handle) => elementsToHide.push(handle));
      const canvasControls = canvasContent.querySelectorAll('.canvas-product-controls');
      canvasControls.forEach((control) => elementsToHide.push(control));
      canvasContent.querySelectorAll('.canvas-engraving-empty').forEach((el) => elementsToHide.push(el));
      canvasContent.querySelectorAll('.pcp-capture-overlay').forEach((el) => elementsToHide.push(el));
      if (getCanvasCharmProductCount() === 0) {
        canvasContent.querySelectorAll('.chain-focal-marker').forEach((marker) => elementsToHide.push(marker));
      }
      const restoreHidden = hideElementsForCapture(elementsToHide);

      const originalError = console.error;
      const originalWarn = console.warn;
      const originalDefine = window.customElements?.define;

      return waitForImages(captureTarget)
        .then(() => {
          layoutPcpCharms();
          const rect = captureTarget.getBoundingClientRect();
          let captureWidth = Math.round(rect.width || captureTarget.offsetWidth || 0);
          let captureHeight = Math.round(rect.height || captureTarget.offsetHeight || 0);
          if (
            sizeHint &&
            sizeHint.width > 1 &&
            sizeHint.height > 1 &&
            (captureWidth < 2 || captureHeight < 2)
          ) {
            captureWidth = sizeHint.width;
            captureHeight = sizeHint.height;
          }
          if (captureWidth < 2 || captureHeight < 2) {
            const parentEl = captureTarget.parentElement;
            if (parentEl) {
              const pr = parentEl.getBoundingClientRect();
              captureWidth = Math.max(captureWidth, Math.round(pr.width) || 320);
              captureHeight = Math.max(captureHeight, Math.round(pr.height) || 240);
            }
          }
          if (captureWidth < 2 || captureHeight < 2) {
            captureWidth = Math.max(captureWidth, 600);
            captureHeight = Math.max(captureHeight, 400);
          }
          if (captureWidth < 2 || captureHeight < 2) {
            restoreHidden();
            throw new Error('Canvas has zero dimensions');
          }
          
          if (window.customElements) {
            window.customElements.define = function() {
              try {
                return originalDefine.apply(window.customElements, arguments);
              } catch (e) {
                return;
              }
            };
          }
          
          console.error = function(...args) {
            const errorMsg = args[0]?.toString() || '';
            if (errorMsg.includes('addEventListener') || 
                errorMsg.includes('innerHTML') ||
                errorMsg.includes('MenuDisclosure') ||
                errorMsg.includes('DropdownMenuDisclosure') ||
                errorMsg.includes('QuantityInput') ||
                errorMsg.includes('Cannot read properties of null')) {
              return;
            }
            originalError.apply(console, args);
          };
          
          console.warn = function(...args) {
            const warnMsg = args[0]?.toString() || '';
            if (warnMsg.includes('html2canvas') || warnMsg.includes('clone')) {
              return;
            }
            originalWarn.apply(console, args);
          };

          const tempContainer = document.createElement('div');
          tempContainer.classList.add('shopify-section--product-customizer-panel');
          tempContainer.style.position = 'absolute';
          tempContainer.style.left = '-9999px';
          tempContainer.style.top = '-9999px';
          tempContainer.style.width = captureWidth + 'px';
          tempContainer.style.height = captureHeight + 'px';
          tempContainer.style.backgroundColor = '#fbf8f2';
          document.body.appendChild(tempContainer);
          
          const clonedCanvas = captureTarget.cloneNode(true);
          clonedCanvas.style.width = captureWidth + 'px';
          clonedCanvas.style.height = captureHeight + 'px';
          clonedCanvas.style.boxSizing = 'border-box';
          const customizerCanvasEl = section.querySelector('.customizer-canvas');
          const captureRoot = document.createElement('div');
          if (customizerCanvasEl && customizerCanvasEl.className) {
            captureRoot.className = customizerCanvasEl.className;
          } else {
            captureRoot.className = 'customizer-canvas';
          }
          captureRoot.style.boxSizing = 'border-box';
          captureRoot.style.width = captureWidth + 'px';
          captureRoot.style.height = captureHeight + 'px';
          captureRoot.style.padding = '0';
          captureRoot.style.margin = '0';
          captureRoot.style.background = '#fbf8f2';
          captureRoot.style.position = 'relative';
          captureRoot.appendChild(clonedCanvas);
          tempContainer.appendChild(captureRoot);

          const captureScale = getCanvasCaptureScale(captureWidth, captureHeight);
          const captureImageWidth = Math.round(captureWidth * captureScale);
          const imagesUpgraded = upgradeCaptureImagesForExport(clonedCanvas, captureImageWidth);

          const scriptsInClone = clonedCanvas.querySelectorAll('script');
          scriptsInClone.forEach((script) => script.remove());
          
          const customElementsInClone = clonedCanvas.querySelectorAll(
            'menu-disclosure, dropdown-menu, quantity-input, cart-notification, notification-banner, cart-drawer, product-form, [is="menu-disclosure"], [is="dropdown-menu"], [is="quantity-input"]'
          );
          customElementsInClone.forEach((el) => {
            try {
              el.remove();
            } catch (e) {}
          });

          const cloneImagesReady = imagesUpgraded
            ? waitForImages(clonedCanvas)
            : Promise.resolve();

          return cloneImagesReady.then(() => {
            return html2canvas(captureRoot, {
            backgroundColor: '#fbf8f2',
            useCORS: true,
            allowTaint: false,
            scale: captureScale,
            logging: false,
            width: captureWidth,
            height: captureHeight,
            foreignObjectRendering: false,
            removeContainer: true,
            onclone: function (clonedDoc, clonedElement) {
              try {
                if (!clonedDoc) return;

                const scripts = clonedDoc.querySelectorAll('script');
                scripts.forEach((script) => {
                  try {
                    script.remove();
                  } catch (e) {}
                });

                clonedDoc.querySelectorAll('.pcp-capture-overlay').forEach((el) => {
                  try {
                    el.remove();
                  } catch (e) {}
                });

                clonedDoc.querySelectorAll('.canvas-engraving-empty').forEach((el) => {
                  try {
                    el.remove();
                  } catch (e) {}
                });

                const canvasContentEl =
                  (clonedElement && clonedElement.querySelector('.canvas-content')) ||
                  clonedDoc.querySelector('.canvas-content');
                if (canvasContentEl) {
                  void canvasContentEl.offsetHeight;
                  layoutPcpCharms(canvasContentEl, { skipControls: true });
                }
                const container = canvasContentEl || clonedElement || clonedDoc.querySelector('.canvas-content');
                const charmItems = container ? container.querySelectorAll('.canvas-product-item:not(.chain-item)') : [];
                if (charmItems.length === 0) {
                  (container || clonedDoc).querySelectorAll('.chain-focal-marker').forEach((el) => {
                    try {
                      el.remove();
                    } catch (e) {}
                  });
                }
                const layoutRect = container ? container.getBoundingClientRect() : null;
                const w = layoutRect && layoutRect.width > 1 ? layoutRect.width : captureWidth;
                const h = layoutRect && layoutRect.height > 1 ? layoutRect.height : captureHeight;
                charmItems.forEach((item) => {
                  try {
                    item.style.mixBlendMode = 'darken';
                    const img = item.querySelector('img');
                    if (img) {
                      img.style.mixBlendMode = 'darken';
                    }
                    item.querySelectorAll('.canvas-engraving-badge').forEach((badge) => {
                      badge.style.maxWidth = 'none';
                      badge.style.width = 'fit-content';
                      badge.style.overflow = 'visible';
                      badge.style.overflowX = 'visible';
                      badge.style.overflowY = 'visible';
                      badge.style.padding = '3px';
                      badge.style.lineHeight = '0';
                      badge.style.minHeight = 'auto';
                      badge.style.alignItems = 'start';
                      badge.style.justifyContent = 'flex-start';
                      badge.style.gap = '0';
                      const textEl = badge.querySelector('.canvas-engraving-badge-text');
                      if (textEl) {
                        textEl.style.display = 'inline-flex';
                        textEl.style.alignItems = 'start';
                        textEl.style.height = 'auto';
                        textEl.style.lineHeight = '0';
                        textEl.style.overflow = 'visible';
                        textEl.style.maxWidth = 'none';
                        textEl.style.textOverflow = 'clip';
                        textEl.style.margin = '0';
                        textEl.style.padding = '0';
                      }
                      const markEl = badge.querySelector('.canvas-engraving-badge-mark');
                      if (markEl) {
                        markEl.style.flexShrink = '0';
                        markEl.style.lineHeight = '0';
                        markEl.style.lineHeight = '0';
                        markEl.style.marginRight = '3px';
                        markEl.style.alignItems = 'start';
                        markEl.style.lineHeight = '0';
                      }
                    });
                    let pctX = 50;
                    let pctY = 50;
                    if (item.style.left && typeof item.style.left === 'string' && item.style.left.endsWith('%')) {
                      pctX = parseFloat(item.style.left) || 50;
                    }
                    if (item.style.top && typeof item.style.top === 'string' && item.style.top.endsWith('%')) {
                      pctY = parseFloat(item.style.top) || 50;
                    }
                    const leftPx = (pctX / 100) * w;
                    const topPx = (pctY / 100) * h;
                    item.style.left = leftPx + 'px';
                    item.style.top = topPx + 'px';
                  } catch (e) {}
                });
              } catch (error) {
                console.warn('Error in html2canvas onclone:', error);
              }
            },
            ignoreElements: function (element) {
              if (!element || !element.classList) return false;
              
              return (
                element.classList.contains('selection-counter') ||
                element.classList.contains('remove-btn') ||
                element.classList.contains('rotate-btn') ||
                element.classList.contains('canvas-rotate-handle') ||
                element.classList.contains('canvas-product-controls') ||
                element.classList.contains('canvas-engraving-empty') ||
                element.classList.contains('pcp-capture-overlay') ||
                element.classList.contains('pcp-spinner') ||
                element.classList.contains('pcp-spinner__icon') ||
                element.classList.contains('pcp-spinner__text') ||
                element.tagName === 'SCRIPT' ||
                element.tagName === 'MENU-DISCLOSURE' ||
                element.tagName === 'DROPDOWN-MENU' ||
                element.tagName === 'QUANTITY-INPUT' ||
                element.tagName === 'CART-NOTIFICATION' ||
                element.tagName === 'NOTIFICATION-BANNER' ||
                element.getAttribute('is') === 'menu-disclosure' ||
                element.getAttribute('is') === 'dropdown-menu' ||
                element.getAttribute('is') === 'quantity-input'
              );
            },
          })
            .then((canvas) => {
              try {
                if (tempContainer && tempContainer.parentNode) {
                  tempContainer.parentNode.removeChild(tempContainer);
                }
              } catch (e) {}
              
              console.error = originalError;
              console.warn = originalWarn;
              
              if (window.customElements && originalDefine) {
                window.customElements.define = originalDefine;
              }
              
              restoreHidden();

              if (!canvas) {
                throw new Error('Failed to create canvas');
              }

              const dataUrl = canvas.toDataURL('image/png');
              if (!dataUrl || dataUrl === 'data:,') {
                throw new Error('Invalid image data');
              }

              return dataUrl;
            })
            .catch((error) => {
              try {
                if (tempContainer && tempContainer.parentNode) {
                  tempContainer.parentNode.removeChild(tempContainer);
                }
              } catch (e) {}
              
              console.error = originalError;
              console.warn = originalWarn;
              
              if (window.customElements && originalDefine) {
                window.customElements.define = originalDefine;
              }
              
              restoreHidden();
              throw error;
            });
          });
        })
        .catch((error) => {
          console.error = originalError;
          console.warn = originalWarn;
          
          if (window.customElements && originalDefine) {
            window.customElements.define = originalDefine;
          }
          
          restoreHidden();
          throw error;
        });
    })
    .catch((error) => {
      if (typeof originalError !== 'undefined') {
        console.error = originalError;
      }
      if (typeof originalWarn !== 'undefined') {
        console.warn = originalWarn;
      }
      if (window.customElements && typeof originalDefine !== 'undefined' && originalDefine) {
        window.customElements.define = originalDefine;
      }
      console.error('Canvas capture error:', error);
      throw error;
    });
}

let capturedCanvasImageData = null;

function setReviewCanvasLoading(container) {
  if (!container) return;
  container.innerHTML =
    '<div class="pcp-review-canvas-loading" role="status" aria-live="polite">' +
    '<div class="pcp-spinner"><div class="pcp-spinner__icon"></div>' +
    '<p class="pcp-spinner__text">Generating preview…</p></div></div>';
}

function setReviewCanvasImage(container, imageDataUrl) {
  if (!container) return;
  container.innerHTML = '';
  const canvasImage = document.createElement('img');
  canvasImage.src = imageDataUrl;
  canvasImage.alt = 'Customized jewelry';
  canvasImage.classList.add('pcp-review-image');
  canvasImage.decoding = 'async';
  canvasImage.onerror = function () {
    console.error('Failed to load captured image');
    container.innerHTML =
      '<p class="pcp-empty-message">' + getPcpMessage('canvasPreviewFailed') + '</p>';
  };
  container.appendChild(canvasImage);
}

function exitReviewMobileFullscreen() {
  if (!productCustomizerWrapper) return;
  if (!productCustomizerWrapper.classList.contains('pcp-mobile-canvas-fullscreen')) return;
  productCustomizerWrapper.classList.remove('pcp-mobile-canvas-fullscreen');
  const fsHintEl = section.querySelector('.canvas-fullscreen-drag-hint');
  const sheetHandleBtn = section.querySelector('.mobile-sheet-handle');
  if (fsHintEl) fsHintEl.hidden = true;
  if (sheetHandleBtn) sheetHandleBtn.setAttribute('aria-expanded', 'true');
}

function prepareCustomizerForCapture() {
  if (!productCustomizerWrapper) return;
  exitReviewMobileFullscreen();
  productCustomizerWrapper.classList.remove('pcp-hidden');
  productCustomizerWrapper.classList.add('pcp-capture-source');
}

function hideCustomizerAfterReview() {
  if (!productCustomizerWrapper) return;
  productCustomizerWrapper.classList.remove('pcp-capture-source');
  setHidden(productCustomizerWrapper, true);
}

function openReviewLayout(options) {
  if (!reviewView || !productCustomizerWrapper) return;
  const keepCustomizerForCapture = options && options.keepCustomizerForCapture;
  if (keepCustomizerForCapture) {
    prepareCustomizerForCapture();
  } else {
    exitReviewMobileFullscreen();
    hideCustomizerAfterReview();
  }
  setHidden(reviewView, false);
  if (typeof reviewView.scrollIntoView === 'function') {
    requestAnimationFrame(function () {
      reviewView.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }
}

function beginReview(triggerBtn) {
  if (!triggerBtn || triggerBtn.disabled) return Promise.resolve();
  setButtonLoading(triggerBtn, true, REVIEW_BTN_LOADING_HTML);
  triggerBtn.setAttribute('aria-busy', 'true');
  return new Promise(function (resolve) {
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        showReviewView().finally(function () {
          setButtonLoading(triggerBtn, false);
          triggerBtn.removeAttribute('aria-busy');
          resolve();
        });
      });
    });
  });
}

function showReviewView() {
  if (!reviewView || !productCustomizerWrapper) return Promise.resolve();

  const selectedProducts = getAllSelectedProducts();
  const reviewCanvasContainer = reviewView.querySelector('.review-canvas-products-container');
  const reviewProductsList = reviewView.querySelector('.review-products-list');
  const reviewTotalPrice = reviewView.querySelector('.review-total-price');
  const canvasContent = section.querySelector('.canvas-content');
  const captureSizeHint = canvasContent
    ? {
        width: Math.max(
          1,
          Math.round(canvasContent.getBoundingClientRect().width || canvasContent.offsetWidth || 0)
        ),
        height: Math.max(
          1,
          Math.round(canvasContent.getBoundingClientRect().height || canvasContent.offsetHeight || 0)
        ),
      }
    : null;

  if (reviewProductsList) {
    reviewProductsList.innerHTML = '';

    const reviewContent = reviewView.querySelector('.review-content');
    appendReviewFinalSaleNotice(reviewContent);

    if (selectedProducts.length === 0) {
      const emptyMessage = document.createElement('p');
      emptyMessage.className = 'pcp-empty-message';
      emptyMessage.textContent = getPcpMessage('reviewNoProducts');
      reviewProductsList.appendChild(emptyMessage);
    } else {
    const priceTrim = function (v) {
      if (v == null || v === '') return '';
      return String(v).trim();
    };

    let totalPrice = 0;

    const chainProducts = selectedProducts.filter((p) => p.type === 'chain');
    const charmProducts = selectedProducts.filter((p) => p.type === 'charm');

    chainProducts.forEach((productData) => {
      productData.price = normalizeCustomizerProductPrice(
        productData.price,
        productData.productId,
        productData.variantId
      );
      const productInfo = getProductData(productData.productId);
      let variantInfo = null;
      if (productData.variantId) {
        variantInfo = getVariantData(productData.productId, productData.variantId);
      }

      const productItem = document.createElement('div');
      productItem.className = 'review-product-item';

      const image = document.createElement('img');
      image.className = 'review-product-image';
      image.src = productData.imageSrc || productInfo?.image || '';
      image.alt = productData.title || productInfo?.title || '';
      productItem.appendChild(image);

      const details = document.createElement('div');
      details.className = 'review-product-details';

      const title = document.createElement('h4');
      title.className = 'review-product-title';
      title.textContent = productData.title || productInfo?.title || 'Product';
      details.appendChild(title);

      const finalSaleBadge = document.createElement('span');
      finalSaleBadge.className = 'review-product-final-sale';
      finalSaleBadge.textContent = 'Final Sale';
      details.appendChild(finalSaleBadge);

      const metalStep = steps.find((step) => {
        const stepTitle = step.querySelector('.step-title');
        if (stepTitle) {
          const titleText = stepTitle.textContent.toLowerCase();
          return titleText.includes('metal') || titleText.includes('choose metal');
        }
        return false;
      });
      if (metalStep) {
        const selectedMetalButton = metalStep.querySelector('.option-button.selected');
        if (selectedMetalButton) {
          const metalText = document.createElement('p');
          metalText.className = 'review-product-variant';
          metalText.textContent = 'Metal: ' + selectedMetalButton.textContent.trim();
          details.appendChild(metalText);
        }
      }

      const chainLengthStep = steps.find((step) => {
        const stepTitle = step.querySelector('.step-title');
        if (stepTitle) {
          const titleText = stepTitle.textContent.toLowerCase();
          return (
            titleText.includes('chain length') ||
            (titleText.includes('length') && !titleText.includes('chain') && !titleText.includes('size'))
          );
        }
        return false;
      });
      let chainVariantText = '';
      if (productData.variantTitle && String(productData.variantTitle).trim() !== '') {
        chainVariantText = String(productData.variantTitle).trim();
      } else if (variantInfo && variantInfo.title) {
        chainVariantText = variantInfo.title;
      }
      if (chainVariantText) {
        const variant = document.createElement('p');
        variant.className = 'review-product-variant';
        variant.textContent = 'Size: ' + chainVariantText;
        details.appendChild(variant);
      }

      const price = document.createElement('p');
      price.className = 'review-product-price';
      let priceText = '$0.00';
      if (priceTrim(productData.price)) {
        priceText = priceTrim(productData.price);
      } else if (priceTrim(variantInfo && variantInfo.price)) {
        priceText = priceTrim(variantInfo.price);
      } else if (priceTrim(productInfo && productInfo.price)) {
        priceText = priceTrim(productInfo.price);
      }
      price.textContent = priceText;
      details.appendChild(price);
      let priceValue = 0;
      if (priceTrim(productData.price)) {
        priceValue = parsePrice(priceTrim(productData.price));
      } else if (priceTrim(variantInfo && variantInfo.price)) {
        priceValue = parsePrice(priceTrim(variantInfo.price));
      } else if (priceTrim(productInfo && productInfo.price)) {
        priceValue = parsePrice(priceTrim(productInfo.price));
      }
      totalPrice += priceValue;

      productItem.appendChild(details);
      reviewProductsList.appendChild(productItem);
      productItem.appendChild(price);
    });

    if (charmProducts.length > 0) {
      const addOnsTitle = document.createElement('h4');
      addOnsTitle.className = 'review-section-title';
      addOnsTitle.textContent = 'Add Ons';
      reviewProductsList.appendChild(addOnsTitle);
    }

    charmProducts.forEach((productData) => {
      productData.price = normalizeCustomizerProductPrice(
        productData.price,
        productData.productId,
        productData.variantId
      );
      const productItem = document.createElement('div');
      productItem.className = 'review-product-item';

      const productInfo = getProductData(productData.productId);
      let variantInfo = null;
      let variantText = null;

      if (productData.variantTitle && String(productData.variantTitle).trim() !== '') {
        variantText = String(productData.variantTitle).trim();
      } else if (productData.variantId) {
        variantInfo = getVariantData(productData.productId, productData.variantId);
        if (variantInfo && variantInfo.title) {
          variantText = variantInfo.title;
          productData.variantTitle = variantInfo.title;
        }
      }
      
      const charmSelectors = getCharmSelectors();
      let storedVariantId = productData.variantId;
      
      charmSelectors.forEach((selector) => {
        const selectorSelectedProducts = selector._selectedProducts || [];
        const storedProduct = selectorSelectedProducts.find(
          (p) => p.productId === productData.productId && 
                 (p.id === productData.id || (p.title === productData.title && p.imageSrc === productData.imageSrc))
        );
        if (storedProduct && storedProduct.variantId) {
          storedVariantId = storedProduct.variantId;
        }
      });
      
      if (!variantText && storedVariantId) {
        variantInfo = getVariantData(productData.productId, storedVariantId);
        if (variantInfo && variantInfo.title) {
          variantText = variantInfo.title;
          productData.variantTitle = variantInfo.title;
        }
      }
      
      if (!variantText) {
        const productCards = section.querySelectorAll(`[data-product-id="${productData.productId}"]`);
        
        for (let i = 0; i < productCards.length; i++) {
          const card = productCards[i];
          const variantSelect = card.querySelector('.product-card-variant-select');
          
          if (variantSelect) {
            if (storedVariantId) {
              const variantIdStr = String(storedVariantId);
              const option = variantSelect.querySelector(`option[value="${variantIdStr}"], option[value="${storedVariantId}"]`);
              if (option) {
                variantText = option.textContent.trim();
                break;
              }
            }
            
            if (!variantText && variantSelect.value && variantSelect.value !== '' && variantSelect.value !== 'null') {
              const selectedOption = variantSelect.options[variantSelect.selectedIndex];
              if (selectedOption && selectedOption.value && selectedOption.value !== '') {
                variantText = selectedOption.textContent.trim();
                break;
              }
            }
            
            if (!variantText && variantSelect.options.length > 0) {
              for (let j = 0; j < variantSelect.options.length; j++) {
                const option = variantSelect.options[j];
                if (option.value && option.value !== '' && option.value !== 'null') {
                  variantText = option.textContent.trim();
                  break;
                }
              }
            }
            
            if (variantText) break;
          }
        }
      }
      
      if (!variantText) {
        (async () => {
          try {
            const defaultVariantId = await getDefaultVariantId(productData.productId);
            if (defaultVariantId) {
              variantInfo = getVariantData(productData.productId, defaultVariantId);
              if (variantInfo && variantInfo.title) {
                const variantTextElement = productItem.querySelector('.review-product-variant');
                if (variantTextElement) {
                  variantTextElement.textContent = variantInfo.title;
                }
              }
            }
          } catch (e) {
            console.warn('Error getting default variant for review:', e);
          }
        })();
      }

      const image = document.createElement('img');
      image.className = 'review-product-image';
      image.src = productData.imageSrc || productInfo?.image || '';
      image.alt = productData.title || productInfo?.title || '';
      productItem.appendChild(image);

      const details = document.createElement('div');
      details.className = 'review-product-details';

      const title = document.createElement('h4');
      title.className = 'review-product-title';
      title.textContent = productData.title || productInfo?.title || 'Product';
      details.appendChild(title);

      if (variantText) {
        const variant = document.createElement('p');
        variant.className = 'review-product-variant';
        variant.textContent = variantText;
        details.appendChild(variant);
      }

      const engravingTrim = normalizeEngravingText(
        productData.engravingText,
        resolveEngravingMaxChars(productData.productId, productData)
      );
      if (engravingTrim !== '') {
        const engraving = document.createElement('div');
        engraving.className = 'review-product-engraving';
        const head = document.createElement('span');
        head.className = 'review-product-engraving-label';
        head.textContent = 'Engraving: ';
        const body = document.createElement('span');
        body.className = 'review-product-engraving-text';
        const reviewFontClass = getEngravingFontModifierClass(
          productData.engravingFont != null ? String(productData.engravingFont) : ''
        );
        if (reviewFontClass) body.classList.add(reviewFontClass);
        body.textContent = engravingTrim;
        engraving.appendChild(head);
        engraving.appendChild(body);
        const fontTrim =
          productData.engravingFont != null ? String(productData.engravingFont).trim() : '';
        if (fontTrim !== '') {
          const fontSpan = document.createElement('span');
          fontSpan.className = 'review-product-engraving-font';
          fontSpan.textContent = ' (' + fontTrim + ')';
          engraving.appendChild(fontSpan);
        }
        details.appendChild(engraving);
      }

      const price = document.createElement('p');
      price.className = 'review-product-price';
      let priceText = '$0.00';
      if (priceTrim(productData.price)) {
        priceText = priceTrim(productData.price);
      } else if (priceTrim(variantInfo && variantInfo.price)) {
        priceText = priceTrim(variantInfo.price);
      } else if (priceTrim(productInfo && productInfo.price)) {
        priceText = priceTrim(productInfo.price);
      }
      price.textContent = priceText;
      details.appendChild(price);

      let priceValue = 0;
      if (priceTrim(productData.price)) {
        priceValue = parsePrice(priceTrim(productData.price));
      } else if (priceTrim(variantInfo && variantInfo.price)) {
        priceValue = parsePrice(priceTrim(variantInfo.price));
      } else if (priceTrim(productInfo && productInfo.price)) {
        priceValue = parsePrice(priceTrim(productInfo.price));
      }
      totalPrice += priceValue;

      productItem.appendChild(details);
      productItem.appendChild(price);
      reviewProductsList.appendChild(productItem);
    });

    appendReviewProductWarnings(reviewProductsList);

    if (reviewTotalPrice) {
      let samplePrice = '';
      if (chainProducts.length > 0 && chainProducts[0].price) {
        samplePrice = chainProducts[0].price;
      } else if (charmProducts.length > 0 && charmProducts[0].price) {
        samplePrice = charmProducts[0].price;
      }

      const totalPriceText = formatPrice(totalPrice, samplePrice);
      reviewTotalPrice.textContent = totalPriceText;
      const addToCartTotal = reviewView.querySelector('.review-add-to-cart-total');
      if (addToCartTotal) {
        addToCartTotal.textContent = totalPriceText;
      }
    }
    }
  }

  setReviewCanvasLoading(reviewCanvasContainer);
  openReviewLayout({ keepCustomizerForCapture: true });

  if (!canvasContent) {
    if (reviewCanvasContainer) {
      reviewCanvasContainer.innerHTML =
        '<p class="pcp-empty-message">' + getPcpMessage('canvasNotFound') + '</p>';
    }
    hideCustomizerAfterReview();
    return Promise.resolve();
  }

  layoutPcpCharms();
  return captureCanvasAsImage(captureSizeHint)
    .then(function (imageDataUrl) {
      if (!imageDataUrl || imageDataUrl === 'data:,') {
        throw new Error('Invalid image data');
      }
      capturedCanvasImageData = imageDataUrl;
      setReviewCanvasImage(reviewCanvasContainer, imageDataUrl);
    })
    .catch(function (error) {
      console.error('Error capturing canvas:', error);
      capturedCanvasImageData = null;
      if (reviewCanvasContainer) {
        reviewCanvasContainer.innerHTML =
          '<p class="pcp-empty-message">' + getPcpMessage('canvasPreviewRetry') + '</p>';
      }
    })
    .finally(hideCustomizerAfterReview);
}

if (reviewBackButton) {
  reviewBackButton.addEventListener('click', function () {
    if (reviewView && productCustomizerWrapper) {
      setHidden(reviewView, true);
      productCustomizerWrapper.classList.remove('pcp-capture-source');
      setHidden(productCustomizerWrapper, false);
      if (productCustomizerWrapper.classList.contains('pcp-mobile-canvas-fullscreen')) {
        productCustomizerWrapper.classList.remove('pcp-mobile-canvas-fullscreen');
        const fsHintReturn = section.querySelector('.canvas-fullscreen-drag-hint');
        const sheetHandleReturn = section.querySelector('.mobile-sheet-handle');
        if (fsHintReturn) fsHintReturn.hidden = true;
        if (sheetHandleReturn) sheetHandleReturn.setAttribute('aria-expanded', 'true');
      }
    }
  });
}

function dataURLtoFile(dataurl, filename) {
  const arr = dataurl.split(',');
  const mime = arr[0].match(/:(.*?);/)[1];
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], filename, { type: mime });
}

const reviewAddToCartButton = section.querySelector('.review-add-to-cart-button');

function openCartAfterAdd(fallbackToCartPage) {
  if (window.Rebuy && window.Rebuy.SmartCart && typeof window.Rebuy.SmartCart.show === 'function') {
    if (window.Rebuy.Cart && typeof window.Rebuy.Cart.fetchShopifyCart === 'function') {
      window.Rebuy.Cart.fetchShopifyCart(function () {
        window.Rebuy.SmartCart.show();
      });
    } else {
      window.Rebuy.SmartCart.show();
    }
    return;
  }

  const cartDrawer = document.getElementById('cart-drawer');
  if (cartDrawer) {
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:refresh', {
        bubbles: true,
      })
    );

    setTimeout(function () {
      if (typeof cartDrawer.show === 'function') {
        cartDrawer.show();
      } else if (cartDrawer.open && typeof cartDrawer.open === 'function') {
        cartDrawer.open();
      } else {
        cartDrawer.setAttribute('open', '');
      }
    }, 200);
    return;
  }

  if (fallbackToCartPage) {
    window.location.href = '/cart';
  }
}

async function resolveValidatedVariant(productData) {
  let variantId = resolveProductVariantId(productData);
  if (!variantId || variantId === 'null' || variantId === '' || variantId === null) {
    variantId = await getDefaultVariantId(productData.productId);
  }

  variantId = variantId ? String(variantId).trim() : '';
  if (!variantId || !/^\d+$/.test(variantId)) {
    return {
      ok: false,
      productData,
      error:
        'Could not resolve variant for this product. Please ensure the product is selected from the customizer.',
    };
  }

  return {
    ok: true,
    productData,
    variantId,
  };
}

function appendCharmPlacementToCartProperties(properties, productData) {
  if (!properties || !productData || productData.type === 'chain') return;

  const position = productData.position;
  if (
    position &&
    typeof position.x === 'number' &&
    !Number.isNaN(position.x) &&
    typeof position.y === 'number' &&
    !Number.isNaN(position.y)
  ) {
    const serializedPosition = {
      x: position.x,
      y: position.y,
    };
    if (position.relativeTo === 'chain') {
      serializedPosition.relativeTo = 'chain';
    }
    properties['_Position'] = JSON.stringify(serializedPosition);
    properties['_Rotation'] = String(productData.rotation || 0);
  } else if (productData.rotation) {
    properties['_Rotation'] = String(productData.rotation);
  }
}

function buildCustomizerCartProperties(productData, variantId, customizerGroupId, options) {
  const cartOptions = options || {};
  const properties = {
    '_Customizer Group': customizerGroupId,
    '_Customizer Return URL': window.location.pathname + window.location.search,
  };

  if (productData.type) {
    properties['_Customizer Type'] = String(productData.type);
  }

  if (
    productData.engravingText !== undefined &&
    productData.engravingText !== null &&
    normalizeEngravingText(
      productData.engravingText,
      resolveEngravingMaxChars(productData.productId, productData)
    ) !== ''
  ) {
    properties['Engraving'] = normalizeEngravingText(
      productData.engravingText,
      resolveEngravingMaxChars(productData.productId, productData)
    );
  }

  if (
    productData.engravingFont !== undefined &&
    productData.engravingFont !== null &&
    String(productData.engravingFont).trim() !== ''
  ) {
    properties['Engraving Font'] = String(productData.engravingFont).trim();
  }

  if (productData.id != null && String(productData.id).trim() !== '') {
    properties['_Customizer Instance'] = String(productData.id).trim();
  }

  let variantLabel =
    productData.variantTitle != null ? String(productData.variantTitle).trim() : '';
  if (!variantLabel && productData.productId && variantId) {
    const variantData = getVariantData(productData.productId, variantId);
    if (variantData && variantData.title) {
      variantLabel = String(variantData.title).trim();
    }
  }
  if (variantLabel && variantLabel !== 'Default Title') {
    properties['_Variant Label'] = decodeHtmlEntities(variantLabel);
  }

  if (productData.imageSrc != null && String(productData.imageSrc).trim() !== '') {
    properties['_Canvas Image'] = getOriginalImageUrl(String(productData.imageSrc).trim());
  }

  if (productData.hasPersonalizerImage) {
    properties['_Has Personalizer Image'] = 'true';
  }

  if (productData.price != null && String(productData.price).trim() !== '') {
    properties['_Price Display'] = String(productData.price).trim();
  }

  appendCharmPlacementToCartProperties(properties, productData);

  if (productData.type === 'chain' && cartOptions.selectionsSnapshot) {
    properties['_Customizer Selections'] = cartOptions.selectionsSnapshot;
  }

  if (cartOptions.finalSaleAccepted) {
    const finalSaleConfig = getFinalSaleAgreementConfig();
    properties[finalSaleConfig.propertyKey] = finalSaleConfig.acceptedValue;
  }

  return properties;
}

function appendCustomizerDesignToFormData(formData, imageFile, canvasImageData) {
  if (imageFile) {
    formData.append('properties[Customized Design]', imageFile, 'customized-design.png');
    return true;
  }

  if (canvasImageData) {
    const imageDataLength = canvasImageData.length;
    if (imageDataLength > 500000) {
      console.warn('Canvas image data is very large, may cause issues. Consider compressing.');
    }
    formData.append('properties[Customized Design]', canvasImageData);
    return true;
  }

  return false;
}

async function parseCartAddError(response, productData, variantId) {
  let errorMessage = 'Failed to add product to cart';
  try {
    const error = await response.json();

    if (typeof error.errors === 'string') {
      errorMessage = error.errors;
    } else if (error.description) {
      errorMessage = error.description;
    } else if (error.message) {
      errorMessage = error.message;
    } else if (error.errors && typeof error.errors === 'object') {
      errorMessage = JSON.stringify(error.errors);
    }

    console.error('Cart add error response:', error);
    console.error('Failed product data:', {
      variantId: variantId,
      productId: productData.productId,
      title: productData.title,
      variantIdType: typeof variantId,
    });
    console.error('Response status:', response.status, response.statusText);
  } catch (e) {
    console.error('Cart add failed with status:', response.status, response.statusText);
    console.error('Failed to parse error response');
  }

  return errorMessage;
}

async function addCustomizerProductViaFormData(
  productData,
  variantId,
  customizerGroupId,
  attachDesign,
  imageFile,
  cartOptions
) {
  const formData = new FormData();
  formData.append('id', variantId);
  formData.append('quantity', '1');

  const properties = buildCustomizerCartProperties(
    productData,
    variantId,
    customizerGroupId,
    cartOptions
  );
  Object.entries(properties).forEach(([key, value]) => {
    formData.append('properties[' + key + ']', value);
  });

  if (attachDesign) {
    appendCustomizerDesignToFormData(formData, imageFile, capturedCanvasImageData);
  }

  const response = await fetch('/cart/add.js', {
    method: 'POST',
    body: formData,
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
    },
  });

  if (!response.ok) {
    return {
      ok: false,
      error: await parseCartAddError(response, productData, variantId),
    };
  }

  const result = await response.json();
  const lineItemKey =
    result.key || (result.items && result.items[result.items.length - 1]?.key) || null;

  return {
    ok: true,
    key: lineItemKey,
  };
}

async function addCustomizerProductsViaBulk(entries, customizerGroupId, cartOptions) {
  const items = entries.map(({ productData, variantId }) => ({
    id: parseInt(variantId, 10),
    quantity: 1,
    properties: buildCustomizerCartProperties(
      productData,
      variantId,
      customizerGroupId,
      cartOptions
    ),
  }));

  const response = await fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
    },
    body: JSON.stringify({ items }),
  });

  if (!response.ok) {
    const failedEntry = entries[0];
    return {
      ok: false,
      error: await parseCartAddError(
        response,
        failedEntry.productData,
        failedEntry.variantId
      ),
    };
  }

  const result = await response.json();
  const resultItems = Array.isArray(result.items)
    ? result.items
    : result.key
      ? [result]
      : [];

  return {
    ok: true,
    items: entries.map((entry, index) => ({
      productData: entry.productData,
      variantId: entry.variantId,
      key: resultItems[index]?.key || resultItems[resultItems.length - 1]?.key || null,
    })),
  };
}

async function removePendingCartEditGroup() {
  let keys = [];
  try {
    const keysRaw = sessionStorage.getItem('pcp-cart-edit-keys');
    if (keysRaw) {
      const parsed = JSON.parse(keysRaw);
      if (Array.isArray(parsed)) {
        keys = parsed.filter(Boolean);
      }
    }
  } catch (e) {
    sessionStorage.removeItem('pcp-cart-edit-keys');
    sessionStorage.removeItem('pcp-cart-edit');
    return;
  }

  sessionStorage.removeItem('pcp-cart-edit-keys');
  sessionStorage.removeItem('pcp-cart-edit');
  sessionStorage.removeItem('pcp-cart-edit-restore');

  if (!keys.length) {
    delete section.dataset.pcpCartEditRestored;
    return;
  }

  const updates = {};
  keys.forEach(function (key) {
    updates[key] = 0;
  });

  const cartRoot =
    window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';
  const response = await fetch(cartRoot + 'cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
    },
    body: JSON.stringify({ updates: updates }),
  });

  if (response.ok) {
    delete section.dataset.pcpCartEditRestored;
  }
}

async function proceedWithAddToCart(button, cartOptions) {
  const addToCartOptions = cartOptions || {};
  const selectedProducts = getAllSelectedProducts();

  setButtonLoading(button, true, 'Adding to cart...');

  const validationResults = await Promise.all(
    selectedProducts.map(resolveValidatedVariant)
  );

  const validatedProducts = [];
  const validationErrors = [];

  validationResults.forEach((result) => {
    if (result.ok) {
      validatedProducts.push({
        productData: result.productData,
        variantId: result.variantId,
      });
      return;
    }

    validationErrors.push({
      product: result.productData,
      error: result.error,
    });
  });

  if (validationErrors.length > 0) {
    const errorMessages = validationErrors.map(e => `${e.product.title || 'Unknown'}: ${e.error}`).join('\n');
    showTransitionAlert(getPcpMessage('cartValidationError', { errors: errorMessages }));
    setButtonLoading(button, false);
    return;
  }

  await removePendingCartEditGroup();

  const selectionsSnapshot = JSON.stringify(selections);
  const addToCartOptionsWithSelections = Object.assign({}, addToCartOptions, {
    selectionsSnapshot: selectionsSnapshot,
  });

  const addedProducts = [];
  const failedProducts = [];
  let rollbackNeeded = false;
  
  try {
    let imageFile = null;
    
    if (capturedCanvasImageData) {
      imageFile = dataURLtoFile(capturedCanvasImageData, 'customized-design.png');
    }
    const customizerGroupId =
      'pcp-' + Date.now() + '-' + Math.random().toString(36).slice(2, 10);

    const designEntry =
      validatedProducts.find(({ productData }) => productData.type === 'chain') ||
      (validatedProducts.length === 1 ? validatedProducts[0] : null);
    const shouldAttachDesignToEntry =
      designEntry &&
      (designEntry.productData.type === 'chain' || validatedProducts.length === 1);
    const bulkEntries = shouldAttachDesignToEntry
      ? validatedProducts.filter((entry) => entry !== designEntry)
      : validatedProducts.slice();

    if (shouldAttachDesignToEntry) {
      const { productData, variantId } = designEntry;
      const formResult = await addCustomizerProductViaFormData(
        productData,
        variantId,
        customizerGroupId,
        true,
        imageFile,
        addToCartOptionsWithSelections
      );

      if (!formResult.ok) {
        rollbackNeeded = true;
        failedProducts.push({
          product: productData,
          error: formResult.error,
        });
      } else {
        addedProducts.push({
          productData,
          variantId,
          key: formResult.key,
        });
      }
    }

    if (!rollbackNeeded && bulkEntries.length > 0) {
      const bulkResult = await addCustomizerProductsViaBulk(
        bulkEntries,
        customizerGroupId,
        addToCartOptionsWithSelections
      );

      if (!bulkResult.ok) {
        rollbackNeeded = true;
        failedProducts.push({
          product: bulkEntries[0].productData,
          error: bulkResult.error,
        });
      } else {
        addedProducts.push(...bulkResult.items);
      }
    }

    if (rollbackNeeded && addedProducts.length > 0) {
      const cartResponse = await fetch('/cart.js');
      if (cartResponse.ok) {
        const cart = await cartResponse.json();
        for (const { variantId, key } of addedProducts) {
          try {
            const lineItemKey = key || cart.items?.find(item => String(item.variant_id) === String(variantId))?.key;
            if (lineItemKey) {
              await fetch('/cart/change.js', {
                method: 'POST',
                body: JSON.stringify({
                  id: lineItemKey,
                  quantity: 0
                }),
                headers: {
                  'Content-Type': 'application/json',
                  'X-Requested-With': 'XMLHttpRequest',
                },
              });
            } else {
              console.warn('Could not find line item key for rollback, variantId:', variantId);
            }
          } catch (rollbackError) {
            console.error('Error rolling back product:', rollbackError);
          }
        }
      }
    }

    if (failedProducts.length > 0 || rollbackNeeded) {
      const errorMessages = failedProducts.map(f => `${f.product.title || 'Unknown'}: ${f.error}`).join('\n');
      showTransitionAlert(getPcpMessage('cartAllFailedError', { errors: errorMessages }));
      setButtonLoading(button, false);
      return;
    }

    if (addedProducts.length !== validatedProducts.length) {
      throw new Error('Not all products were added successfully');
    }

    setButtonLoading(button, false);
    document.dispatchEvent(new CustomEvent('pcp:cart-items-added'));
    openCartAfterAdd(true);
  } catch (error) {
    console.error('Error adding to cart:', error);
    
    if (addedProducts && addedProducts.length > 0) {
      openCartAfterAdd(false);
      showTransitionAlert(getPcpMessage('cartPartialError', { error: error.message }));
    } else {
      showTransitionAlert(getPcpMessage('cartFailedError', { error: error.message }));
    }
    
    setButtonLoading(button, false);
  }
}

if (reviewAddToCartButton) {
  reviewAddToCartButton.addEventListener('click', function () {
    if (!capturedCanvasImageData) {
      showTransitionAlert(getPcpMessage('canvasCaptureWait'));
      return;
    }

    const selectedProducts = getAllSelectedProducts();
    if (selectedProducts.length === 0) {
      showTransitionAlert(getPcpMessage('noProductsSelected'));
      return;
    }

    showFinalSaleModal(function () {
      proceedWithAddToCart(reviewAddToCartButton, { finalSaleAccepted: true });
    });
  });
}

/** When a chain image is on the canvas, charm x/y are stored relative to the chain’s rendered box (0–100%), not the full canvas — so charms stay on the chain when the canvas/chain is resized. */
const PCP_POSITION_REL_CHAIN = 'chain';
const PCP_REF_CHAIN_PX = 320;

function parseChainFocalPoint(source) {
  if (!source) return null;
  const nx = Number(source.focalPointX);
  const ny = Number(source.focalPointY);
  if (Number.isNaN(nx) || Number.isNaN(ny)) return null;
  return { x: nx, y: ny };
}

function resolveChainFocalPoint(productId, variantId) {
  const variantData = productId && variantId ? getVariantData(productId, variantId) : null;
  const fromVariant = parseChainFocalPoint(variantData);
  if (fromVariant) return fromVariant;
  const productData = getProductData(productId);
  const fromProduct = parseChainFocalPoint(productData);
  if (fromProduct) return fromProduct;
  return { x: 50, y: 50 };
}

function getDefaultCharmPosition(chainProducts, charmCount) {
  const spacing = 8;
  if (chainProducts.length > 0) {
    const chainProduct = chainProducts[0];
    const focalPoint =
      chainProduct.focalPoint || resolveChainFocalPoint(chainProduct.productId, chainProduct.variantId);
    return {
      x: Math.max(0, Math.min(100, focalPoint.x + charmCount * spacing)),
      y: Math.max(0, Math.min(100, focalPoint.y)),
      relativeTo: PCP_POSITION_REL_CHAIN,
    };
  }
  const canvasSpacing = 15;
  return {
    x: 50 + charmCount * canvasSpacing,
    y: 50 + charmCount * canvasSpacing,
  };
}

const PCP_CHAIN_FOCAL_ARROW_SVG =
  '<svg aria-hidden="true" focusable="false" fill="none" width="14" height="18" viewBox="0 0 14 18">' +
  '<path d="M7 17V3M7 17L2.5 12.5M7 17L11.5 12.5" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"/>' +
  '</svg>';

function createChainFocalMarkerElement() {
  const marker = document.createElement('div');
  marker.className = 'chain-focal-marker';
  marker.setAttribute('aria-hidden', 'true');

  const callout = document.createElement('div');
  callout.className = 'chain-focal-marker__callout';

  const label = document.createElement('span');
  label.className = 'chain-focal-marker__label';
  label.textContent = 'Add piece here';

  const arrow = document.createElement('span');
  arrow.className = 'chain-focal-marker__arrow';
  arrow.innerHTML = PCP_CHAIN_FOCAL_ARROW_SVG;

  const circle = document.createElement('span');
  circle.className = 'chain-focal-marker__circle';

  callout.appendChild(label);
  callout.appendChild(arrow);
  marker.appendChild(callout);
  marker.appendChild(circle);
  return marker;
}

function layoutChainFocalMarker(marker, focalPoint, canvasRect, chainRect) {
  if (!marker) return;
  if (!focalPoint || !chainRect || chainRect.width < 0.5 || chainRect.height < 0.5) {
    marker.hidden = true;
    return;
  }
  const position = {
    x: focalPoint.x,
    y: focalPoint.y,
    relativeTo: PCP_POSITION_REL_CHAIN,
  };
  applyPcpContainerStyleForCharmItem(marker, position, canvasRect, chainRect);
  marker.hidden = false;
}

function getPcpChainImageEl() {
  const c = section.querySelector('.canvas-products-container');
  if (!c) return null;
  return c.querySelector('.canvas-product-item.chain-item img');
}

function findPcpCharmProductDataByInstanceId(instanceId) {
  if (instanceId == null || instanceId === '') return null;
  const sid = String(instanceId);
  const chSel = getCharmSelectors();
  for (let i = 0; i < chSel.length; i++) {
    const arr = chSel[i]._selectedProducts;
    if (!Array.isArray(arr)) continue;
    const p = arr.find(function (x) {
      return x && x.type !== 'chain' && String(x.id) === sid;
    });
    if (p) return p;
  }
  return null;
}

function pcpGetCharmScaleFromChainWidth(chainImg) {
  if (!chainImg) return 1;
  const w = chainImg.getBoundingClientRect().width;
  if (w < 1) return 1;
  return Math.max(0.2, Math.min(2.5, w / PCP_REF_CHAIN_PX));
}

/**
 * @param {HTMLElement} item
 * @param {HTMLImageElement} imageElement
 * @param {object} _productData
 * @param {boolean} isPersonalizer
 * @param {HTMLImageElement|null} chainImg
 * @param {function(HTMLElement): void|undefined} onLayout
 */
function applyPcpCharmImageSize(item, imageElement, _productData, isPersonalizer, chainImg, onLayout) {
  if (!item || !imageElement) return;
  if (!imageElement.naturalWidth || !imageElement.naturalHeight) return;
  const scale = pcpGetCharmScaleFromChainWidth(chainImg);
  item.style.setProperty('--pcp-charm-scale', String(scale));
  if (isPersonalizer) {
    imageElement.style.width = '';
    imageElement.style.height = '';
    item.style.width = '';
    item.style.height = '';
    if (typeof onLayout === 'function') {
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          onLayout(item);
        });
      });
    }
    return;
  }
  const maxW = 150 * scale;
  let width = imageElement.naturalWidth;
  let height = imageElement.naturalHeight;
  if (width > maxW) {
    const r = maxW / width;
    width = maxW;
    height = height * r;
  }
  item.style.width = '';
  item.style.height = '';
  imageElement.style.width = width + 'px';
  imageElement.style.height = height + 'px';
  if (typeof onLayout === 'function') onLayout(item);
}

function ensurePcpProductPositionChainSpace(productData, canvasRect, chainRect) {
  if (!productData || !productData.position) return;
  if (productData.position.relativeTo === PCP_POSITION_REL_CHAIN) return;
  if (!chainRect || chainRect.width < 0.5 || chainRect.height < 0.5) return;
  const p = productData.position;
  if (typeof p.x !== 'number' || typeof p.y !== 'number' || Number.isNaN(p.x) || Number.isNaN(p.y)) return;
  const w = canvasRect.width;
  const centerX = (p.x / 100) * w;
  const centerY = (p.y / 100) * canvasRect.height;
  const cl = chainRect.left - canvasRect.left;
  const ct = chainRect.top - canvasRect.top;
  const nx = ((centerX - cl) / chainRect.width) * 100;
  const ny = ((centerY - ct) / chainRect.height) * 100;
  productData.position = {
    x: Math.max(0, Math.min(100, nx)),
    y: Math.max(0, Math.min(100, ny)),
    relativeTo: PCP_POSITION_REL_CHAIN,
  };
}

function applyPcpContainerStyleForCharmItem(item, position, canvasRect, chainRect) {
  if (!item) return;
  if (
    !position ||
    typeof position.x !== 'number' ||
    typeof position.y !== 'number' ||
    Number.isNaN(position.x) ||
    Number.isNaN(position.y)
  ) {
    item.style.left = '50%';
    item.style.top = '50%';
    return;
  }
  if (!chainRect || chainRect.width < 0.5 || chainRect.height < 0.5) {
    item.style.left = position.x + '%';
    item.style.top = position.y + '%';
    return;
  }
  if (position.relativeTo === PCP_POSITION_REL_CHAIN) {
    const cl = chainRect.left - canvasRect.left;
    const ct = chainRect.top - canvasRect.top;
    const cx = cl + (position.x / 100) * chainRect.width;
    const cy = ct + (position.y / 100) * chainRect.height;
    item.style.left = (100 * cx) / canvasRect.width + '%';
    item.style.top = (100 * cy) / canvasRect.height + '%';
  } else {
    item.style.left = position.x + '%';
    item.style.top = position.y + '%';
  }
}

function layoutPcpCharms(targetCanvasContent, options) {
  const canvasContent = targetCanvasContent || section.querySelector('.canvas-content');
  if (!canvasContent) return;
  const cpc = canvasContent.querySelector('.canvas-products-container');
  if (!cpc) return;
  const chainImg = cpc.querySelector('.canvas-product-item.chain-item img');
  const canvasRect = canvasContent.getBoundingClientRect();
  const chainRect =
    chainImg && chainImg.getBoundingClientRect().width > 0.5 ? chainImg.getBoundingClientRect() : null;
  const items = cpc.querySelectorAll('.canvas-product-item:not(.chain-item)');
  const skipControls = options && options.skipControls;
  const updateControls = skipControls ? null : section._pcpUpdateCanvasItemControls;
  items.forEach(function (item) {
    const iid = item.getAttribute('data-instance-id');
    const productData = findPcpCharmProductDataByInstanceId(iid);
    if (!productData) return;
    if (chainRect) {
      ensurePcpProductPositionChainSpace(productData, canvasRect, chainRect);
    }
    applyPcpContainerStyleForCharmItem(item, productData.position, canvasRect, chainRect);
    const img = item.querySelector('img');
    if (!img) return;
    const isP = img.classList.contains('personalizer_image');
    if (isP) {
      applyPcpCharmImageSize(item, img, productData, true, chainImg, updateControls);
    } else {
      if (img.complete && img.naturalWidth && img.naturalHeight) {
        applyPcpCharmImageSize(item, img, productData, false, chainImg, updateControls);
      }
    }
  });
  if (typeof updateControls === 'function') {
    items.forEach(function (el) {
      updateControls(el);
    });
  }
  const focalMarker = cpc.querySelector('.chain-focal-marker');
  if (focalMarker) {
    const chainProduct = window._canvasProducts
      ? window._canvasProducts.find(function (p) {
          return p && p.type === 'chain';
        })
      : null;
    const showFocalMarker = chainProduct && items.length === 0 && isCharmStepExpanded();
    if (showFocalMarker) {
      if (!chainProduct.focalPoint) {
        chainProduct.focalPoint = resolveChainFocalPoint(chainProduct.productId, chainProduct.variantId);
      }
      layoutChainFocalMarker(focalMarker, chainProduct.focalPoint, canvasRect, chainRect);
    } else {
      focalMarker.hidden = true;
    }
  }

  // After positioning items + controls, ensure engraving UI (badge/empty prompt)
  // doesn't overlap between adjacent engravables (e.g. two connectors close together).
  schedulePcpEngravingCollisionAvoidance(canvasContent);
}

function schedulePcpEngravingCollisionAvoidance(canvasContent) {
  if (!canvasContent) return;
  if (canvasContent._pcpEngravingCollisionRaf) return;
  canvasContent._pcpEngravingCollisionRaf = requestAnimationFrame(() => {
    canvasContent._pcpEngravingCollisionRaf = null;
    runPcpEngravingCollisionAvoidance(canvasContent);
  });
}

function runPcpEngravingCollisionAvoidance(canvasContent) {
  const cpc = canvasContent ? canvasContent.querySelector('.canvas-products-container') : null;
  if (!cpc) return;

  const engravingEls = Array.from(
    cpc.querySelectorAll('.canvas-engraving-badge, .canvas-engraving-empty')
  ).filter((el) => {
    if (!el || !document.contains(el)) return false;
    if (el.classList.contains('pcp-hidden')) return false;
    // offsetParent is null for display:none; still allow fixed/absolute in some cases
    const style = window.getComputedStyle(el);
    return style && style.display !== 'none' && style.visibility !== 'hidden' && style.opacity !== '0';
  });

  // Reset state before reflowing.
  engravingEls.forEach((el) => {
    el.style.setProperty('--pcp-engraving-nudge-y', '0px');
    el.classList.remove('pcp-engraving--below');
  });
  if (engravingEls.length < 2) return;

  const canvasRect = canvasContent.getBoundingClientRect();
  const padding = 6;
  const nudgeStep = 14;
  const maxTries = 10;

  function rectsOverlap(a, b) {
    return !(
      a.right <= b.left + padding ||
      a.left >= b.right - padding ||
      a.bottom <= b.top + padding ||
      a.top >= b.bottom - padding
    );
  }

  // Process top-to-bottom so later elements move away from earlier ones.
  engravingEls.sort((a, b) => {
    const ra = a.getBoundingClientRect();
    const rb = b.getBoundingClientRect();
    if (ra.top !== rb.top) return ra.top - rb.top;
    return ra.left - rb.left;
  });

  const placed = [];
  engravingEls.forEach((el) => {
    const firstRect = el.getBoundingClientRect();
    const overlapsExisting = placed.some((p) => rectsOverlap(firstRect, p.rect));

    if (overlapsExisting) {
      // Primary fix: render engraving text/prompt BELOW the charm (keeps the charm itself still).
      el.classList.add('pcp-engraving--below');
    }

    // If it still overlaps after moving below (tight canvas), nudge as a last resort.
    let tries = 0;
    let nudge = 0;
    while (tries < maxTries) {
      const rect = el.getBoundingClientRect();
      const overlapsNow = placed.some((p) => rectsOverlap(rect, p.rect));
      if (!overlapsNow) break;

      tries += 1;
      const nextDown = nudge + nudgeStep;
      const downRectBottom = rect.bottom + nudgeStep;
      const canGoDown = downRectBottom <= canvasRect.bottom - padding;

      if (canGoDown) {
        nudge = nextDown;
      } else {
        const nextUp = nudge - nudgeStep;
        const upRectTop = rect.top - nudgeStep;
        nudge = upRectTop >= canvasRect.top + padding ? nextUp : nextDown;
      }

      el.style.setProperty('--pcp-engraving-nudge-y', `${nudge}px`);
    }

    placed.push({ el, rect: el.getBoundingClientRect() });
  });
}

function engravingFontPreviewClass(fontValue) {
  return getEngravingFontModifierClass(fontValue);
}

function getEngravingFontList(dropdown) {
  if (!dropdown) return null;
  if (dropdown._fontListEl && document.contains(dropdown._fontListEl)) {
    return dropdown._fontListEl;
  }
  dropdown._fontListEl = dropdown.querySelector('.engraving-font-dropdown__list');
  return dropdown._fontListEl;
}

function getEngravingFontOptions(dropdown) {
  const list = getEngravingFontList(dropdown);
  return list ? list.querySelectorAll('.engraving-font-dropdown__option') : [];
}

function isEngravingFontDropdownInteractionTarget(target) {
  return !!(
    target &&
    target.closest(
      '[data-engraving-font-dropdown], .engraving-font-dropdown__list, .engraving-font-dropdown__trigger, .engraving-font-dropdown__option'
    )
  );
}

function syncEngravingFontDropdown(dropdown) {
  if (!dropdown) return;
  const select = dropdown.querySelector('.product-card-engraving-font-select');
  const valueEl = dropdown.querySelector('.engraving-font-dropdown__value');
  const options = getEngravingFontOptions(dropdown);
  if (!select || !valueEl) return;

  const value = select.value;
  const previewClass = engravingFontPreviewClass(value);
  valueEl.textContent = value;
  valueEl.className = 'engraving-font-dropdown__value' + (previewClass ? ' ' + previewClass : '');

  options.forEach((option) => {
    const isSelected = option.getAttribute('data-value') === value;
    option.classList.toggle('is-selected', isSelected);
    option.setAttribute('aria-selected', isSelected ? 'true' : 'false');
  });
}

function resetEngravingFontDropdown(dropdown, defaultValue) {
  if (!dropdown) return;
  const select = dropdown.querySelector('.product-card-engraving-font-select');
  if (!select) return;
  const fallback =
    defaultValue ||
    (select.querySelector('option[selected]') && select.querySelector('option[selected]').value) ||
    (select.options[0] && select.options[0].value) ||
    'Sans Serif';
  select.value = fallback;
  syncEngravingFontDropdown(dropdown);
  closeEngravingFontDropdown(dropdown);
}

function clearEngravingFontDropdownListPosition(list) {
  if (!list) return;
  list.style.position = '';
  list.style.top = '';
  list.style.left = '';
  list.style.width = '';
  list.style.minWidth = '';
  list.style.maxHeight = '';
  list.style.zIndex = '';
  list.style.overflowY = '';
}

function portalEngravingFontDropdownList(dropdown) {
  const list = getEngravingFontList(dropdown);
  if (!list || list.dataset.portaled === 'true') return;
  if (!dropdown._fontListPlaceholder) {
    dropdown._fontListPlaceholder = document.createComment('engraving-font-list');
    list.parentNode.insertBefore(dropdown._fontListPlaceholder, list);
  }
  document.body.appendChild(list);
  list.dataset.portaled = 'true';
  list.classList.add('engraving-font-dropdown__list--portaled');
}

function restoreEngravingFontDropdownList(dropdown) {
  const list = getEngravingFontList(dropdown);
  if (!list || list.dataset.portaled !== 'true' || !dropdown._fontListPlaceholder) return;
  const parent = dropdown._fontListPlaceholder.parentNode;
  if (parent) {
    parent.insertBefore(list, dropdown._fontListPlaceholder.nextSibling);
  }
  list.dataset.portaled = 'false';
  list.classList.remove('engraving-font-dropdown__list--portaled');
}

function positionEngravingFontDropdownList(dropdown) {
  const trigger = dropdown.querySelector('.engraving-font-dropdown__trigger');
  const list = getEngravingFontList(dropdown);
  if (!trigger || !list || !dropdown.classList.contains('is-open')) return;

  const rect = trigger.getBoundingClientRect();
  const viewportPadding = 8;
  const gap = 2;
  const listHeight = list.offsetHeight || list.scrollHeight || 132;
  const spaceBelow = window.innerHeight - rect.bottom - viewportPadding;
  const spaceAbove = rect.top - viewportPadding;
  const openAbove = spaceBelow < listHeight && spaceAbove > spaceBelow;

  list.style.position = 'fixed';
  list.style.left = Math.round(rect.left) + 'px';
  list.style.width = Math.round(rect.width) + 'px';
  list.style.minWidth = Math.round(rect.width) + 'px';
  list.style.zIndex = '10050';
  list.style.overflowY = 'auto';

  if (openAbove) {
    const top = Math.max(viewportPadding, Math.round(rect.top - listHeight - gap));
    list.style.top = top + 'px';
    list.style.maxHeight = Math.round(rect.top - gap - viewportPadding) + 'px';
  } else {
    list.style.top = Math.round(rect.bottom + gap) + 'px';
    list.style.maxHeight = Math.round(window.innerHeight - rect.bottom - gap - viewportPadding) + 'px';
  }
}

function repositionOpenEngravingFontDropdowns() {
  section.querySelectorAll('[data-engraving-font-dropdown].is-open').forEach(positionEngravingFontDropdownList);
}

function closeEngravingFontDropdown(dropdown) {
  if (!dropdown) return;
  const trigger = dropdown.querySelector('.engraving-font-dropdown__trigger');
  const list = getEngravingFontList(dropdown);
  dropdown.classList.remove('is-open');
  if (trigger) trigger.setAttribute('aria-expanded', 'false');
  if (list) {
    list.hidden = true;
    list.classList.remove('is-visible');
    clearEngravingFontDropdownListPosition(list);
    restoreEngravingFontDropdownList(dropdown);
  }
}

function openEngravingFontDropdown(dropdown) {
  const trigger = dropdown.querySelector('.engraving-font-dropdown__trigger');
  const list = getEngravingFontList(dropdown);
  if (!trigger || !list) return;
  dropdown.classList.add('is-open');
  trigger.setAttribute('aria-expanded', 'true');
  list.hidden = false;
  list.classList.add('is-visible');
  portalEngravingFontDropdownList(dropdown);
  positionEngravingFontDropdownList(dropdown);
  window.requestAnimationFrame(function () {
    positionEngravingFontDropdownList(dropdown);
  });
}

function toggleEngravingFontDropdown(dropdown) {
  const isOpen = dropdown.classList.contains('is-open');
  section.querySelectorAll('[data-engraving-font-dropdown].is-open').forEach((openDropdown) => {
    if (openDropdown !== dropdown) closeEngravingFontDropdown(openDropdown);
  });
  if (isOpen) {
    closeEngravingFontDropdown(dropdown);
  } else {
    openEngravingFontDropdown(dropdown);
  }
}

function initEngravingFontDropdowns(root) {
  const scope = root || section;
  scope.querySelectorAll('[data-engraving-font-dropdown]').forEach((dropdown) => {
    if (dropdown.dataset.engravingFontDropdownInit === 'true') return;
    dropdown.dataset.engravingFontDropdownInit = 'true';

    const select = dropdown.querySelector('.product-card-engraving-font-select');
    const trigger = dropdown.querySelector('.engraving-font-dropdown__trigger');
    const list = dropdown.querySelector('.engraving-font-dropdown__list');
    if (!select || !trigger || !list) return;

    dropdown._fontListEl = list;
    let suppressClickToggle = false;

    syncEngravingFontDropdown(dropdown);
    closeEngravingFontDropdown(dropdown);

    function activateTrigger(e) {
      e.stopPropagation();
      e.preventDefault();
      toggleEngravingFontDropdown(dropdown);
    }

    trigger.addEventListener(
      'touchend',
      function (e) {
        suppressClickToggle = true;
        activateTrigger(e);
        window.setTimeout(function () {
          suppressClickToggle = false;
        }, 450);
      },
      { passive: false }
    );

    trigger.addEventListener('click', function (e) {
      if (suppressClickToggle) {
        e.preventDefault();
        e.stopPropagation();
        return;
      }
      e.stopPropagation();
      e.preventDefault();
      toggleEngravingFontDropdown(dropdown);
    });

    getEngravingFontOptions(dropdown).forEach((option) => {
      let suppressOptionClick = false;

      function selectOption(e) {
        e.stopPropagation();
        e.preventDefault();
        const value = option.getAttribute('data-value');
        if (!value) return;
        select.value = value;
        syncEngravingFontDropdown(dropdown);
        closeEngravingFontDropdown(dropdown);
      }

      option.addEventListener(
        'touchend',
        function (e) {
          suppressOptionClick = true;
          selectOption(e);
          window.setTimeout(function () {
            suppressOptionClick = false;
          }, 450);
        },
        { passive: false }
      );
      option.addEventListener('click', function (e) {
        if (suppressOptionClick) {
          e.preventDefault();
          e.stopPropagation();
          return;
        }
        selectOption(e);
      });
    });
  });
}

if (!section.dataset.engravingFontDropdownListeners) {
  section.dataset.engravingFontDropdownListeners = 'true';
  window.addEventListener('resize', repositionOpenEngravingFontDropdowns);
  window.addEventListener('scroll', repositionOpenEngravingFontDropdowns, true);
  section.addEventListener('scroll', repositionOpenEngravingFontDropdowns, true);
}

function closeOpenEngravingFontDropdownsFromEvent(e) {
  if (isEngravingFontDropdownInteractionTarget(e.target)) return;
  section.querySelectorAll('[data-engraving-font-dropdown].is-open').forEach(closeEngravingFontDropdown);
}

section.addEventListener('click', closeOpenEngravingFontDropdownsFromEvent);

const ENGRAVABLE_TAB_ALERT_DISMISS_KEY = 'pcp-engravable-tab-alert-dismissed';

function updateEngravableTabAlert(selector, currentFilter) {
  const alert = selector.querySelector('.engravable-tab-alert');
  if (!alert) return;
  const dismissed = sessionStorage.getItem(ENGRAVABLE_TAB_ALERT_DISMISS_KEY) === 'true';
  const show = currentFilter === 'engravable' && !dismissed;
  alert.classList.toggle('pcp-hidden', !show);
}

const charmSelectors = getCharmSelectors();
charmSelectors.forEach((selector) => {
  const stepIndex = parseInt(selector.getAttribute('data-step'));
  const searchInput = selector.querySelector('.search-input');
  const filterTabs = selector.querySelectorAll('.filter-tab');
  const categoryFilters = selector.querySelectorAll('.category-filter');
  const productCards = selector.querySelectorAll('.product-card');
  const configPanel = selector.querySelector('.product-config-panel');
  const configTitle = selector.querySelector('.config-product-title');
  const configSelectBtn = selector.querySelector('.config-select-btn');
  let selectedProduct = null;

  const activeTab = selector.querySelector('.filter-tab.active');
  let currentFilter = activeTab
    ? activeTab.getAttribute('data-filter')
    : selector.querySelector('.filter-tab')
    ? selector.querySelector('.filter-tab').getAttribute('data-filter')
    : 'connector';
  const activeCategory = selector.querySelector('.category-filter.active');
  let currentCategory = activeCategory ? activeCategory.getAttribute('data-category') : 'all';
  let searchTerm = '';

  const emptyMessage = selector.querySelector('.product-grid-empty');
  const productGrid = selector.querySelector('.product-grid');

  function filterProducts() {
    if (!productCards || productCards.length === 0) return;
    let visibleCount = 0;
    productCards.forEach((card) => {
      const productTitle = card.querySelector('.product-title').textContent.toLowerCase();
      const productTags = card.getAttribute('data-product-tags').toLowerCase();
      let show = true;

      if (card.classList.contains('product-card--hidden-incompatible')) {
        show = false;
      }

      if (searchTerm && !productTitle.includes(searchTerm.toLowerCase())) {
        show = false;
      }

      if (currentFilter === 'pendant') {
        if (!productTags.includes('pendant')) {
          show = false;
        }
      } else if (currentFilter === 'charm') {
        if (!productTags.includes('charm') || productTags.includes('pendant')) {
          show = false;
        }
      } else if (currentFilter === 'connector') {
        if (!productTags.includes('connector')) {
          show = false;
        }
      } else if (currentFilter === 'engravable') {
        if (!productTags.includes('engravable')) {
          show = false;
        }
      }

      if (currentCategory !== 'all') {
        const categoryWords = currentCategory.split('-');
        const titleMatches = categoryWords.some((word) => {
          const base = word.endsWith('s') ? word.slice(0, -1) : word;
          return productTitle.includes(word) || productTitle.includes(base);
        });
        if (!titleMatches) {
          show = false;
        }
      }

      card.style.display = show ? 'flex' : 'none';
      if (show) visibleCount++;
    });

    if (emptyMessage) {
      emptyMessage.classList.toggle('pcp-hidden', visibleCount > 0);
    }
    if (productGrid) {
      productGrid.classList.toggle('is-empty', visibleCount === 0);
    }

    updateEngravableTabAlert(selector, currentFilter);
  }

  selector._filterProducts = filterProducts;

  if (searchInput) {
    searchInput.addEventListener('input', function () {
      searchTerm = this.value;
      filterProducts();
    });
  }

  filterTabs.forEach((tab) => {
    tab.addEventListener('click', function () {
      filterTabs.forEach((t) => t.classList.remove('active'));
      this.classList.add('active');
      currentFilter = this.getAttribute('data-filter');
      filterProducts();
    });
  });

  const engravableTabAlertClose = selector.querySelector('.engravable-tab-alert__close');
  if (engravableTabAlertClose) {
    engravableTabAlertClose.addEventListener('click', function () {
      sessionStorage.setItem(ENGRAVABLE_TAB_ALERT_DISMISS_KEY, 'true');
      updateEngravableTabAlert(selector, currentFilter);
    });
  }

  categoryFilters.forEach((filter) => {
    filter.addEventListener('click', function () {
      categoryFilters.forEach((f) => f.classList.remove('active'));
      this.classList.add('active');
      currentCategory = this.getAttribute('data-category');
      filterProducts();
    });
  });

  filterProducts();
  updateCharmCompatibility();

      const canvasImage = section.querySelector('.canvas-product-image');
      const canvasContent = section.querySelector('.canvas-content');
  const canvasProductsContainer = canvasContent ? canvasContent.querySelector('.canvas-products-container') : null;
  const selectionCounter = canvasContent ? canvasContent.querySelector('.selection-counter') : null;
  const canvasDragHint = section.querySelector('.canvas-drag-hint');

  function showCharmDragAlert() {
    if (!canvasDragHint) return;
    setHidden(canvasDragHint, false);
    if (canvasDragHint.classList.contains('is-visible')) return;
    requestAnimationFrame(function () {
      canvasDragHint.classList.add('is-visible');
    });
  }

  function hideCharmDragAlert() {
    if (!canvasDragHint || canvasDragHint.classList.contains(hiddenClassName)) return;
    if (!canvasDragHint.classList.contains('is-visible')) {
      setHidden(canvasDragHint, true);
      return;
    }
    canvasDragHint.classList.remove('is-visible');
    let finished = false;
    function finishHide(e) {
      if (finished) return;
      if (e && e.propertyName !== 'opacity' && e.propertyName !== 'transform') return;
      finished = true;
      canvasDragHint.removeEventListener('transitionend', finishHide);
      setHidden(canvasDragHint, true);
    }
    canvasDragHint.addEventListener('transitionend', finishHide);
    setTimeout(finishHide, 400);
  }

  if (canvasDragHint) {
    const charmDragAlertClose = canvasDragHint.querySelector('.canvas-drag-hint__close');
    if (charmDragAlertClose) {
      charmDragAlertClose.addEventListener('click', hideCharmDragAlert);
    }
  }

  if (canvasContent && !section.pcpPcpLayoutResizeWired) {
    section.pcpPcpLayoutResizeWired = true;
    if (window.ResizeObserver) {
      new ResizeObserver(function () {
        if (section.pcpPcpLayoutRaf) cancelAnimationFrame(section.pcpPcpLayoutRaf);
        section.pcpPcpLayoutRaf = requestAnimationFrame(function () {
          section.pcpPcpLayoutRaf = null;
          layoutPcpCharms();
        });
      }).observe(canvasContent);
    } else {
      window.addEventListener(
        'resize',
        function () {
          layoutPcpCharms();
        },
        { passive: true }
      );
    }
  }

  if (!window._canvasProducts) {
    window._canvasProducts = [];
  }

  function getMaxSelections() {
    const charmLimit = selector.getAttribute('data-charm-limit');
    if (charmLimit) {
      return parseInt(charmLimit) || 3;
    }
    return 3;
  }

  let selectedProducts = [];
  let activeCanvasEngravingInstanceId = null;

  function getSelectedProductByInstanceId(instanceId) {
    const idx = findCharmIndexByInstanceId(instanceId);
    if (idx === -1) return null;
    return selectedProducts[idx];
  }

  function closeCanvasEngravingEditor() {
    const overlay = canvasContent ? canvasContent.querySelector('.canvas-engraving-editor') : null;
    if (!overlay) return;
    overlay.classList.add('pcp-hidden');
    overlay.setAttribute('aria-hidden', 'true');
    activeCanvasEngravingInstanceId = null;
    overlay.querySelectorAll('[data-engraving-font-dropdown].is-open').forEach(closeEngravingFontDropdown);
  }

  function openCanvasEngravingEditor(instanceId) {
    if (!canvasContent || !instanceId) return;
    const overlay = canvasContent.querySelector('.canvas-engraving-editor');
    if (!overlay) return;
    const productData = getSelectedProductByInstanceId(instanceId);
    if (!productData || !productData.isEngravable) return;

    activeCanvasEngravingInstanceId = String(instanceId);
    const titleEl = overlay.querySelector('.canvas-engraving-editor__title');
    const inputEl = overlay.querySelector('.canvas-engraving-editor__input');
    const dropdownEl = overlay.querySelector('[data-engraving-font-dropdown]');
    const selectEl = overlay.querySelector('.product-card-engraving-font-select');

    if (titleEl) titleEl.textContent = productData.title || 'Add engraving';
    const applyEditorLimit = function (limit) {
      if (limit == null) return;
      productData.engravingMaxChars = limit;
      applyEngravingLimitToUi(overlay, limit);
      if (inputEl) {
        inputEl.value = normalizeEngravingText(productData.engravingText, limit);
      }
    };
    const cachedLimit = getEngravingMaxChars(productData.productId, productData);
    if (cachedLimit != null) applyEditorLimit(cachedLimit);
    fetchZeptoEngravingLimit(productData.productId, productData.title).then(applyEditorLimit);
    if (selectEl) {
      const currentFont = productData.engravingFont != null ? String(productData.engravingFont).trim() : '';
      selectEl.value = currentFont !== '' ? currentFont : 'Sans Serif';
    }
    syncEngravingFontDropdown(dropdownEl);
    closeEngravingFontDropdown(dropdownEl);

    overlay.classList.remove('pcp-hidden');
    overlay.setAttribute('aria-hidden', 'false');
    if (inputEl) {
      window.requestAnimationFrame(function () {
        inputEl.focus();
        inputEl.select();
      });
    }
  }

  function ensureCanvasEngravingEditor() {
    if (!canvasContent || canvasContent.querySelector('.canvas-engraving-editor')) return;

    const overlay = document.createElement('div');
    overlay.className = 'canvas-engraving-editor pcp-hidden';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-hidden', 'true');
    overlay.innerHTML =
      '<div class="canvas-engraving-editor__backdrop"></div>' +
      '<div class="canvas-engraving-editor__panel">' +
      '  <button type="button" class="engraving-overlay-close canvas-engraving-editor__close" aria-label="Close">' +
      '    <svg aria-hidden="true" focusable="false" fill="none" width="16" viewBox="0 0 16 16"><path d="m1 1 14 14M1 15 15 1" stroke="currentColor" stroke-width="1.5"/></svg>' +
      '  </button>' +
      '  <h3 class="canvas-engraving-editor__title"></h3>' +
      '  <div class="canvas-engraving-editor__field">' +
      '    <label class="engraving-font-dropdown__label">Choose Font</label>' +
      '    <div class="engraving-font-dropdown" data-engraving-font-dropdown>' +
      '      <select class="product-card-engraving-font-select sr-only" tabindex="-1" aria-hidden="true">' +
      '        <option value="Cursive">Cursive</option>' +
      '        <option value="Sans Serif" selected>Sans Serif</option>' +
      '        <option value="Serif">Serif</option>' +
      '      </select>' +
      '      <button type="button" class="engraving-font-dropdown__trigger" aria-haspopup="listbox" aria-expanded="false">' +
      '        <span class="engraving-font-dropdown__value pcp-engrave-font--sans-serif">Sans Serif</span>' +
      '        <svg class="engraving-font-dropdown__chevron" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L5 5L9 1" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
      '      </button>' +
      '      <ul class="engraving-font-dropdown__list" role="listbox" hidden>' +
      '        <li class="engraving-font-dropdown__option pcp-engrave-font--cursive" role="option" data-value="Cursive" tabindex="-1">Cursive</li>' +
      '        <li class="engraving-font-dropdown__option pcp-engrave-font--sans-serif is-selected" role="option" data-value="Sans Serif" aria-selected="true" tabindex="-1">Sans Serif</li>' +
      '        <li class="engraving-font-dropdown__option pcp-engrave-font--serif" role="option" data-value="Serif" tabindex="-1">Serif</li>' +
      '      </ul>' +
      '    </div>' +
      '  </div>' +
      '  <div class="canvas-engraving-editor__field">' +
      '    <label>Type text <span class="max_chr_hh"></span>:</label>' +
      '    <input type="text" class="canvas-engraving-editor__input" placeholder="Type your text" autocomplete="off" />' +
      '  </div>' +
      '  <button type="button" class="canvas-engraving-editor__submit">Add Engraving</button>' +
      '</div>';

    canvasContent.appendChild(overlay);
    initEngravingFontDropdowns(overlay);

    overlay.addEventListener('click', function (e) {
      if (e.target.classList.contains('canvas-engraving-editor__backdrop')) {
        closeCanvasEngravingEditor();
      }
    });

    const panel = overlay.querySelector('.canvas-engraving-editor__panel');
    if (panel) {
      panel.addEventListener('click', function (e) {
        e.stopPropagation();
      });
    }

    const closeBtn = overlay.querySelector('.canvas-engraving-editor__close');
    if (closeBtn) {
      closeBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        closeCanvasEngravingEditor();
      });
    }

    const submitBtn = overlay.querySelector('.canvas-engraving-editor__submit');
    submitBtn.addEventListener('click', function () {
      if (!activeCanvasEngravingInstanceId) return;
      const productData = getSelectedProductByInstanceId(activeCanvasEngravingInstanceId);
      if (!productData) return;
      const textInput = overlay.querySelector('.canvas-engraving-editor__input');
      const fontSelect = overlay.querySelector('.product-card-engraving-font-select');
      productData.engravingText = normalizeEngravingText(
        textInput ? textInput.value : '',
        resolveEngravingMaxChars(productData.productId, productData)
      );
      productData.engravingFont = fontSelect ? String(fontSelect.value || '').trim() : '';
      updateCanvasDisplay();
      updateSelections();
      closeCanvasEngravingEditor();
    });

    const inputEl = overlay.querySelector('.canvas-engraving-editor__input');
    if (inputEl) {
      inputEl.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          submitBtn.click();
        } else if (e.key === 'Escape') {
          e.preventDefault();
          closeCanvasEngravingEditor();
        }
      });
    }
  }

  ensureCanvasEngravingEditor();

  function getAllCanvasProducts() {
    const allProducts = [...window._canvasProducts];
    selectedProducts.forEach((p) => {
      allProducts.push(p);
    });
    return allProducts;
  }

  function findCharmIndexByInstanceId(instanceId) {
    if (instanceId == null || instanceId === '') return -1;
    const sid = String(instanceId);
    return selectedProducts.findIndex((p) => String(p.id) === sid);
  }

  function ensureCharmInstanceId(productData) {
    if (!productData) return;
    if (productData.id == null || productData.id === '') {
      productData.id = generateCharmInstanceId();
    }
  }

  function getEventClientPoint(e) {
    if (e.touches && e.touches.length) {
      return { x: e.touches[0].clientX, y: e.touches[0].clientY };
    }
    if (e.changedTouches && e.changedTouches.length) {
      return { x: e.changedTouches[0].clientX, y: e.changedTouches[0].clientY };
    }
    return { x: e.clientX, y: e.clientY };
  }

  function updateCanvasDisplay() {
    if (!canvasProductsContainer) return;

    const maxSelections = getMaxSelections();
    const allProducts = getAllCanvasProducts();
    canvasProductsContainer.innerHTML = '';

    if (allProducts.length === 0) {
      setHidden(canvasProductsContainer, true);
      if (canvasImage) {
        canvasImage.classList.remove('show');
      }
      setHidden(selectionCounter, true);
      return;
    }

    const chainProducts = allProducts.filter((p) => p.type === 'chain');
    const charmProducts = allProducts.filter((p) => p.type !== 'chain');

    charmProducts.forEach((p) => {
      if (p.engravingText !== undefined) {
        p.engravingText = normalizeEngravingText(
          p.engravingText,
          resolveEngravingMaxChars(p.productId, p)
        );
      }
    });

    setHidden(canvasProductsContainer, false);
    if (canvasImage) {
      canvasImage.classList.remove('show');
    }

    if (selectionCounter) {
      selectionCounter.textContent = `${charmProducts.length}/${maxSelections} Selected`;
      setHidden(selectionCounter, false);
    }

    if (chainProducts.length > 0) {
      const chainProduct = chainProducts[0];
      const chainItem = document.createElement('div');
      chainItem.className = 'canvas-product-item chain-item';
      chainItem.setAttribute('data-product-id', chainProduct.productId);
      chainItem.setAttribute('data-variant-id', chainProduct.variantId || '');
      chainItem.setAttribute('data-product-type', 'chain');

      const chainImg = document.createElement('img');
      chainImg.src = chainProduct.imageSrc;
      chainImg.alt = chainProduct.imageAlt || chainProduct.title;
      chainImg.crossOrigin = 'anonymous';
      chainImg.className = 'canvas-chain-background show';
      if (chainProduct.hasPersonalizerImage) {
        chainImg.classList.add('personalizer_image');
      }
      applyCanvasItemAltClass(chainItem, chainImg.alt);

      chainItem.appendChild(chainImg);
      canvasProductsContainer.appendChild(chainItem);

      if (!chainProduct.focalPoint) {
        chainProduct.focalPoint = resolveChainFocalPoint(chainProduct.productId, chainProduct.variantId);
      }
      canvasProductsContainer.appendChild(createChainFocalMarkerElement());

      (function () {
        const onChainLayout = function () {
          requestAnimationFrame(function () {
            layoutPcpCharms();
          });
        };
        chainImg.addEventListener('load', onChainLayout);
        if (chainImg.complete && chainImg.naturalWidth) {
          onChainLayout();
        }
      })();
    }

    charmProducts.forEach((productData, index) => {
      ensureCharmInstanceId(productData);

      const item = document.createElement('div');
      item.className = 'canvas-product-item';
      item.setAttribute('data-product-id', productData.productId);
      item.setAttribute('data-variant-id', productData.variantId || '');
      item.setAttribute('data-product-type', 'charm');
      item.setAttribute('data-instance-id', String(productData.id));
      item.style.zIndex = (10 + index).toString();

      if (
        !productData.position ||
        typeof productData.position.x !== 'number' ||
        Number.isNaN(productData.position.x) ||
        typeof productData.position.y !== 'number' ||
        Number.isNaN(productData.position.y)
      ) {
        productData.position = getDefaultCharmPosition(chainProducts, index);
      }
      const savedRotation = productData.rotation || 0;
      item.style.left = '50%';
      item.style.top = '50%';
      item.style.transform = `translate(-50%, -50%) rotate(${savedRotation}deg)`;

      const img = document.createElement('img');
      img.src = productData.imageSrc;
      img.alt = productData.imageAlt || productData.title;
      img.crossOrigin = 'anonymous';
      img.draggable = false;
      if (productData.hasPersonalizerImage) {
        img.classList.add('personalizer_image');
      }
      applyCanvasItemAltClass(item, img.alt);

      let charmContentRoot = img;
      if (canvasItemUsesBelowFrameControls(item)) {
        const frame = document.createElement('div');
        frame.className = 'canvas-product-item__frame';
        frame.appendChild(img);
        charmContentRoot = frame;
      }

      const applyCanvasItemSize = (imageElement) => {
        const chainIm = getPcpChainImageEl();
        applyPcpCharmImageSize(
          item,
          imageElement,
          productData,
          imageElement.classList.contains('personalizer_image'),
          chainIm,
          updateCanvasItemControls
        );
      };

      img.addEventListener('load', function () {
        applyCanvasItemSize(this);
      });

      if (img.complete && img.naturalWidth && img.naturalHeight) {
        applyCanvasItemSize(img);
      }

      const engravingTrim = normalizeEngravingText(
        productData.engravingText,
        resolveEngravingMaxChars(productData.productId, productData)
      );
      if (engravingTrim !== '') {
        const badge = document.createElement('div');
        badge.className = 'canvas-engraving-badge';
        badge.setAttribute('tabindex', '0');
        const fontForAria =
          productData.engravingFont != null ? String(productData.engravingFont).trim() : '';
        badge.setAttribute(
          'aria-label',
          'Engraving: ' + engravingTrim + (fontForAria ? ', font ' + fontForAria : '')
        );
        const mark = document.createElement('span');
        mark.className = 'canvas-engraving-badge-mark';
        mark.textContent = 'T';
        const label = document.createElement('span');
        label.className = 'canvas-engraving-badge-text';
        const engraveFontClass = getEngravingFontModifierClass(fontForAria);
        if (engraveFontClass) label.classList.add(engraveFontClass);
        label.textContent = engravingTrim;
        badge.appendChild(mark);
        badge.appendChild(label);
        ['click', 'mousedown', 'touchstart'].forEach((evt) => {
          badge.addEventListener(evt, function (e) {
            e.stopPropagation();
            if (evt === 'click') openCanvasEngravingEditor(String(productData.id));
          });
        });
        badge.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            e.stopPropagation();
            openCanvasEngravingEditor(String(productData.id));
          }
        });
        item.appendChild(badge);
      } else if (productData.isEngravable) {
        const emptyPrompt = document.createElement('div');
        emptyPrompt.className = 'canvas-engraving-empty';
        emptyPrompt.setAttribute('role', 'button');
        emptyPrompt.setAttribute('tabindex', '0');
        emptyPrompt.setAttribute('aria-label', 'Tap to engrave');
        const icon = document.createElement('span');
        icon.className = 'canvas-engraving-empty__icon';
        icon.textContent = '+';
        const label = document.createElement('span');
        label.className = 'canvas-engraving-empty__text';
        label.textContent = 'Tap to engrave';
        const svg_arrow = document.createElement('span');
        svg_arrow.className = 'canvas-engraving-empty__arrow';
        svg_arrow.innerHTML =
          '<svg aria-hidden="true" focusable="false" fill="none" width="31" height="38" viewBox="0 0 31 38">' +
          '<path d="M0.948242 0.660227C3.81887 -0.296659 7.70608 -0.194753 11.5664 0.844797C15.4444 1.88919 19.4188 3.91151 22.458 6.93757C25.5108 9.97714 27.6185 14.0332 27.7031 19.0723C27.7791 23.6006 26.2185 28.8266 22.4043 34.7344L28.9746 33.6309C29.5191 33.5395 30.0344 33.9067 30.126 34.4512C30.2173 34.9958 29.8502 35.5111 29.3057 35.6026L20.4307 37.0948C19.886 37.1864 19.3699 36.8191 19.2783 36.2745L17.7861 27.3995C17.6946 26.8549 18.0618 26.3387 18.6064 26.2471C19.151 26.1556 19.6671 26.523 19.7588 27.0675L20.8359 33.4757C24.413 27.8811 25.7711 23.0953 25.7041 19.1055C25.6294 14.6542 23.7814 11.0784 21.0469 8.35554C18.2986 5.61913 14.6532 3.74768 11.0469 2.77644C7.42307 1.80051 3.9603 1.76465 1.58105 2.55769L0.631836 2.87409L0 0.976633L0.948242 0.660227Z" fill="currentColor"/>' +
          '</svg>';
        emptyPrompt.appendChild(icon);
        emptyPrompt.appendChild(label);
        emptyPrompt.appendChild(svg_arrow);
        emptyPrompt.addEventListener('click', function (e) {
          e.stopPropagation();
          openCanvasEngravingEditor(String(productData.id));
        });
        emptyPrompt.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            e.stopPropagation();
            openCanvasEngravingEditor(String(productData.id));
          }
        });
        item.appendChild(emptyPrompt);
      }

      const controls = document.createElement('div');
      controls.className = 'canvas-product-controls';

      const rotateLeftBtn = document.createElement('button');
      rotateLeftBtn.className = 'rotate-btn rotate-left';
      rotateLeftBtn.setAttribute('aria-label', 'Rotate Left');
      rotateLeftBtn.innerHTML =
        '<svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.50039 2.37451C7.63248 2.37475 5.84014 3.11217 4.51289 4.42651V3.08701C4.51289 2.89805 4.43782 2.71682 4.3042 2.5832C4.17058 2.44958 3.98936 2.37451 3.80039 2.37451C3.61142 2.37451 3.4302 2.44958 3.29658 2.5832C3.16296 2.71682 3.08789 2.89805 3.08789 3.08701V6.64951C3.08789 6.83848 3.16296 7.01971 3.29658 7.15333C3.4302 7.28694 3.61142 7.36201 3.80039 7.36201H7.36289C7.55186 7.36201 7.73308 7.28694 7.8667 7.15333C8.00032 7.01971 8.07539 6.83848 8.07539 6.64951C8.07539 6.46055 8.00032 6.27932 7.8667 6.1457C7.73308 6.01208 7.55186 5.93701 7.36289 5.93701H5.06579C5.79709 5.03002 6.78916 4.36935 7.90798 4.04425C9.02679 3.71915 10.2184 3.74529 11.3219 4.11915C12.4254 4.493 13.3875 5.19655 14.0784 6.13474C14.7692 7.07293 15.1554 8.20056 15.1848 9.36528C15.2142 10.53 14.8854 11.6757 14.2429 12.6476C13.6003 13.6194 12.6749 14.3706 11.5917 14.7997C10.5085 15.2288 9.31967 15.3151 8.18587 15.0469C7.05207 14.7787 6.02791 14.1689 5.25175 13.3C5.18962 13.2293 5.1141 13.1716 5.02955 13.1302C4.94499 13.0889 4.85309 13.0647 4.75913 13.0591C4.66518 13.0534 4.57104 13.0665 4.48215 13.0975C4.39327 13.1284 4.3114 13.1767 4.24128 13.2395C4.17115 13.3022 4.11416 13.3783 4.0736 13.4632C4.03303 13.5482 4.0097 13.6403 4.00494 13.7343C4.00019 13.8283 4.0141 13.9223 4.04589 14.0109C4.07767 14.0995 4.1267 14.1809 4.19013 14.2505C4.98257 15.1361 5.98396 15.8095 7.10312 16.2093C8.22228 16.6091 9.42367 16.7225 10.5979 16.5394C11.7721 16.3563 12.8819 15.8823 13.8262 15.1607C14.7704 14.4391 15.5192 13.4928 16.0043 12.4079C16.4894 11.323 16.6955 10.134 16.6037 8.94911C16.5118 7.76424 16.1251 6.62115 15.4787 5.62392C14.8323 4.62669 13.9466 3.80699 12.9025 3.23946C11.8583 2.67193 10.6888 2.37459 9.50039 2.37451Z" fill="black"/></svg>';

      const rotateRightBtn = document.createElement('button');
      rotateRightBtn.className = 'rotate-btn rotate-right';
      rotateRightBtn.setAttribute('aria-label', 'Rotate Right');
      rotateRightBtn.innerHTML =
        '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.5499 1.4248C10.4178 1.42504 12.2102 2.16246 13.5374 3.4768V2.1373C13.5374 1.94834 13.6125 1.76711 13.7461 1.63349C13.8797 1.49987 14.0609 1.4248 14.2499 1.4248C14.4389 1.4248 14.6201 1.49987 14.7537 1.63349C14.8873 1.76711 14.9624 1.94834 14.9624 2.1373V5.6998C14.9624 5.88877 14.8873 6.07 14.7537 6.20362C14.6201 6.33724 14.4389 6.4123 14.2499 6.4123H10.6874C10.4984 6.4123 10.3172 6.33724 10.1836 6.20362C10.05 6.07 9.9749 5.88877 9.9749 5.6998C9.9749 5.51084 10.05 5.32961 10.1836 5.19599C10.3172 5.06237 10.4984 4.9873 10.6874 4.9873H12.9845C12.2532 4.08031 11.2611 3.41964 10.1423 3.09454C9.0235 2.76944 7.83186 2.79559 6.72837 3.16944C5.62489 3.54329 4.66275 4.24684 3.97193 5.18503C3.28111 6.12323 2.89491 7.25085 2.86549 8.41557C2.83607 9.58029 3.16486 10.726 3.80744 11.6978C4.45002 12.6697 5.37542 13.4209 6.45862 13.85C7.54182 14.2791 8.73063 14.3654 9.86443 14.0972C10.9982 13.8289 12.0224 13.2192 12.7985 12.3503C12.8607 12.2796 12.9362 12.2219 13.0207 12.1805C13.1053 12.1392 13.1972 12.115 13.2912 12.1094C13.3851 12.1037 13.4793 12.1168 13.5681 12.1477C13.657 12.1787 13.7389 12.227 13.809 12.2898C13.8791 12.3525 13.9361 12.4286 13.9767 12.5135C14.0173 12.5985 14.0406 12.6906 14.0453 12.7846C14.0501 12.8786 14.0362 12.9726 14.0044 13.0612C13.9726 13.1498 13.9236 13.2312 13.8602 13.3008C13.0677 14.1864 12.0663 14.8598 10.9472 15.2596C9.82801 15.6593 8.62663 15.7728 7.4524 15.5897C6.27817 15.4066 5.1684 14.9326 4.22413 14.211C3.27986 13.4894 2.53109 12.5431 2.04598 11.4582C1.56087 10.3733 1.35484 9.18428 1.44664 7.99941C1.53845 6.81454 1.92517 5.67145 2.5716 4.67422C3.21804 3.67698 4.10365 2.85729 5.1478 2.28975C6.19195 1.72222 7.36148 1.42488 8.5499 1.4248Z" fill="black"/></svg>';

      function makeRotateBtnDraggable(rotateBtn, item, productData) {
        let isRotating = false;
        let startAngle = 0;
        let initialRotation = 0;

        function startRotate(e) {
          e.preventDefault();
          e.stopPropagation();
          isRotating = true;

          const rect = item.getBoundingClientRect();
          const centerX = rect.left + rect.width / 2;
          const centerY = rect.top + rect.height / 2;

          const point = getEventClientPoint(e);
          initialRotation = productData.rotation || 0;
          startAngle = Math.atan2(point.y - centerY, point.x - centerX) * (180 / Math.PI);

          document.addEventListener('mousemove', rotateHandler);
          document.addEventListener('mouseup', stopRotate);
          document.addEventListener('touchmove', rotateHandler, { passive: false });
          document.addEventListener('touchend', stopRotate);
          document.addEventListener('touchcancel', stopRotate);
        }

        rotateBtn.addEventListener('mousedown', function (e) {
          startRotate(e);
        });

        rotateBtn.addEventListener('touchstart', function (e) {
          if (e.touches.length !== 1) return;
          startRotate(e);
        }, { passive: false });

        function rotateHandler(e) {
          if (!isRotating) return;
          e.preventDefault();

          const rect = item.getBoundingClientRect();
          const centerX = rect.left + rect.width / 2;
          const centerY = rect.top + rect.height / 2;

          const point = getEventClientPoint(e);
          const currentAngle = Math.atan2(point.y - centerY, point.x - centerX) * (180 / Math.PI);
          const angleDiff = currentAngle - startAngle;
          const newRotation = initialRotation + angleDiff;

          productData.rotation = newRotation;
          item.style.transform = `translate(-50%, -50%) rotate(${newRotation}deg)`;
          item.style.transformOrigin = 'center center';
          updateCanvasItemControls(item);
        }

        function stopRotate() {
          if (isRotating) {
            isRotating = false;
            const productIndex = findCharmIndexByInstanceId(productData.id);
            if (productIndex !== -1) {
              selectedProducts[productIndex].rotation = productData.rotation;
            }
          }
          document.removeEventListener('mousemove', rotateHandler);
          document.removeEventListener('mouseup', stopRotate);
          document.removeEventListener('touchmove', rotateHandler);
          document.removeEventListener('touchend', stopRotate);
          document.removeEventListener('touchcancel', stopRotate);
        }
      }

      makeRotateBtnDraggable(rotateLeftBtn, item, productData);
      makeRotateBtnDraggable(rotateRightBtn, item, productData);

      const removeBtn = document.createElement('button');
      removeBtn.className = 'remove-btn';
      removeBtn.textContent = '×';
      removeBtn.setAttribute('aria-label', 'Remove');
      removeBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        const row = this.closest('.canvas-product-item');
        const instanceId = row ? row.getAttribute('data-instance-id') : null;
        const productIndex = findCharmIndexByInstanceId(instanceId);
        if (productIndex !== -1) {
          removeProduct(productIndex);
        }
      });

      controls.appendChild(rotateLeftBtn);
      controls.appendChild(removeBtn);
      controls.appendChild(rotateRightBtn);

      const topLeftHandle = document.createElement('div');
      topLeftHandle.className = 'canvas-rotate-handle top-left';
      topLeftHandle.setAttribute('aria-label', 'Rotate');

      const topRightHandle = document.createElement('div');
      topRightHandle.className = 'canvas-rotate-handle top-right';
      topRightHandle.setAttribute('aria-label', 'Rotate');

      const bottomLeftHandle = document.createElement('div');
      bottomLeftHandle.className = 'canvas-rotate-handle bottom-left';
      bottomLeftHandle.setAttribute('aria-label', 'Rotate');

      const bottomRightHandle = document.createElement('div');
      bottomRightHandle.className = 'canvas-rotate-handle bottom-right';
      bottomRightHandle.setAttribute('aria-label', 'Rotate');

      item.appendChild(charmContentRoot);
      item.appendChild(controls);
      item.appendChild(topLeftHandle);
      item.appendChild(topRightHandle);
      item.appendChild(bottomLeftHandle);
      item.appendChild(bottomRightHandle);
      canvasProductsContainer.appendChild(item);
      updateCanvasItemControls(item);

      item.addEventListener('click', function (e) {
        if (
          e.target.classList.contains('remove-btn') ||
          e.target.closest('.remove-btn') ||
          e.target.classList.contains('rotate-btn') ||
          e.target.closest('.rotate-btn') ||
          e.target.classList.contains('canvas-product-controls') ||
          e.target.closest('.canvas-product-controls') ||
          e.target.classList.contains('canvas-rotate-handle') ||
          e.target.closest('.canvas-rotate-handle') ||
          e.target.classList.contains('canvas-engraving-badge') ||
          e.target.closest('.canvas-engraving-badge') ||
          e.target.classList.contains('canvas-engraving-empty') ||
          e.target.closest('.canvas-engraving-empty')
        ) {
          return;
        }
        e.stopPropagation();
        const allItems = canvasProductsContainer.querySelectorAll('.canvas-product-item');
        allItems.forEach((i) => i.classList.remove('active'));
        this.classList.add('active');
        updateCanvasItemControls(this);
      });

      if (canvasContent) {
        canvasContent.addEventListener('click', function (e) {
          if (
            e.target.classList.contains('canvas-product-item') ||
            e.target.closest('.canvas-product-item') ||
            e.target.classList.contains('canvas-product-controls') ||
            e.target.closest('.canvas-product-controls') ||
            e.target.classList.contains('canvas-rotate-handle') ||
            e.target.closest('.canvas-rotate-handle') ||
            e.target.classList.contains('canvas-engraving-badge') ||
            e.target.closest('.canvas-engraving-badge') ||
            e.target.classList.contains('canvas-engraving-empty') ||
            e.target.closest('.canvas-engraving-empty')
          ) {
            return;
          }
          const allItems = canvasProductsContainer ? canvasProductsContainer.querySelectorAll('.canvas-product-item') : [];
          allItems.forEach((item) => {
            item.classList.remove('active');
          });
        });
      }

      makeDraggable(item, productData, canvasProductsContainer);
      makeRotatable(item, productData, [topLeftHandle, topRightHandle, bottomLeftHandle, bottomRightHandle], canvasProductsContainer);
    });
    requestAnimationFrame(function () {
      layoutPcpCharms();
    });
  }

  function updateCanvasItemControls(element) {
    if (!canvasContent || !element) return;
    if (element._controlsUpdateRaf) return;
    element._controlsUpdateRaf = requestAnimationFrame(() => {
      element._controlsUpdateRaf = null;
      const canvasRect = canvasContent.getBoundingClientRect();
      const elementRect = element.getBoundingClientRect();
      const controls = element.querySelector('.canvas-product-controls');
      if (controls) {
        if (canvasItemUsesBelowFrameControls(element)) {
          let controlsHeight = 28;
          if (element.classList.contains('active') || element.classList.contains('dragging')) {
            const measured = controls.getBoundingClientRect().height;
            if (measured > 2) {
              controls._controlsHeight = measured;
              controlsHeight = measured;
            } else {
              controlsHeight = controls._controlsHeight || 28;
            }
          } else {
            controlsHeight = controls._controlsHeight || 28;
          }
          const gap = 6;
          const edgePadding = 8;
          const roomBelow = canvasRect.bottom - edgePadding - elementRect.bottom - gap;
          const roomAbove = elementRect.top - canvasRect.top - edgePadding - gap;

          let placement = 'below';
          if (roomBelow >= controlsHeight) {
            placement = 'below';
          } else if (roomAbove >= controlsHeight) {
            placement = 'above';
          } else {
            placement = roomAbove >= roomBelow ? 'above' : 'below';
          }

          // Ensure engraving UI never overlaps the navigation arrows/controls.
          // When controls are placed above the charm, bump engraving badge/prompt higher by controlsHeight + gap.
          element.style.setProperty(
            '--pcp-controls-above-offset',
            placement === 'above' ? controlsHeight + gap + 'px' : '0px'
          );
          element.style.setProperty(
            '--pcp-controls-below-offset',
            placement === 'below' ? controlsHeight + gap + 'px' : '0px'
          );

          controls.style.left = 'auto';
          controls.style.right = 'auto';
          controls.style.width = 'max-content';
          controls.style.transform = 'none';

          if (placement === 'below') {
            controls.style.top = '100%';
            controls.style.bottom = 'auto';
            controls.style.marginTop = gap + 'px';
            controls.style.marginBottom = '';
            controls._controlsState = 'below-frame';
          } else {
            controls.style.top = 'auto';
            controls.style.bottom = '100%';
            controls.style.marginTop = '';
            controls.style.marginBottom = (gap + 31) + 'px';
            controls._controlsState = 'below-frame-above';
          }
        } else {
          controls.style.marginTop = '';
          controls.style.marginBottom = '';
          controls.style.transform = '';
          controls.style.left = '';
          controls.style.right = '';
          if (!controls._controlsHeight) {
            const measuredHeight = controls.getBoundingClientRect().height;
            controls._controlsHeight = measuredHeight || 0;
          }
          const controlsHeight = controls._controlsHeight || 0;
          const edgePadding = 8;
          let controlsState = controls._controlsState || 'center';
          if (controlsState === 'below-frame' || controlsState === 'below-frame-above') {
            controlsState = 'center';
          }
          if (controlsState === 'top') {
            if (elementRect.bottom + controlsHeight < canvasRect.bottom - edgePadding) {
              controlsState = 'center';
            }
          } else if (controlsState === 'bottom') {
            if (elementRect.top - controlsHeight > canvasRect.top + edgePadding) {
              controlsState = 'center';
            }
          } else {
            if (elementRect.bottom + controlsHeight / 2 > canvasRect.bottom - edgePadding) {
              controlsState = 'top';
            } else if (elementRect.top - controlsHeight / 2 < canvasRect.top + edgePadding) {
              controlsState = 'bottom';
            }
          }
          if (controls._controlsState !== controlsState) {
            controls._controlsState = controlsState;
            if (controlsState === 'top') {
              controls.style.top = '0';
              controls.style.bottom = 'auto';
            } else if (controlsState === 'bottom') {
              controls.style.bottom = '0';
              controls.style.top = 'auto';
            } else {
              controls.style.top = '';
              controls.style.bottom = '';
            }
          }
        }
      }

      const handlePadding = 6;
      if (!canvasItemUsesBelowFrameControls(element)) {
        const overflowTop = elementRect.top < canvasRect.top + handlePadding;
        const overflowBottom = elementRect.bottom > canvasRect.bottom - handlePadding;
        const overflowLeft = elementRect.left < canvasRect.left + handlePadding;
        const overflowRight = elementRect.right > canvasRect.right - handlePadding;
        const overflowState = `${overflowTop ? 1 : 0}${overflowBottom ? 1 : 0}${overflowLeft ? 1 : 0}${overflowRight ? 1 : 0}`;
        if (element._handlesOverflowState !== overflowState) {
          element._handlesOverflowState = overflowState;
          const handles = element.querySelectorAll('.canvas-rotate-handle');
          handles.forEach((handle) => {
            if (handle.classList.contains('top-left') || handle.classList.contains('top-right')) {
              handle.style.top = overflowTop ? '2px' : '';
            }
            if (handle.classList.contains('bottom-left') || handle.classList.contains('bottom-right')) {
              handle.style.bottom = overflowBottom ? '2px' : '';
            }
            if (handle.classList.contains('top-left') || handle.classList.contains('bottom-left')) {
              handle.style.left = overflowLeft ? '2px' : '';
            }
            if (handle.classList.contains('top-right') || handle.classList.contains('bottom-right')) {
              handle.style.right = overflowRight ? '2px' : '';
            }
          });
        }
      }

      // When controls/handles shift, re-check engraving overlap too.
      schedulePcpEngravingCollisionAvoidance(canvasContent);
    });
  }

  section._pcpUpdateCanvasItemControls = updateCanvasItemControls;

  function makeRotatable(element, productData, handles, canvasProductsContainer) {
    let isRotating = false;
    let startAngle = 0;
    let initialRotation = 0;

    function startRotate(e) {
      e.preventDefault();
      e.stopPropagation();
      isRotating = true;
      element.classList.add('active');
      const allItems = canvasProductsContainer ? canvasProductsContainer.querySelectorAll('.canvas-product-item') : [];
      allItems.forEach((i) => {
        if (i !== element) {
          i.classList.remove('active');
        }
      });

      const rect = element.getBoundingClientRect();
      const centerX = rect.left + rect.width / 2;
      const centerY = rect.top + rect.height / 2;

      const point = getEventClientPoint(e);
      initialRotation = productData.rotation || 0;
      startAngle = Math.atan2(point.y - centerY, point.x - centerX) * (180 / Math.PI);

      document.addEventListener('mousemove', rotateHandler);
      document.addEventListener('mouseup', stopRotate);
      document.addEventListener('touchmove', rotateHandler, { passive: false });
      document.addEventListener('touchend', stopRotate);
      document.addEventListener('touchcancel', stopRotate);
    }

    handles.forEach((handle) => {
      handle.addEventListener('mousedown', function (e) {
        startRotate(e);
      });

      handle.addEventListener('touchstart', function (e) {
        if (e.touches.length !== 1) return;
        startRotate(e);
      }, { passive: false });
    });

    function rotateHandler(e) {
      if (!isRotating) return;
      e.preventDefault();

      const rect = element.getBoundingClientRect();
      const centerX = rect.left + rect.width / 2;
      const centerY = rect.top + rect.height / 2;

      const point = getEventClientPoint(e);
      const currentAngle = Math.atan2(point.y - centerY, point.x - centerX) * (180 / Math.PI);
      const angleDiff = currentAngle - startAngle;
      const newRotation = initialRotation + angleDiff;

      productData.rotation = newRotation;
      element.style.transform = `translate(-50%, -50%) rotate(${newRotation}deg)`;
      element.style.transformOrigin = 'center center';
      updateCanvasItemControls(element);
    }

    function stopRotate() {
      if (isRotating) {
        isRotating = false;
        const productIndex = findCharmIndexByInstanceId(productData.id);
        if (productIndex !== -1) {
          selectedProducts[productIndex].rotation = productData.rotation;
        }
      }
      document.removeEventListener('mousemove', rotateHandler);
      document.removeEventListener('mouseup', stopRotate);
      document.removeEventListener('touchmove', rotateHandler);
      document.removeEventListener('touchend', stopRotate);
      document.removeEventListener('touchcancel', stopRotate);
    }
  }

  function makeDraggable(element, productData, canvasProductsContainer) {
    let isDragging = false;
    let draggingListenersActive = false;

    function startDrag(e) {
      const target = e.target;
      if (
        target.classList.contains('remove-btn') ||
        target.closest('.remove-btn') ||
        target.classList.contains('rotate-btn') ||
        target.closest('.rotate-btn') ||
        target.classList.contains('canvas-product-controls') ||
        target.closest('.canvas-product-controls') ||
        target.classList.contains('canvas-rotate-handle') ||
        target.closest('.canvas-rotate-handle') ||
        target.classList.contains('canvas-engraving-badge') ||
        target.closest('.canvas-engraving-badge') ||
        target.classList.contains('canvas-engraving-empty') ||
        target.closest('.canvas-engraving-empty')
      ) {
        return;
      }
      e.preventDefault();
      isDragging = true;
      hideCharmDragAlert();
      element.classList.add('dragging');
      element.classList.add('active');
      if (!draggingListenersActive) {
        draggingListenersActive = true;
        document.addEventListener('mousemove', onMouseMove);
        document.addEventListener('mouseup', onMouseUp);
        document.addEventListener('touchmove', onTouchMove, { passive: false });
        document.addEventListener('touchend', onTouchEnd);
        document.addEventListener('touchcancel', onTouchCancel);
      }
      const allItems = canvasProductsContainer ? canvasProductsContainer.querySelectorAll('.canvas-product-item') : [];
      allItems.forEach((i) => {
        if (i !== element) {
          i.classList.remove('active');
        }
      });
    }

    function moveDrag(clientX, clientY) {
      if (!isDragging) return;
      const rect = canvasContent.getBoundingClientRect();
      const currentRotation = productData.rotation || 0;
      const chainImg = getPcpChainImageEl();
      const cRect = chainImg && chainImg.getBoundingClientRect().width > 0.5 ? chainImg.getBoundingClientRect() : null;
      if (cRect) {
        const relX = ((clientX - cRect.left) / cRect.width) * 100;
        const relY = ((clientY - cRect.top) / cRect.height) * 100;
        const t = {
          x: Math.max(0, Math.min(100, relX)),
          y: Math.max(0, Math.min(100, relY)),
          relativeTo: PCP_POSITION_REL_CHAIN,
        };
        applyPcpContainerStyleForCharmItem(element, t, rect, cRect);
      } else {
        const currentX = clientX - rect.left;
        const currentY = clientY - rect.top;
        const percentX = (currentX / rect.width) * 100;
        const percentY = (currentY / rect.height) * 100;
        const clampedX = Math.max(0, Math.min(100, percentX));
        const clampedY = Math.max(0, Math.min(100, percentY));
        element.style.left = clampedX + '%';
        element.style.top = clampedY + '%';
      }
      element.style.transform = `translate(-50%, -50%) rotate(${currentRotation}deg)`;
      element.style.transformOrigin = 'center center';
      updateCanvasItemControls(element);
    }

    function endDrag() {
      if (!isDragging) return;
      isDragging = false;
      element.classList.remove('dragging');
      if (draggingListenersActive) {
        draggingListenersActive = false;
        document.removeEventListener('mousemove', onMouseMove);
        document.removeEventListener('mouseup', onMouseUp);
        document.removeEventListener('touchmove', onTouchMove);
        document.removeEventListener('touchend', onTouchEnd);
        document.removeEventListener('touchcancel', onTouchCancel);
      }
      const rect = canvasContent.getBoundingClientRect();
      const elementRect = element.getBoundingClientRect();
      const centerX = elementRect.left + elementRect.width / 2;
      const centerY = elementRect.top + elementRect.height / 2;
      const chainImg = getPcpChainImageEl();
      const cRect = chainImg && chainImg.getBoundingClientRect().width > 0.5 ? chainImg.getBoundingClientRect() : null;
      let position;
      if (cRect) {
        const relX = ((centerX - cRect.left) / cRect.width) * 100;
        const relY = ((centerY - cRect.top) / cRect.height) * 100;
        position = {
          x: Math.max(0, Math.min(100, relX)),
          y: Math.max(0, Math.min(100, relY)),
          relativeTo: PCP_POSITION_REL_CHAIN,
        };
      } else {
        const pX = ((centerX - rect.left) / rect.width) * 100;
        const pY = ((centerY - rect.top) / rect.height) * 100;
        position = {
          x: Math.max(0, Math.min(100, pX)),
          y: Math.max(0, Math.min(100, pY)),
        };
      }
      const productIndex = findCharmIndexByInstanceId(productData.id);
      if (productIndex !== -1) {
        selectedProducts[productIndex].position = position;
      }
      productData.position = position;
      updateCanvasItemControls(element);
    }

    element.addEventListener('mousedown', function (e) {
      startDrag(e);
    });

    function onMouseMove(e) {
      if (!isDragging) return;
      e.preventDefault();
      moveDrag(e.clientX, e.clientY);
    }

    function onMouseUp() {
      endDrag();
    }

    element.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) return;
      startDrag(e);
    }, { passive: false });

    function onTouchMove(e) {
      if (!isDragging || e.touches.length !== 1) return;
      e.preventDefault();
      moveDrag(e.touches[0].clientX, e.touches[0].clientY);
    }

    function onTouchEnd(e) {
      if (e.changedTouches.length) endDrag();
    }

    function onTouchCancel() {
      endDrag();
    }
  }

  function removeChainProduct(productId, variantId) {
    window._canvasProducts = window._canvasProducts.filter(
      (p) => !(p.productId === productId && p.variantId === variantId)
    );
    steps.forEach((step, idx) => {
      const selector = step.querySelector('.chain-selector');
      if (selector) {
        const cards = selector.querySelectorAll('.product-card');
        cards.forEach((card) => {
          const cardProductId = card.getAttribute('data-product-id');
          const cardVariantSelect = card.querySelector('.product-card-variant-select');
          const cardVariantId = cardVariantSelect ? cardVariantSelect.value : null;
          if (cardProductId === productId && cardVariantId === variantId) {
            card.classList.remove('selected');
          }
        });
      }
    });
    updateCanvasDisplay();
    const chainStepIndex =
      steps.findIndex((step) => {
        const selector = step.querySelector('.chain-selector');
        return selector !== null;
      }) + 1;
    if (chainStepIndex > 0) {
      selections[chainStepIndex] = '';
      updateStepNextButton(chainStepIndex);
      updateStepHeadersState();
    }
  }

  function removeProduct(index) {
    const productData = selectedProducts[index];
    if (productData) {
      selectedProducts.splice(index, 1);
      updateCanvasDisplay();
      updateSelections();
      updateStepNextButton(stepIndex);
      updateStepHeadersState();
      updateSelectorState();
      restoreStepSelectionHighlights(stepIndex);
    }
  }

  function addProduct(card, options) {
    if (card.classList.contains('product-card--sold-out') || card.getAttribute('data-available') === 'false') {
      showTransitionAlert(getPcpMessage('soldOutMessage'));
      return false;
    }
    const chainProductId = getSelectedChainProductId();
    if (chainProductId && !isCharmCompatibleWithChain(card, chainProductId)) {
      showTransitionAlert(getPcpMessage('incompatibleChainMessage'));
      return false;
    }
    const maxSelections = getMaxSelections();
    if (selectedProducts.length >= maxSelections) {
      return false;
    }

    const productId = card.getAttribute('data-product-id');
    const productImage = card.querySelector('.product-image img');
    const productTitle = card.querySelector('.product-title').textContent;

    if (!productImage) {
      return false;
    }

    const variantSelect = card.querySelector('.product-card-variant-select');
    const forcedVariantId = options && options.variantId ? String(options.variantId) : null;
    const forcedVariantImage = options && options.variantImage ? String(options.variantImage) : null;
    const forcedVariantPrice = options && options.variantPrice ? String(options.variantPrice) : null;
    const forcedVariantTitle = options && options.variantTitle ? String(options.variantTitle) : null;
    const forcedImageAlt =
      options && options.imageAlt != null && String(options.imageAlt).trim() !== ''
        ? String(options.imageAlt).trim()
        : '';
    let variantId = null;
    let imageSrc = null;
    let priceText = '';
    let variantTitle = forcedVariantTitle || '';
    let hasPersonalizerImage = card.getAttribute('data-product-personalizer-image') === 'true';

    if (forcedVariantId) {
      variantId = forcedVariantId;
    }

    function resolveCanvasImageFromVariantData(vd, selectedOption, cardEl) {
      if (vd && vd.image && String(vd.image).trim() !== '') {
        return getOriginalImageUrl(vd.image);
      }
      const fromOpt = selectedOption && selectedOption.getAttribute('data-canvas-image');
      if (fromOpt && String(fromOpt).trim() !== '') {
        return getOriginalImageUrl(fromOpt);
      }
      const fromCard = cardEl && cardEl.getAttribute('data-canvas-image');
      if (fromCard && String(fromCard).trim() !== '') {
        return getOriginalImageUrl(fromCard);
      }
      return null;
    }

    if (variantSelect && variantSelect.options && variantSelect.options.length > 0) {
      if (!variantId) {
        variantId = variantSelect.value;
        if (!variantId || variantId === '' || variantId === 'null') {
          for (let i = 0; i < variantSelect.options.length; i++) {
            const optionValue = variantSelect.options[i].value;
            if (optionValue && optionValue !== '' && optionValue !== 'null' && /^\d+$/.test(String(optionValue))) {
              variantId = optionValue;
              break;
            }
          }
        }
      }

      const selectedOption = getVariantSelectOption(variantSelect, variantId);
      const variantImage = selectedOption ? selectedOption.getAttribute('data-image') : null;
      const variantCanvasImage = selectedOption ? selectedOption.getAttribute('data-canvas-image') : null;
      const variantPrice = selectedOption ? selectedOption.getAttribute('data-price') : null;
      const variantHasPersonalizerImage = selectedOption
        ? selectedOption.getAttribute('data-personalizer-image') === 'true'
        : false;
      if (selectedOption && !variantTitle) {
        variantTitle = selectedOption.textContent.trim();
      }
      hasPersonalizerImage = variantHasPersonalizerImage;

      const vdSel = productId && variantId ? getVariantData(productId, variantId) : null;
      imageSrc = resolveCanvasImageFromVariantData(vdSel, selectedOption, card);
      if (!imageSrc && forcedVariantImage) {
        imageSrc = getOriginalImageUrl(forcedVariantImage);
      }
      if (!imageSrc && variantCanvasImage && variantCanvasImage !== '') {
        imageSrc = getOriginalImageUrl(variantCanvasImage);
      }
      if (!imageSrc && variantImage && variantImage !== '') {
        imageSrc = getOriginalImageUrl(variantImage);
      }
      if (!imageSrc) {
        imageSrc = getOriginalImageUrl(productImage.getAttribute('src'));
      }

      if (forcedVariantPrice) {
        priceText = forcedVariantPrice;
      } else if (variantPrice) {
        priceText = variantPrice;
      }
    } else {
      const productData = getProductData(productId);
      let resolvedVariant = null;
      if (productData && productData.variants && Array.isArray(productData.variants) && productData.variants.length > 0) {
        const dataVariantId = card.getAttribute('data-variant-id');
        if (dataVariantId && productData.variants.some((v) => v && String(v.id) === String(dataVariantId))) {
          resolvedVariant = productData.variants.find((v) => v && String(v.id) === String(dataVariantId));
        } else {
          resolvedVariant = productData.variants[0];
        }
        variantId = String(resolvedVariant.id);
      } else {
        const dataVariantId = card.getAttribute('data-variant-id');
        if (dataVariantId && dataVariantId !== '' && dataVariantId !== 'null' && /^\d+$/.test(String(dataVariantId).trim())) {
          variantId = String(dataVariantId).trim();
        }
      }
      if (resolvedVariant) {
        hasPersonalizerImage = !!resolvedVariant.hasPersonalizerImage;
      }
      const vdNoSel = productId && variantId ? getVariantData(productId, variantId) : null;
      imageSrc = resolveCanvasImageFromVariantData(vdNoSel, null, card);
      if (!imageSrc && resolvedVariant && resolvedVariant.image && String(resolvedVariant.image).trim() !== '') {
        imageSrc = getOriginalImageUrl(resolvedVariant.image);
      }
      if (!imageSrc && forcedVariantImage) {
        imageSrc = getOriginalImageUrl(forcedVariantImage);
      }
      if (!imageSrc) {
        imageSrc = getOriginalImageUrl(productImage.getAttribute('src'));
      }
    }

    if (!priceText) {
      const priceElement = card.querySelector('.product-price');
      if (priceElement) {
        priceText = priceElement.textContent.trim();
      }
    }

    let imageAlt = forcedImageAlt;
    if (!imageAlt && variantSelect && variantSelect.options && variantSelect.options.length > 0) {
      const selOpt = variantSelect.options[variantSelect.selectedIndex];
      const fromCanvasAlt = selOpt && selOpt.getAttribute('data-canvas-image-alt');
      if (fromCanvasAlt != null && String(fromCanvasAlt).trim() !== '') {
        imageAlt = String(fromCanvasAlt).trim();
      }
    }
    if (!imageAlt && productId && variantId) {
      const vd = getVariantData(productId, variantId);
      if (vd && vd.imageAlt != null && String(vd.imageAlt).trim() !== '') {
        imageAlt = String(vd.imageAlt).trim();
      }
    }
    if (!imageAlt && variantSelect && variantSelect.options && variantSelect.options.length > 0) {
      const selOpt = variantSelect.options[variantSelect.selectedIndex];
      const fromOpt = selOpt && selOpt.getAttribute('data-image-alt');
      if (fromOpt != null && String(fromOpt).trim() !== '') {
        imageAlt = String(fromOpt).trim();
      }
    }
    if (!imageAlt && card.getAttribute('data-canvas-image-alt')) {
      const a = card.getAttribute('data-canvas-image-alt');
      if (a != null && String(a).trim() !== '') {
        imageAlt = String(a).trim();
      }
    }
    if (!imageAlt && productImage) {
      const fromImg = productImage.getAttribute('alt');
      if (fromImg != null && String(fromImg).trim() !== '') {
        imageAlt = String(fromImg).trim();
      }
    }
    if (!imageAlt) {
      imageAlt = productTitle;
    }

    if (!variantId || variantId === '' || variantId === 'null') {
      showTransitionAlert(getPcpMessage('soldOutMessage'));
      return false;
    }

    if (!variantTitle && productId && variantId) {
      const resolvedVariantData = getVariantData(productId, variantId);
      if (resolvedVariantData && resolvedVariantData.title) {
        variantTitle = resolvedVariantData.title;
      }
    }

    const reconciledVariantId = resolveProductVariantId({
      productId: productId,
      variantId: variantId,
      variantTitle: variantTitle,
    });
    if (reconciledVariantId) {
      variantId = reconciledVariantId;
      if (!variantTitle) {
        const reconciledVariantData = getVariantData(productId, variantId);
        if (reconciledVariantData && reconciledVariantData.title) {
          variantTitle = reconciledVariantData.title;
        }
      }
    }

    const chainProducts = window._canvasProducts.filter((p) => p.type === 'chain');
    const charmCount = selectedProducts.length;
    const defaultPosition = getDefaultCharmPosition(chainProducts, charmCount);

    const productTags = (card.getAttribute('data-product-tags') || '').toLowerCase();
    const newProduct = {
      id: generateCharmInstanceId(),
      type: 'charm',
      productId: productId,
      variantId: variantId,
      variantTitle: variantTitle,
      imageSrc: imageSrc,
      hasPersonalizerImage: hasPersonalizerImage,
      imageAlt: imageAlt,
      title: productTitle,
      price: priceText,
      position: defaultPosition,
      rotation: 0,
      isEngravable: productTags.includes('engravable'),
    };
    if (productTags.includes('engravable')) {
      const cachedLimit = getEngravingMaxChars(productId);
      if (cachedLimit != null) newProduct.engravingMaxChars = cachedLimit;
      fetchZeptoEngravingLimit(productId, productTitle).then(function (limit) {
        if (limit == null) return;
        newProduct.engravingMaxChars = limit;
        if (newProduct.engravingText !== undefined) {
          newProduct.engravingText = normalizeEngravingText(newProduct.engravingText, limit);
          updateCanvasDisplay();
        }
      });
    }
    if (options && (options.engravingText !== undefined || options.engravingFont !== undefined)) {
      if (options.engravingMaxChars != null) {
        newProduct.engravingMaxChars = options.engravingMaxChars;
      }
      if (options.engravingText !== undefined) {
        newProduct.engravingText = normalizeEngravingText(
          options.engravingText,
          resolveEngravingMaxChars(productId, newProduct)
        );
      }
      if (options.engravingFont !== undefined) newProduct.engravingFont = String(options.engravingFont);
    }

    selectedProducts.push(newProduct);

    updateCanvasDisplay();
    updateSelections();
    updateStepNextButton(stepIndex);
    updateStepHeadersState();
    updateSelectorState();
    restoreStepSelectionHighlights(stepIndex);
    checkSelectionWarnings(productId);
    showCharmDragAlert();
    return true;
  }


  function updateSelections() {
    const selectionArray = selectedProducts.map((p) => {
      const base = p.variantId ? `${p.productId}|${p.variantId}` : String(p.productId);
      return p.id != null && p.id !== '' ? `${base}#${p.id}` : base;
    });
    selections[stepIndex] = selectionArray.join(',');
  }

  productCards.forEach((card) => {
    card.setAttribute('draggable', 'true');

    card.addEventListener('dragstart', function (e) {
      if (this.style.pointerEvents === 'none') {
        e.preventDefault();
        return false;
      }
      this.classList.add('dragging');
      e.dataTransfer.setData('text/plain', this.getAttribute('data-product-id'));
      e.dataTransfer.effectAllowed = 'move';
    });

    card.addEventListener('dragend', function (e) {
      this.classList.remove('dragging');
    });

  });

  if (canvasContent) {
    canvasContent.addEventListener('dragover', function (e) {
      e.preventDefault();
      e.dataTransfer.dropEffect = 'move';
      this.classList.add('drag-over');
    });

    canvasContent.addEventListener('dragleave', function (e) {
      this.classList.remove('drag-over');
    });

    canvasContent.addEventListener('drop', function (e) {
      e.preventDefault();
      this.classList.remove('drag-over');

      const productId = e.dataTransfer.getData('text/plain');
      const droppedCard = selector.querySelector(`[data-product-id="${productId}"]`);

      if (droppedCard && droppedCard.style.pointerEvents !== 'none') {
        const maxSelections = getMaxSelections();
        if (selectedProducts.length >= maxSelections) {
          return;
        }
        addProduct(droppedCard);
      }
    });
  }

  const variantSelects = selector.querySelectorAll('.product-card-variant-select');
  variantSelects.forEach((select) => {
    select.setAttribute('data-old-value', select.value);
    const card = select.closest('.product-card');
    if (card) {
      const initialOption = select.options[select.selectedIndex];
      if (initialOption) {
        card.dataset.selectedVariantId = select.value;
        card.dataset.selectedVariantTitle = initialOption.textContent.trim();
        const initialImage = initialOption.getAttribute('data-image') || '';
        const initialPrice = initialOption.getAttribute('data-price') || '';
        if (initialImage) {
          card.dataset.selectedVariantImage = initialImage;
        }
        if (initialPrice) {
          card.dataset.selectedVariantPrice = initialPrice;
        }
        const initialImageAlt = initialOption.getAttribute('data-image-alt');
        if (initialImageAlt != null && String(initialImageAlt).trim() !== '') {
          card.dataset.selectedVariantImageAlt = initialImageAlt.trim();
        }
        const productImageWrap = card.querySelector('.product-image');
        const productImageForAlt = card.querySelector('.product-image img');
        if (productImageWrap && productImageForAlt) {
          const altForClass =
            initialImageAlt != null && String(initialImageAlt).trim() !== ''
              ? String(initialImageAlt).trim()
              : productImageForAlt.getAttribute('alt');
          syncProductImageCanvasAltClass(productImageWrap, altForClass);
        }
      }
    }

    select.addEventListener('change', function (e) {
      e.stopPropagation();
      const card = this.closest('.product-card');
      if (card) {
        const selectedOption = this.options[this.selectedIndex];
        const price = selectedOption.getAttribute('data-price');
        const priceElement = card.querySelector('.product-price');
        if (priceElement && !priceElement.dataset.originalPrice) {
          priceElement.dataset.originalPrice = priceElement.textContent.trim();
        }
        if (priceElement && price) {
          priceElement.textContent = price;
        }

        const productId = card.getAttribute('data-product-id');
        const oldVariantId = this.getAttribute('data-old-value') || null;
        const newVariantId = this.value;
        this.setAttribute('data-old-value', newVariantId);
        card.dataset.selectedVariantId = newVariantId;
        const variantImageData = selectedOption.getAttribute('data-image');
        const variantPriceData = selectedOption.getAttribute('data-price');
        const variantTitleData = selectedOption.textContent.trim();
        if (variantImageData && variantImageData !== '') {
          card.dataset.selectedVariantImage = variantImageData;
        }
        if (variantPriceData && variantPriceData !== '') {
          card.dataset.selectedVariantPrice = variantPriceData;
        }
        if (variantTitleData) {
          card.dataset.selectedVariantTitle = variantTitleData;
        }
        const variantImageAltData = selectedOption.getAttribute('data-image-alt');
        if (variantImageAltData != null && String(variantImageAltData).trim() !== '') {
          card.dataset.selectedVariantImageAlt = variantImageAltData.trim();
        } else {
          delete card.dataset.selectedVariantImageAlt;
        }
        if (variantImageData && variantImageData !== '') {
          const productImage = card.querySelector('.product-image img');
          if (productImage) {
            if (!productImage.dataset.originalSrc) {
              productImage.dataset.originalSrc = productImage.getAttribute('src') || '';
            }
            productImage.setAttribute('src', variantImageData);
            productImage.setAttribute('srcset', '');
            if (variantImageAltData != null) {
              productImage.setAttribute('alt', String(variantImageAltData).trim());
            }
          }
        }
        const wrapForAltClass = card.querySelector('.product-image');
        const imgForAltClass = card.querySelector('.product-image img');
        if (wrapForAltClass && imgForAltClass) {
          const altForClass =
            variantImageAltData != null && String(variantImageAltData).trim() !== ''
              ? String(variantImageAltData).trim()
              : imgForAltClass.getAttribute('alt');
          syncProductImageCanvasAltClass(wrapForAltClass, altForClass);
        }
      }
    });
  });

  const cardSelectButtons = selector.querySelectorAll('.product-card-overlay-select-btn');
  cardSelectButtons.forEach((btn) => {
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      const card = this.closest('.product-card');
      if (card && card.style.pointerEvents !== 'none') {
        const maxSelections = getMaxSelections();
        if (selectedProducts.length >= maxSelections) {
          return;
        }
        const variantSelect = card.querySelector('.product-card-variant-select');
        let variantId = null;
        let variantImage = null;
        let variantPrice = null;
        let variantTitle = null;
        let variantImageAlt = null;
        if (variantSelect && variantSelect.options && variantSelect.options.length > 0) {
          variantId = variantSelect.value;
          const selectedOption = getVariantSelectOption(variantSelect, variantId);
          variantImage = selectedOption ? selectedOption.getAttribute('data-image') : null;
          variantPrice = selectedOption ? selectedOption.getAttribute('data-price') : null;
          variantTitle = selectedOption ? selectedOption.textContent.trim() : null;
          variantImageAlt = selectedOption ? selectedOption.getAttribute('data-image-alt') : null;
        } else if (card.dataset.selectedVariantId) {
          variantId = card.dataset.selectedVariantId;
          variantImage = card.dataset.selectedVariantImage || null;
          variantPrice = card.dataset.selectedVariantPrice || null;
          variantTitle = card.dataset.selectedVariantTitle || null;
          variantImageAlt = card.dataset.selectedVariantImageAlt || null;
        }
        const added = addProduct(card, {
          variantId: variantId,
          variantTitle: variantTitle || null,
          variantPrice: variantPrice,
        });
        if (added && variantSelect) {
          variantSelect.setAttribute('data-old-value', variantSelect.value);
        }
      }
    });
  });

  initEngravingFontDropdowns(selector);

  selector.querySelectorAll('.product-card-engraving-select-btn').forEach((btn) => {
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      e.preventDefault();
      const card = this.closest('.product-card');
      if (!card || card.style.pointerEvents === 'none') return;
      const maxSelections = getMaxSelections();
      if (selectedProducts.length >= maxSelections) return;
      const overlay = card.querySelector('.product-card-engraving-overlay');
      const textInput = overlay ? overlay.querySelector('.product-card-engraving-text-input') : null;
      const fontSelect = overlay ? overlay.querySelector('.product-card-engraving-font-select') : null;
      const fontDropdown = overlay ? overlay.querySelector('[data-engraving-font-dropdown]') : null;
      const productId = card.getAttribute('data-product-id');
      fetchZeptoEngravingLimit(productId, getCardProductTitle(card)).then(function (engravingMaxChars) {
        const limit =
          engravingMaxChars != null ? engravingMaxChars : resolveEngravingMaxChars(productId);
        const engravingText = normalizeEngravingText(textInput ? textInput.value : '', limit);
        const engravingFont = fontSelect ? fontSelect.value : '';
        addProduct(card, {
          engravingText: engravingText,
          engravingFont: engravingFont,
          engravingMaxChars: engravingMaxChars != null ? engravingMaxChars : limit,
        });
        card.classList.remove('engraving-overlay-open');
        if (textInput) textInput.value = '';
        resetEngravingFontDropdown(fontDropdown);
      });
    });
  });

  filterProducts();
  prefetchZeptoEngravingLimits(selector);

  function updateSelectorState() {
    const maxSelections = getMaxSelections();
    const cards = selector.querySelectorAll('.product-card');

    if (maxSelections === 0) {
      selector.style.opacity = '0.5';
      selector.style.pointerEvents = 'none';
      cards.forEach((card) => {
        card.setAttribute('draggable', 'false');
        card.style.opacity = '0.5';
        card.style.pointerEvents = 'none';
        card.style.cursor = 'not-allowed';
      });
      if (selectedProducts.length > 0) {
        selectedProducts = [];
        updateCanvasDisplay();
        updateSelections();
        updateStepNextButton(stepIndex);
        updateStepHeadersState();
      }
    } else if (selectedProducts.length >= maxSelections) {
      const tokens = selections[stepIndex] ? String(selections[stepIndex]).split(',').filter(Boolean) : [];
      cards.forEach((card) => {
        const isSelected = tokens.some((token) => cardMatchesSelectionToken(card, token));
        card.setAttribute('draggable', 'false');
        if (isSelected) {
          card.style.opacity = '1';
          card.style.pointerEvents = 'auto';
          card.style.cursor = 'grab';
        } else {
          card.style.opacity = '0.5';
          card.style.pointerEvents = 'none';
          card.style.cursor = 'not-allowed';
        }
      });
    } else {
      selector.style.opacity = '1';
      selector.style.pointerEvents = 'auto';
      cards.forEach((card) => {
        card.setAttribute('draggable', 'true');
        card.style.opacity = '1';
        card.style.pointerEvents = 'auto';
        card.style.cursor = 'grab';
      });
    }
    restoreStepSelectionHighlights(stepIndex);
  }

  selector._getMaxSelections = getMaxSelections;
  selector._updateCanvasDisplay = updateCanvasDisplay;
  selector._updateSelectorState = updateSelectorState;
  selector._selectedProducts = selectedProducts;
  selector._removeProduct = removeProduct;

  updateSelectorState();
});

const chainSelectors = section.querySelectorAll('.chain-selector');
chainSelectors.forEach((selector) => {
  const stepIndex = parseInt(selector.getAttribute('data-step'));
  const searchInput = selector.querySelector('.search-input');
  const chainFilters = selector.querySelectorAll('.category-filter[data-chain-filter]');
  const productGrid = selector.querySelector('.product-grid');
  const isDirectRender = productGrid && !productGrid.hasAttribute('data-chain-step');

  function filterDirectRenderProducts() {
    if (!isDirectRender || !productGrid) return;

    const productCards = productGrid.querySelectorAll('.product-card.chain-product');
    const activeFilter = selector.querySelector('.category-filter.active[data-chain-filter]');
    const selectedFilter = activeFilter ? activeFilter.getAttribute('data-chain-filter') : 'all';
    const searchTerm = searchInput ? searchInput.value.toLowerCase() : '';

    let visibleCount = 0;
    productCards.forEach((card) => {
      let shouldShow = true;
      const productTitle = card.querySelector('.product-title')
        ? card.querySelector('.product-title').textContent.toLowerCase()
        : '';
      const productTags = card.getAttribute('data-product-tags')
        ? card.getAttribute('data-product-tags').toLowerCase()
        : '';

      if (searchTerm && !productTitle.includes(searchTerm)) {
        shouldShow = false;
      }

      if (shouldShow && selectedFilter !== 'all') {
        const filterValue = selectedFilter.toLowerCase();
        const normalizedFilter = filterValue.replace(/[-_\s]/g, '');
        const tagsArray = productTags ? productTags.split(',').map((tag) => tag.trim().toLowerCase()) : [];

        let matchesFilter = false;

        if (productTitle.includes(filterValue)) {
          matchesFilter = true;
        } else {
          for (let i = 0; i < tagsArray.length; i++) {
            const tag = tagsArray[i];
            const normalizedTag = tag.replace(/[-_\s]/g, '');

            if (
              tag === filterValue ||
              tag.includes(filterValue) ||
              normalizedTag === normalizedFilter ||
              normalizedTag.includes(normalizedFilter)
            ) {
              matchesFilter = true;
              break;
            }
          }
        }

        if (!matchesFilter) {
          shouldShow = false;
        }
      }

      card.style.display = shouldShow ? 'flex' : 'none';
      if (shouldShow) visibleCount++;
    });

    productGrid.classList.toggle('is-empty', visibleCount === 0);
  }

  if (searchInput) {
    searchInput.addEventListener('input', function () {
      if (isDirectRender) {
        filterDirectRenderProducts();
      } else {
        filterChainProducts(stepIndex);
      }
    });
  }

  if (chainFilters && chainFilters.length > 0) {
    chainFilters.forEach((filter) => {
      filter.addEventListener('click', function () {
        chainFilters.forEach((f) => f.classList.remove('active'));
        this.classList.add('active');
        if (isDirectRender) {
          filterDirectRenderProducts();
        } else {
          filterChainProducts(stepIndex);
        }
      });
    });
  }

  if (isDirectRender) {
    filterDirectRenderProducts();
  }
});

for (let i = 1; i <= totalSteps; i++) {
  updateStepNextButton(i);
}

  section.querySelectorAll('.product-image.personalizer_image').forEach(function (wrap) {
    const img = wrap.querySelector('img');
    if (!img) return;
    syncProductImageCanvasAltClass(wrap, img.getAttribute('alt'));
  });

  /**
   * Viewport widths matching product-customizer-panel.css (1024): drag down on sheet handle or tap it
   * to expand the bracelet preview full-height; swipe or tap the bottom hint strip to reopen tools.
   */
  (function initPcpMobileCanvasFullscreenSheet() {
    const mq = window.matchMedia('(max-width: 1024px)');
    const wrapEl = section.querySelector('.product-customizer-wrapper');
    const sheetHandleEl = section.querySelector('.mobile-sheet-handle');
    const fullscreenHintEl = section.querySelector('.canvas-fullscreen-drag-hint');
    const fullscreenBtnEl = section.querySelector('.canvas-fullscreen-btn');
    if (!wrapEl || !sheetHandleEl || !fullscreenHintEl) return;

    const DRAG_THRESHOLD = 48;

    function setFullscreen(on) {
      const v = Boolean(on);
      wrapEl.classList.toggle('pcp-mobile-canvas-fullscreen', v);
      fullscreenHintEl.hidden = !v;
      sheetHandleEl.setAttribute('aria-expanded', String(!v));
      if (fullscreenBtnEl) {
        fullscreenBtnEl.setAttribute('aria-pressed', String(v));
        fullscreenBtnEl.setAttribute(
          'aria-label',
          v
            ? fullscreenBtnEl.dataset.labelExit || 'Exit fullscreen preview'
            : fullscreenBtnEl.dataset.labelEnter || 'Expand design preview to fullscreen'
        );
      }
    }

    function clearIfWideViewport() {
      if (!mq.matches) {
        wrapEl.classList.remove('pcp-mobile-canvas-fullscreen');
        fullscreenHintEl.hidden = true;
        sheetHandleEl.setAttribute('aria-expanded', 'true');
        if (fullscreenBtnEl) {
          fullscreenBtnEl.setAttribute('aria-pressed', 'false');
          fullscreenBtnEl.setAttribute(
            'aria-label',
            fullscreenBtnEl.dataset.labelEnter || 'Expand design preview to fullscreen'
          );
        }
      }
    }

    if (typeof mq.addEventListener === 'function') {
      mq.addEventListener('change', clearIfWideViewport);
    } else if (typeof mq.addListener === 'function') {
      mq.addListener(clearIfWideViewport);
    }

    function attachPanGestures(el, mode) {
      let activeId = null;
      let sy = 0;
      let sx = 0;
      let suppressClickFromDrag = false;

      el.addEventListener(
        'pointerdown',
        function (ev) {
          if (!mq.matches) return;
          if (ev.pointerType === 'mouse' && ev.button !== 0) return;
          activeId = ev.pointerId;
          sy = ev.clientY;
          sx = ev.clientX;
          suppressClickFromDrag = false;
          try {
            el.setPointerCapture(ev.pointerId);
          } catch (err) {
            /* ignore capture errors on older engines */
          }
        },
        { passive: true }
      );

      el.addEventListener(
        'pointermove',
        function (ev) {
          if (ev.pointerId !== activeId) return;
          if (
            Math.abs(ev.clientY - sy) > 12 ||
            Math.abs(ev.clientX - sx) > 18
          ) {
            suppressClickFromDrag = true;
          }
        },
        { passive: true }
      );

      function releaseGesture(ev, clientY, clientX) {
        if (ev.pointerId !== activeId) return;
        const dy = clientY - sy;
        const dx = clientX - sx;
        activeId = null;
        try {
          el.releasePointerCapture(ev.pointerId);
        } catch (err2) {
          /**/
        }

        if (!mq.matches) return;

        const strongVertical =
          Math.abs(dy) >= DRAG_THRESHOLD &&
          Math.abs(dy) >= Math.abs(dx) * 0.45;

        if (!strongVertical) return;

        if (mode === 'handle') {
          if (dy > 0) {
            setFullscreen(true);
          } else {
            setFullscreen(false);
          }
          return;
        }
        /* mode === hint — tap or swipe up exits fullscreen */
        if (!wrapEl.classList.contains('pcp-mobile-canvas-fullscreen')) return;
        if (strongVertical) {
          if (dy < 0) setFullscreen(false);
          return;
        }
        setFullscreen(false);
      }

      el.addEventListener('pointerup', function (ev) {
        releaseGesture(ev, ev.clientY, ev.clientX);
      });
      el.addEventListener('pointercancel', function (ev) {
        if (ev.pointerId !== activeId) return;
        activeId = null;
      });

      if (mode === 'handle') {
        el.addEventListener(
          'click',
          function () {
            if (!mq.matches) return;
            if (suppressClickFromDrag) return;
            if (!wrapEl.classList.contains('pcp-mobile-canvas-fullscreen')) {
              setFullscreen(true);
            }
          },
          true
        );
      }

      if (mode === 'hint') {
        el.addEventListener('click', function () {
          if (!mq.matches) return;
          if (wrapEl.classList.contains('pcp-mobile-canvas-fullscreen')) {
            setFullscreen(false);
          }
        });
      }
    }

    attachPanGestures(sheetHandleEl, 'handle');
    attachPanGestures(fullscreenHintEl, 'hint');
    fullscreenHintEl.hidden = true;

    if (fullscreenBtnEl) {
      fullscreenBtnEl.addEventListener('click', function () {
        if (!mq.matches) return;
        setFullscreen(!wrapEl.classList.contains('pcp-mobile-canvas-fullscreen'));
      });
    }
  })();

  updateStepHeadersState();
  updateStepCounter();
  loadHtml2Canvas().catch(function () {});

  function resolveEditProductCanvasImage(productId, variantId, fallback) {
    const fallbackSrc = fallback && fallback.imageSrc ? String(fallback.imageSrc) : '';
    const fallbackPersonalizer = !!(fallback && fallback.hasPersonalizerImage);

    if (fallbackSrc && fallbackPersonalizer) {
      return {
        imageSrc: getOriginalImageUrl(fallbackSrc),
        hasPersonalizerImage: true,
        imageAlt: fallback.imageAlt || '',
      };
    }

    const variantData = productId && variantId ? getVariantData(productId, variantId) : null;
    if (variantData && variantData.image && String(variantData.image).trim() !== '') {
      return {
        imageSrc: getOriginalImageUrl(variantData.image),
        hasPersonalizerImage: !!variantData.hasPersonalizerImage,
        imageAlt: variantData.imageAlt || '',
      };
    }

    const cards = section.querySelectorAll('[data-product-id="' + String(productId) + '"]');
    for (let i = 0; i < cards.length; i++) {
      const card = cards[i];
      const variantSelect = card.querySelector('.product-card-variant-select');
      if (variantSelect && variantId) {
        variantSelect.value = String(variantId);
      }
      const selectedOption = variantSelect
        ? variantSelect.querySelector('option[value="' + String(variantId) + '"]')
        : null;
      const optionCanvasImage = selectedOption
        ? selectedOption.getAttribute('data-canvas-image')
        : '';
      if (optionCanvasImage && String(optionCanvasImage).trim() !== '') {
        return {
          imageSrc: getOriginalImageUrl(optionCanvasImage),
          hasPersonalizerImage:
            selectedOption.getAttribute('data-personalizer-image') === 'true',
          imageAlt:
            selectedOption.getAttribute('data-canvas-image-alt') ||
            selectedOption.getAttribute('data-image-alt') ||
            '',
        };
      }

      const cardCanvasImage = card.getAttribute('data-canvas-image');
      if (cardCanvasImage && String(cardCanvasImage).trim() !== '') {
        return {
          imageSrc: getOriginalImageUrl(cardCanvasImage),
          hasPersonalizerImage: card.getAttribute('data-product-personalizer-image') === 'true',
          imageAlt: card.getAttribute('data-canvas-image-alt') || '',
        };
      }
    }

    return {
      imageSrc: fallbackSrc ? getOriginalImageUrl(fallbackSrc) : '',
      hasPersonalizerImage: fallbackPersonalizer,
      imageAlt: fallback && fallback.imageAlt ? fallback.imageAlt : '',
    };
  }

  function getCharmStepIndex() {
    const idx = steps.findIndex(function (step) {
      return isCharmStepElement(step);
    });
    return idx >= 0 ? idx + 1 : totalSteps;
  }

  function inferSelectionsFromChain(chain) {
    if (!chain || !chain.productId) return;

    const chainStepIndex = getChainStepIndex();
    if (chainStepIndex > 0) {
      selections[chainStepIndex] = chain.variantId
        ? String(chain.productId) + '|' + String(chain.variantId)
        : String(chain.productId);
    }

    const sizeStepIndex = steps.findIndex(isSizeStep) + 1;
    if (sizeStepIndex > 0 && chain.variantId) {
      selections[sizeStepIndex] = String(chain.variantId);
    }

    const metalStepIndex =
      steps.findIndex(function (step) {
        const title = step.querySelector('.step-title');
        return title && title.textContent.toLowerCase().includes('metal');
      }) + 1;
    if (metalStepIndex <= 0) return;

    const chainData = getChainCompatibilityData(chain.productId);
    const materialLabel = chainData && chainData.materialLabel ? String(chainData.materialLabel).trim() : '';
    if (!materialLabel) return;

    const metalStep = steps[metalStepIndex - 1];
    const buttons = metalStep ? metalStep.querySelectorAll('.option-button') : [];
    buttons.forEach(function (btn) {
      const value = btn.getAttribute('data-option-value') || btn.textContent.trim();
      if (value && value.toLowerCase() === materialLabel.toLowerCase()) {
        selections[metalStepIndex] = value;
      }
    });
  }

  function applySavedSelections(savedSelections) {
    if (!savedSelections || typeof savedSelections !== 'object') return;
    Object.keys(savedSelections).forEach(function (key) {
      selections[key] = savedSelections[key];
    });
  }

  function clearSizeStepUpdateCache() {
    steps.forEach(function (step, idx) {
      if (!isSizeStep(step)) return;
      const stepOptions = step.querySelector('.step-options');
      if (stepOptions) {
        delete stepOptions['_lastUpdate_' + (idx + 1)];
      }
    });
  }

  function finalizeCartEditRestore(chain) {
    if (chain && chain.productId) {
      clearSizeStepUpdateCache();
      updateChainLengthQuestion(chain.productId, chain.variantId);
    }

    setTimeout(function () {
      syncAllSelectionHighlights();
      for (let i = 1; i <= totalSteps; i++) {
        updateStepNextButton(i);
      }
      updateStepHeadersState();
      updateCharmCompatibility();

      const charmStepIndex = getCharmStepIndex();
      currentStep = charmStepIndex;
      expandStep(charmStepIndex);
      updateStepCounter();

      requestAnimationFrame(function () {
        layoutPcpCharms();
        setTimeout(layoutPcpCharms, 150);
        setTimeout(layoutPcpCharms, 500);
      });
    }, 120);
  }

  function restoreCartEditState() {
    const restoreRaw = sessionStorage.getItem('pcp-cart-edit-restore');
    sessionStorage.removeItem('pcp-cart-edit-restore');
    sessionStorage.removeItem('pcp-cart-edit');

    if (!restoreRaw) {
      sessionStorage.removeItem('pcp-cart-edit-keys');
      delete section.dataset.pcpCartEditRestored;
      return;
    }

    let payload;
    try {
      payload = JSON.parse(restoreRaw);
    } catch (e) {
      sessionStorage.removeItem('pcp-cart-edit-keys');
      delete section.dataset.pcpCartEditRestored;
      return;
    }

    if (!payload || !Array.isArray(payload.products) || !payload.products.length) {
      sessionStorage.removeItem('pcp-cart-edit-keys');
      delete section.dataset.pcpCartEditRestored;
      return;
    }

    section.dataset.pcpCartEditRestored = 'true';

    applySavedSelections(payload.selections);

    const chain = payload.products.find(function (product) {
      return product.type === 'chain';
    });

    if (!payload.selections && chain) {
      inferSelectionsFromChain(chain);
    }

    const chainStepIndex = getChainStepIndex();
    if (chainStepIndex > 0) {
      filterChainProducts(chainStepIndex);
    }

    if (chain) {
      restoreChainFromCartEdit(chain);
    }

    const charmsToRestore = payload.products.filter(function (product) {
      return product.type !== 'chain';
    });
    sortCharmsByCanvasPosition(charmsToRestore).forEach(function (product) {
      restoreCharmFromCartEdit(product);
    });

    finalizeCartEditRestore(chain);
  }

  function restoreChainFromCartEdit(chain) {
    const chainStepIndex = getChainStepIndex();
    if (chainStepIndex <= 0 || !chain || !chain.productId) return;

    const step = steps[chainStepIndex - 1];
    const selector = step ? step.querySelector('.chain-selector') : null;
    const cards = selector ? selector.querySelectorAll('.product-card') : [];
    let matchedCard = null;

    cards.forEach(function (card) {
      if (String(card.getAttribute('data-product-id')) === String(chain.productId)) {
        matchedCard = card;
      }
    });

    if (matchedCard) {
      const variantSelect = matchedCard.querySelector('.product-card-variant-select');
      if (variantSelect && chain.variantId) {
        variantSelect.value = chain.variantId;
      }
      cards.forEach(function (card) {
        card.classList.remove('selected');
      });
      matchedCard.classList.add('selected');
      const builtChain = buildChainProduct(matchedCard, chain.variantId);
      if (builtChain) {
        const chainImage = resolveEditProductCanvasImage(chain.productId, chain.variantId, chain);
        if (chainImage.imageSrc) builtChain.imageSrc = chainImage.imageSrc;
        if (chainImage.hasPersonalizerImage) builtChain.hasPersonalizerImage = true;
        if (chainImage.imageAlt) builtChain.imageAlt = chainImage.imageAlt;
        setChainProduct(builtChain);
      }
    } else {
      const chainImage = resolveEditProductCanvasImage(chain.productId, chain.variantId, chain);
      setChainProduct({
        productId: String(chain.productId),
        variantId: chain.variantId ? String(chain.variantId) : '',
        variantTitle: chain.variantTitle || '',
        imageSrc: chainImage.imageSrc || '',
        hasPersonalizerImage: chainImage.hasPersonalizerImage,
        imageAlt: chainImage.imageAlt || chain.title || '',
        title: chain.title || '',
        price: normalizeCustomizerProductPrice(chain.price, chain.productId, chain.variantId),
        type: 'chain',
        focalPoint: resolveChainFocalPoint(chain.productId, chain.variantId),
      });
    }

    selections[chainStepIndex] = chain.variantId
      ? String(chain.productId) + '|' + String(chain.variantId)
      : String(chain.productId);

    updateChainLengthQuestion(chain.productId, chain.variantId);
    restoreStepSelectionHighlights(chainStepIndex);
    updateStepNextButton(chainStepIndex);
  }

  function restoreCharmFromCartEdit(charm) {
    if (!charm || !charm.productId) return;

    const selectors = getCharmSelectors();
    let targetSelector = null;

    selectors.forEach(function (selector) {
      if (targetSelector) return;
      if (selector.querySelector('[data-product-id="' + String(charm.productId) + '"]')) {
        targetSelector = selector;
      }
    });

    if (!targetSelector && selectors.length) {
      targetSelector = selectors[0];
    }
    if (!targetSelector) return;

    const stepIndex = parseInt(targetSelector.getAttribute('data-step'), 10);
    if (Number.isNaN(stepIndex)) return;

    const selectedProducts = Array.isArray(targetSelector._selectedProducts)
      ? targetSelector._selectedProducts
      : [];
    const charmImage = resolveEditProductCanvasImage(charm.productId, charm.variantId, charm);
    const charmProduct = {
      id: charm.id || generateCharmInstanceId(),
      type: charm.type === 'charm' ? 'charm' : charm.type || 'charm',
      productId: String(charm.productId),
      variantId: charm.variantId ? String(charm.variantId) : '',
      variantTitle: charm.variantTitle || '',
      imageSrc: charmImage.imageSrc || '',
      hasPersonalizerImage: charmImage.hasPersonalizerImage,
      imageAlt: charmImage.imageAlt || charm.title || '',
      title: charm.title || '',
      price: normalizeCustomizerProductPrice(charm.price, charm.productId, charm.variantId),
      rotation: typeof charm.rotation === 'number' && !Number.isNaN(charm.rotation) ? charm.rotation : 0,
      isEngravable: Boolean(charm.engravingText),
    };

    if (
      charm.position &&
      typeof charm.position.x === 'number' &&
      !Number.isNaN(charm.position.x) &&
      typeof charm.position.y === 'number' &&
      !Number.isNaN(charm.position.y)
    ) {
      charmProduct.position = {
        x: charm.position.x,
        y: charm.position.y,
      };
      if (charm.position.relativeTo === 'chain') {
        charmProduct.position.relativeTo = 'chain';
      }
    }

    if (charm.engravingText) {
      charmProduct.engravingText = charm.engravingText;
    }
    if (charm.engravingFont) {
      charmProduct.engravingFont = charm.engravingFont;
    }

    selectedProducts.push(charmProduct);
    targetSelector._selectedProducts = selectedProducts;

    if (typeof targetSelector._updateCanvasDisplay === 'function') {
      targetSelector._updateCanvasDisplay();
    }

    const selectionArray = selectedProducts.map(function (product) {
      const base = product.variantId
        ? String(product.productId) + '|' + String(product.variantId)
        : String(product.productId);
      return product.id != null && product.id !== '' ? base + '#' + String(product.id) : base;
    });
    selections[stepIndex] = selectionArray.join(',');

    if (typeof targetSelector._updateSelectorState === 'function') {
      targetSelector._updateSelectorState();
    }

    restoreStepSelectionHighlights(stepIndex);
    updateStepNextButton(stepIndex);
  }

  restoreCartEditState();
})();
